import type { TranslationEntry } from '../lib/api'

export const LOCAL_TRANSLATIONS: TranslationEntry[] = [
  {
    "id": "EaDv31jlOlPOVDCYHI7C",
    "key": "100_satisfaction_guaranteed",
    "source": "100% satisfaction guaranteed",
    "translations": {
      "en": "100% satisfaction guaranteed",
      "fr": "100% satisfaction garantie",
      "de": "100 % Zufriedenheit garantiert",
      "es": "100% satisfacción garantizada",
      "uk": "100% задоволення гарантовано"
    },
    "createdAt": "2025-12-05T10:48:01.363Z",
    "updatedAt": "2025-12-05T10:48:01.363Z"
  },
  {
    "id": "Lx17uqoogL7HZVo4KLbm",
    "key": "10_21_business_days",
    "source": "10-21 business days",
    "createdAt": "2025-11-27T14:47:02.346Z",
    "translations": {
      "en": ": 10-21 business days",
      "fr": ": 10-21 jours ouvrables",
      "de": ": 10-21 Werktage",
      "es": ": 10-21 días hábiles",
      "uk": ": 10-21 робочий день"
    },
    "updatedAt": "2025-11-27T14:57:44.526Z"
  },
  {
    "id": "Dubg4mxiYzeqJvCkEnBZ",
    "key": "1_custom_artwork",
    "source": "1. Custom Artwork",
    "translations": {
      "en": "1. Custom Artwork",
      "fr": "1. Illustration personnalisée",
      "de": "1. Benutzerdefiniertes Kunstwerk",
      "es": "1. Ilustraciones personalizadas",
      "uk": "1. Індивідуальні замовлення"
    },
    "createdAt": "2025-12-04T12:46:46.186Z",
    "updatedAt": "2025-12-04T12:46:46.186Z"
  },
  {
    "id": "Oo2hqTqWwcYQoAILLvx5",
    "key": "2025_daria_chizh_art_studio_all_rights_reserved",
    "source": "© 2025 Daria Chizh Art Studio — All rights reserved.",
    "translations": {
      "en": "© 2025 Daria Chizh Art Studio — All rights reserved.",
      "fr": "© 2025 Studio d'art Daria Chizh — Tous droits réservés.",
      "de": "© 2025 Daria Chizh Art Studio — Alle Rechte vorbehalten.",
      "es": "© 2025 Daria Chizh Art Studio — Todos los derechos reservados.",
      "uk": "© 2025 Арт-студія Дарії Чиж — Усі права захищено."
    },
    "createdAt": "2025-11-27T11:28:33.566Z",
    "updatedAt": "2025-11-27T11:28:33.566Z"
  },
  {
    "id": "VLLPA0UUFAz624nwaUbz",
    "key": "24_48_hours",
    "source": "24-48 hours",
    "translations": {
      "en": ": 24-48 hours",
      "fr": ": 24-48 heures",
      "de": ": 24-48 Stunden",
      "es": ": 24-48 horas",
      "uk": ": 24-48 годин"
    },
    "createdAt": "2025-11-27T15:11:05.736Z",
    "updatedAt": "2025-11-27T15:11:05.736Z"
  },
  {
    "id": "MmKW7bFQnv8nlDKPZWhy",
    "key": "24_hours_monday_friday",
    "source": "24 hours Monday–Friday",
    "createdAt": "2025-11-29T13:54:14.775Z",
    "translations": {
      "en": "- 24 hours Monday–Friday",
      "fr": "- 24 heures du lundi au vendredi",
      "de": "- 24 Stunden Montag–Freitag",
      "es": "- 24 horas de lunes a viernes",
      "uk": "- 24 годин з понеділка по п'ятницю"
    },
    "updatedAt": "2025-11-29T13:57:34.363Z"
  },
  {
    "id": "2oUsyCqSD6eJ90WZZfxj",
    "key": "2_3_business_days",
    "source": "2-3 business days",
    "createdAt": "2025-11-27T14:48:14.827Z",
    "translations": {
      "en": ": 2-3 business days",
      "fr": ": 2-3 jours ouvrables",
      "de": ": 2-3 Werktage",
      "es": ": 2-3 días hábiles",
      "uk": ": 2-3 робочих днів"
    },
    "updatedAt": "2025-11-27T14:52:23.028Z"
  },
  {
    "id": "LGnWorbiux7ekArN7poO",
    "key": "2_3_weeks",
    "source": "2-3 weeks",
    "createdAt": "2025-11-27T14:48:55.523Z",
    "translations": {
      "en": ": 2-3 weeks",
      "fr": ": 2-3 semaines",
      "de": ": 2-3 Wochen",
      "es": ": 2-3 semanas",
      "uk": ": 2-3 тижні"
    },
    "updatedAt": "2025-11-27T14:54:18.517Z"
  },
  {
    "id": "fFHMafHHRl1893kFngn4",
    "key": "2_ready_made_paintings",
    "source": "2. Ready-Made Paintings",
    "translations": {
      "en": "2. Ready-Made Paintings",
      "fr": "2. Peintures prêtes à l'emploi",
      "de": "2. Fertige Gemälde",
      "es": "2. Pinturas confeccionadas",
      "uk": "2. Готові картини"
    },
    "createdAt": "2025-12-04T12:55:16.849Z",
    "updatedAt": "2025-12-04T12:55:16.849Z"
  },
  {
    "id": "sWSYcZgnuB7QAXOz8ukn",
    "key": "3_damaged_items",
    "source": "3. Damaged Items",
    "translations": {
      "en": "3. Damaged Items",
      "fr": "3. Articles endommagés",
      "de": "3. Beschädigte Gegenstände",
      "es": "3. Artículos dañados",
      "uk": "3. Пошкодження під час доставки"
    },
    "createdAt": "2025-12-04T13:00:24.273Z",
    "updatedAt": "2025-12-04T13:00:24.273Z"
  },
  {
    "id": "M1m8EJDV7deRubFfSsa3",
    "key": "48_hours",
    "createdAt": "2025-11-29T14:08:40.896Z",
    "translations": {
      "en": "48 hours",
      "fr": "48 heures",
      "de": "48 Stunden",
      "es": "48 horas",
      "uk": "48 годин"
    },
    "source": "48 hours",
    "updatedAt": "2025-11-29T14:11:59.380Z"
  },
  {
    "id": "0KVPPZWuJSFtGSmQBMg4",
    "key": "4_lost_packages",
    "source": "4. Lost Packages",
    "translations": {
      "en": "4. Lost Packages",
      "fr": "4. Colis perdus",
      "de": "4. Verlorene Pakete",
      "es": "4. Paquetes perdidos",
      "uk": "4. Втрата посилки"
    },
    "createdAt": "2025-12-04T13:13:29.064Z",
    "updatedAt": "2025-12-04T13:13:29.064Z"
  },
  {
    "id": "mdmsqYrdgoCJtaZAdOqW",
    "key": "5_12_business_days",
    "source": "5-12 business days",
    "createdAt": "2025-11-27T14:46:22.411Z",
    "translations": {
      "en": ": 5-12 business days",
      "fr": ": 5-12 jours ouvrables",
      "de": ": 5-12 Werktage",
      "es": ": 5-12 días hábiles",
      "uk": ": 5-12 робочих днів"
    },
    "updatedAt": "2025-11-27T14:57:12.950Z"
  },
  {
    "id": "JObFetLFvKKXCE2Hbysj",
    "key": "5_order_cancellation",
    "source": "5. Order Cancellation",
    "translations": {
      "en": "5. Order Cancellation",
      "fr": "5. Annulation de commande",
      "de": "5. Stornierung der Bestellung",
      "es": "5. Cancelación del pedido",
      "uk": "5. Скасування замовлення"
    },
    "createdAt": "2025-12-04T13:17:13.685Z",
    "updatedAt": "2025-12-04T13:17:13.685Z"
  },
  {
    "id": "LVodn1jAv1sfVcVaYiO2",
    "key": "6_contact",
    "source": "6. Contact",
    "translations": {
      "en": "6. Contact",
      "fr": "6. Contacter",
      "de": "6. Kontakt",
      "es": "6. Contacto",
      "uk": "6. Контакти"
    },
    "createdAt": "2025-12-04T13:19:14.980Z",
    "updatedAt": "2025-12-04T13:19:14.980Z"
  },
  {
    "id": "dchRk8E8FuUBxE11v6Qy",
    "key": "7_14_business_days",
    "source": "7-14 business days",
    "createdAt": "2025-11-27T14:45:50.359Z",
    "translations": {
      "en": ": 7-14 business days",
      "fr": ": 7-14 jours ouvrables",
      "de": ": 7-14 Werktage",
      "es": ": 7-14 días hábiles",
      "uk": ": 7-14 робочих днів"
    },
    "updatedAt": "2025-11-27T14:56:44.905Z"
  },
  {
    "id": "Mc8urcGynsYpMV4pjdAh",
    "key": "7_days",
    "source": "7 days",
    "translations": {
      "en": ": 7 days",
      "fr": ": 7 jours",
      "de": ": 7 Tage",
      "es": ": 7 dias",
      "uk": ": 7 днів"
    },
    "createdAt": "2025-11-27T15:07:17.921Z",
    "updatedAt": "2025-11-27T15:07:17.921Z"
  },
  {
    "id": "hnLi5RTnigpBjMsxavmP",
    "key": "a_breach_of_any_terms_will_result_in_immediate_termination_of_services",
    "source": "A breach of any Terms will result in immediate termination of services.",
    "translations": {
      "en": "A breach of any Terms will result in immediate termination of services.",
      "fr": "Une violation des Conditions entraînera la résiliation immédiate des services.",
      "de": "Ein Verstoß gegen die Bedingungen führt zur sofortigen Beendigung der Dienste.",
      "es": "El incumplimiento de cualquiera de los Términos resultará en la terminación inmediata de los servicios.",
      "uk": "Порушення будь-яких Умов призведе до негайного припинення надання послуг."
    },
    "createdAt": "2025-12-04T14:43:31.367Z",
    "updatedAt": "2025-12-04T14:43:31.367Z"
  },
  {
    "id": "rpefXDPhTOGSpKAoHYPA",
    "key": "a_custom_pet_portrait_is_a_deeply_personal_way_to_celebrate_your_best_friend_whe",
    "source": "A custom pet portrait is a deeply personal way to celebrate your best friend. Whether it’s a birthday gift, a wedding surprise, or a pet memorial portrait for a beloved companion, I hand-paint every detail using your photos—the fur texture, the eyes, and the expression that only you know.",
    "translations": {
      "en": "A custom pet portrait is a deeply personal way to celebrate your best friend. Whether it’s a birthday gift, a wedding surprise, or a pet memorial portrait for a beloved companion, I hand-paint every detail using your photos—the fur texture, the eyes, and the expression that only you know.",
      "fr": "Un portrait d'animal personnalisé est une façon profondément personnelle de célébrer votre meilleur ami. Qu'il s'agisse d'un cadeau d'anniversaire, d'une surprise de mariage ou d'un portrait commémoratif d'un animal de compagnie pour un compagnon bien-aimé, je peins à la main chaque détail en utilisant vos photos : la texture de la fourrure, les yeux et l'expression que vous seul connaissez.",
      "de": "Ein individuelles Haustierporträt ist eine zutiefst persönliche Art, Ihren besten Freund zu feiern. Ganz gleich, ob es sich um ein Geburtstagsgeschenk, eine Hochzeitsüberraschung oder ein Erinnerungsporträt eines Haustiers für einen geliebten Begleiter handelt, ich male jedes Detail von Hand anhand Ihrer Fotos – die Fellstruktur, die Augen und den Ausdruck, den nur Sie kennen.",
      "es": "Un retrato de mascota personalizado es una forma profundamente personal de celebrar a tu mejor amigo. Ya sea un regalo de cumpleaños, una sorpresa de boda o un retrato conmemorativo de una mascota para un querido compañero, pinto a mano cada detalle usando tus fotografías: la textura del pelaje, los ojos y la expresión que solo tú conoces.",
      "uk": "Індивідуальний портрет домашнього улюбленця – це глибоко особистий спосіб відзначити найкращого друга. Незалежно від того, чи це подарунок на день народження, сюрприз на весілля чи пам’ятний портрет домашнього улюбленця, я малюю кожну деталь на ваших фотографіях — текстуру хутра, очі та вираз обличчя, які знаєте лише ви."
    },
    "createdAt": "2025-11-29T14:18:53.523Z",
    "updatedAt": "2025-11-29T14:18:53.523Z"
  },
  {
    "id": "DBntO9tfiyQ3euHoie0F",
    "key": "a_meaningful_gift_for_any_pet_lover",
    "source": "A Meaningful Gift for Any Pet Lover",
    "createdAt": "2026-05-20T11:24:49.215Z",
    "translations": {
      "en": "A Meaningful Gift for Any Pet Lover",
      "fr": "Un cadeau qui touche au cœur pour tous les amoureux des animaux",
      "de": "Ein Geschenk, das wirklich bewegt",
      "es": "Un regalo que emociona a cualquier amante de las mascotas",
      "uk": "Зворушливий подарунок для кожного, хто любить тварин"
    },
    "updatedAt": "2026-05-20T11:49:49.383Z"
  },
  {
    "id": "kUWBZ4RWp6QRWehOjgt2",
    "key": "a_personalized_pet_portrait_is_the_gift_that_doesn_t_get_returned_it_works_for_b",
    "source": "A personalized pet portrait is the gift that doesn’t get returned. It works for birthdays, holidays, and housewarmings — and can also serve as a pet memorial portrait: a permanent, beautiful record of a companion you don’t want to forget.",
    "createdAt": "2026-05-20T11:25:14.927Z",
    "translations": {
      "en": "A personalized pet portrait is the gift that doesn’t get returned. It works for birthdays, holidays, and housewarmings — and can also serve as a pet memorial portrait: a permanent, beautiful record of a companion you don’t want to forget.",
      "fr": "Un portrait d'animal personnalisé, c'est le cadeau qu'on ne rapporte jamais en magasin. Il se prête aux anniversaires, aux fêtes et aux pendaisons de crémaillère — et peut aussi tenir lieu de portrait commémoratif : un témoignage beau et durable d'un compagnon que l'on ne veut pas oublier.",
      "de": "Ein personalisiertes Haustierporträt ist das Geschenk, das niemand zurückgibt. Es passt zu Geburtstagen, Feiertagen und Einzugsfeiern – und kann auch als liebevolles Gedenkporträt dienen: eine bleibende, schöne Erinnerung an einen Begleiter, den man nicht vergessen möchte.",
      "es": "Un retrato personalizado de mascota es el regalo que nadie devuelve. Funciona para cumpleaños, fechas especiales y celebraciones de nueva casa — y también puede ser un retrato en memoria de una mascota: un homenaje bello y permanente a un compañero que no quieres olvidar.",
      "uk": "Персональний портрет домашнього улюбленця — це подарунок, який не повертають. Він підходить для дня народження, свята чи новосілля, а ще може стати меморіальним портретом: постійним, красивим спогадом про улюбленця, про якого не хочеться забувати."
    },
    "updatedAt": "2026-05-20T11:49:49.708Z"
  },
  {
    "id": "uoUNzi8jUpIfsJKEDMLZ",
    "key": "a_quick_look_behind_the_scenes_as_i_prep_festive_references_varnish_drying_racks",
    "source": "A quick look behind the scenes as I prep festive references, varnish drying racks, and packaging for seasonal commissions.",
    "translations": {
      "en": "A quick look behind the scenes as I prep festive references, varnish drying racks, and packaging for seasonal commissions.",
      "fr": "Un rapide coup d'œil dans les coulisses pendant que je prépare des références festives, des séchoirs à vernis et des emballages pour les commandes saisonnières.",
      "de": "Ein kurzer Blick hinter die Kulissen, während ich festliche Referenzen, Lack-Trockengestelle und Verpackungen für saisonale Aufträge vorbereite.",
      "es": "Un vistazo rápido detrás de escena mientras preparo referencias festivas, rejillas para secar barnices y empaques para encargos de temporada.",
      "uk": "Невеличкий погляд за лаштунки — як я готую святкові пакунки та оформлюю сезонні замовлення."
    },
    "createdAt": "2025-11-27T10:53:41.528Z",
    "updatedAt": "2025-11-27T10:53:41.528Z"
  },
  {
    "id": "V1pKMkkC7mxj6lgvhObB",
    "key": "a_quiet_atmospheric_oil_painting_muted_tones_textured_brushstrokes_and_a_gentle_",
    "source": "A quiet, atmospheric oil painting. Muted tones, textured brushstrokes, and a gentle haze create a sense of calm and rural stillness — a moment suspended between land and sky. A piece that brings a sense of calm and open space into any room.",
    "translations": {
      "en": "A quiet, atmospheric oil painting. Muted tones, textured brushstrokes, and a gentle haze create a sense of calm and rural stillness — a moment suspended between land and sky. A piece that brings a sense of calm and open space into any room.",
      "fr": "Une peinture à l’huile calme et atmosphérique. Des tons sourds, des coups de pinceau texturés et une douce brume créent une sensation de calme et d’immobilité rurale – un moment suspendu entre terre et ciel. Une pièce qui apporte une sensation de calme et d'espace ouvert dans n'importe quelle pièce.",
      "de": "Ein ruhiges, stimmungsvolles Ölgemälde. Gedämpfte Töne, strukturierte Pinselstriche und ein sanfter Dunst erzeugen ein Gefühl von Ruhe und ländlicher Stille – einen Moment schwebend zwischen Land und Himmel. Ein Stück, das jedem Raum ein Gefühl von Ruhe und Offenheit verleiht.",
      "es": "Una pintura al óleo tranquila y atmosférica. Tonos apagados, pinceladas texturizadas y una suave neblina crean una sensación de calma y quietud rural: un momento suspendido entre la tierra y el cielo. Una pieza que aporta una sensación de calma y espacio abierto a cualquier estancia.",
      "uk": "Тиха, атмосферна картина маслом. Приглушені тони, фактурні мазки пензля та м’який серпанок створюють відчуття спокою та сільської тиші — мить, що лежить між землею та небом. Твір, який привносить у будь-яку кімнату відчуття спокою та відкритості."
    },
    "createdAt": "2026-01-23T17:02:44.056Z",
    "updatedAt": "2026-01-23T17:02:44.056Z"
  },
  {
    "id": "ccdo0C8s3vL8cVlGfIvN",
    "key": "a_repair_if_possible",
    "source": "a repair (if possible),",
    "translations": {
      "en": "a repair (if possible),",
      "fr": "une réparation (si possible),",
      "de": "eine Reparatur (falls möglich),",
      "es": "una reparación (si es posible),",
      "uk": "ремонт (якщо можливо),"
    },
    "createdAt": "2025-12-04T13:09:35.058Z",
    "updatedAt": "2025-12-04T13:09:35.058Z"
  },
  {
    "id": "VFzvV1r8frK3zkqJcZrE",
    "key": "a_replacement",
    "source": "a replacement,",
    "translations": {
      "en": "a replacement,",
      "fr": "un remplacement,",
      "de": "ein Ersatz,",
      "es": "un reemplazo,",
      "uk": "заміну"
    },
    "createdAt": "2025-12-04T13:04:58.946Z",
    "updatedAt": "2025-12-04T13:04:58.946Z"
  },
  {
    "id": "dB9258aoicl3HImL6duC",
    "key": "a_secluded_duck_house_floated_quietly_in_a_lily_choked_pond_the_morning_i_set_up",
    "source": "A secluded duck house floated quietly in a lily-choked pond the morning I set up my easel. Sunlight pierced the trees in soft shards, warming the weathered roof and setting the water aglow with broken greens and cobalt blues. I captured that hush in swift, textural strokes so you can feel the late-spring calm every time you glance at the canvas.",
    "translations": {
      "en": "A secluded duck house floated quietly in a lily-choked pond the morning I set up my easel. Sunlight pierced the trees in soft shards, warming the weathered roof and setting the water aglow with broken greens and cobalt blues. I captured that hush in swift, textural strokes so you can feel the late-spring calm every time you glance at the canvas.",
      "fr": "Une maison de canard isolée flottait tranquillement dans un étang rempli de nénuphars le matin où j'ai installé mon chevalet. La lumière du soleil transperçait les arbres en éclats mous, réchauffant le toit altéré et embrasant l'eau de verts brisés et de bleus cobalt. J'ai capturé ce silence avec des traits rapides et texturés afin que vous puissiez ressentir le calme de la fin du printemps à chaque fois que vous jetez un coup d'œil à la toile.",
      "de": "An dem Morgen, an dem ich meine Staffelei aufstellte, schwamm ein abgeschiedenes Entenhaus still in einem mit Seerosen übersäten Teich. Sonnenlicht durchdrang die Bäume in weichen Splittern, erwärmte das verwitterte Dach und ließ das Wasser in gebrochenem Grün und Kobaltblau erstrahlen. Ich habe diese Stille in schnellen, strukturierten Strichen eingefangen, damit Sie bei jedem Blick auf die Leinwand die Ruhe des Spätfrühlings spüren können.",
      "es": "La mañana en que instalé mi caballete, una aislada casa para patos flotaba silenciosamente en un estanque lleno de nenúfares. La luz del sol atravesaba los árboles en suaves fragmentos, calentando el desgastado techo y haciendo que el agua brillara con verdes rotos y azules cobalto. Capturé ese silencio con pinceladas rápidas y texturizadas para que puedas sentir la calma de finales de la primavera cada vez que miras el lienzo.",
      "uk": "Того ранку, коли я поставив мольберт, усамітнений качинний будиночок тихо плавав у залитому ліліями ставку. Сонячне світло пробивало дерева м’якими осколками, нагрівало вивітрюваний дах і запалювало воду розбитою зеленню та синім кобальтом. Я зафіксував цю тишу швидкими текстурними штрихами, щоб ви могли відчувати спокій пізньої весни щоразу, коли дивитесь на полотно."
    },
    "createdAt": "2026-01-23T16:57:18.265Z",
    "updatedAt": "2026-01-23T16:57:18.265Z"
  },
  {
    "id": "wFhfkO5x3IRVHh7P9t7F",
    "key": "a_small_painting_for_those_who_want_to_make_a_thoughtful_surprise_for_a_loved_on",
    "source": "A small painting for those who want to make a thoughtful surprise for a loved one, or for those who dream of having a dog but aren’t quite ready yet. Painted with expressive brushstrokes and gentle contrast in red and black tones.",
    "translations": {
      "en": "A small painting for those who want to make a thoughtful surprise for a loved one, or for those who dream of having a dog but aren’t quite ready yet. Painted with expressive brushstrokes and gentle contrast in red and black tones.",
      "fr": "Un petit tableau pour ceux qui veulent faire une surprise attentionnée à un être cher, ou pour ceux qui rêvent d’avoir un chien mais ne sont pas encore tout à fait prêts. Peint avec des coups de pinceau expressifs et un léger contraste dans des tons rouges et noirs.",
      "de": "Ein kleines Gemälde für diejenigen, die einem geliebten Menschen eine liebevolle Überraschung bereiten möchten oder für diejenigen, die davon träumen, einen Hund zu haben, aber noch nicht ganz so weit sind. Gemalt mit ausdrucksstarken Pinselstrichen und sanftem Kontrast in Rot- und Schwarztönen.",
      "es": "Un pequeño cuadro para aquellos que quieren hacer una sorpresa pensativa para un ser querido, o para aquellos que sueñan con tener un perro pero aún no están preparados. Pintado con pinceladas expresivas y suave contraste en tonos rojos y negros.",
      "uk": "Маленька картина для тих, хто хоче зробити продуманий сюрприз близькій людині, або для тих, хто мріє завести собаку, але ще не зовсім готовий. Написана виразними мазками та ніжним контрастом червоно-чорних тонів."
    },
    "createdAt": "2026-01-23T14:18:11.551Z",
    "updatedAt": "2026-01-23T14:18:11.551Z"
  },
  {
    "id": "L7dpl22GzknIn1mAKv63",
    "key": "a_sunset_that_feels_like_a_love_letter_to_the_end_of_day_lavender_clouds_drift_o",
    "source": "A sunset that feels like a love letter to the end of day. Lavender clouds drift over threads of molten gold and coral, each stroke humming with the warmth of shared secrets. Look closely and you can almost hear the hush that falls when the sky blushes and the world pauses—just long enough for two hearts to beat in unison. Hang it where you need a breath of quiet wonder, a reminder of hand-in-hand evenings, or the gentle promise that tomorrow’s dawn will keep every soft-spoken dream alive.",
    "translations": {
      "en": "A sunset that feels like a love letter to the end of day. Lavender clouds drift over threads of molten gold and coral, each stroke humming with the warmth of shared secrets. Look closely and you can almost hear the hush that falls when the sky blushes and the world pauses—just long enough for two hearts to beat in unison. Hang it where you need a breath of quiet wonder, a reminder of hand-in-hand evenings, or the gentle promise that tomorrow’s dawn will keep every soft-spoken dream alive.",
      "fr": "Un coucher de soleil qui ressemble à une lettre d’amour à la fin de la journée. Des nuages ​​​​de lavande dérivent sur des fils d'or en fusion et de corail, chaque trait bourdonnant de la chaleur des secrets partagés. Regardez attentivement et vous pouvez presque entendre le silence qui tombe lorsque le ciel rougit et que le monde s'arrête, juste assez longtemps pour que deux cœurs battent à l'unisson. Accrochez-le là où vous avez besoin d'un souffle d'émerveillement tranquille, d'un rappel des soirées main dans la main ou de la douce promesse que l'aube de demain gardera vivant chaque rêve à la voix douce.",
      "de": "Ein Sonnenuntergang, der sich wie ein Liebesbrief an das Ende des Tages anfühlt. Lavendelwolken treiben über Fäden aus geschmolzenem Gold und Korallen, jeder Strich summt mit der Wärme gemeinsamer Geheimnisse. Wenn Sie genau hinsehen, können Sie fast die Stille hören, die hereinbricht, wenn der Himmel errötet und die Welt innehält – gerade lange genug, damit zwei Herzen im Einklang schlagen. Hängen Sie es dort auf, wo Sie einen Hauch stiller Verwunderung, eine Erinnerung an Hand-in-Hand-Abende oder das sanfte Versprechen brauchen, dass die Morgendämmerung jeden leisen Traum am Leben erhält.",
      "es": "Un atardecer que parece una carta de amor al final del día. Nubes de color lavanda flotan sobre hilos de oro fundido y coral, y cada trazo vibra con la calidez de los secretos compartidos. Mire de cerca y casi podrá escuchar el silencio que cae cuando el cielo se sonroja y el mundo se detiene, el tiempo suficiente para que dos corazones latan al unísono. Cuélgalo donde necesites un soplo de tranquilidad, un recordatorio de las noches de la mano o la suave promesa de que el amanecer de mañana mantendrá vivo cada sueño de voz suave.",
      "uk": "Захід сонця, який нагадує любовний лист до кінця дня. Лавандові хмари пливуть над нитками розплавленого золота та коралів, кожен штрих наспівує теплом спільних таємниць. Придивіться уважніше, і ви майже почуєте тишу, яка настає, коли небо червоніє і світ зупиняється — якраз достатньо, щоб два серця забилися в унісон. Повісьте його там, де вам потрібен подих тихого дива, нагадування про вечори рука об руку або ніжне обіцяння, що завтрашній світанок збереже кожну тиху мрію."
    },
    "createdAt": "2026-01-23T16:58:02.035Z",
    "updatedAt": "2026-01-23T16:58:02.035Z"
  },
  {
    "id": "TLahEAPxE7obFQayhvP2",
    "key": "a_tracking_number_will_be_provided_for_all_shipments_please_allow",
    "source": "A tracking number will be provided for all shipments. Please allow",
    "translations": {
      "en": "A tracking number will be provided for all shipments. Please allow",
      "fr": "Un numéro de suivi sera fourni pour tous les envois. S'il vous plaît permettre",
      "de": "Für alle Sendungen wird eine Sendungsverfolgungsnummer bereitgestellt. Bitte erlauben",
      "es": "Se proporcionará un número de seguimiento para todos los envíos. Por favor permita",
      "uk": "Для всіх відправлень буде надано номер відстеження. Будь ласка, дозвольте"
    },
    "createdAt": "2025-11-27T15:10:40.802Z",
    "updatedAt": "2025-11-27T15:10:40.802Z"
  },
  {
    "id": "gz1PolveWDEMWVslIt8l",
    "key": "a_tracking_number_will_be_provided_for_all_shipments_please_allow_24_48_hours_fo",
    "source": "A tracking number will be provided for all shipments. Please allow 24-48 hours for the tracking information to update.",
    "translations": {
      "en": "A tracking number will be provided for all shipments. Please allow 24-48 hours for the tracking information to update.",
      "fr": "Un numéro de suivi sera fourni pour tous les envois. Veuillez prévoir 24 à 48 heures pour que les informations de suivi soient mises à jour.",
      "de": "Für alle Sendungen wird eine Sendungsverfolgungsnummer bereitgestellt. Es kann 24 bis 48 Stunden dauern, bis die Tracking-Informationen aktualisiert werden.",
      "es": "Se proporcionará un número de seguimiento para todos los envíos. Espere entre 24 y 48 horas para que se actualice la información de seguimiento.",
      "uk": "Для всіх відправлень буде надано номер відстеження. Будь ласка, зачекайте 24-48 годин, щоб інформація відстеження оновилася."
    },
    "createdAt": "2025-11-27T14:43:36.708Z",
    "updatedAt": "2025-11-27T14:43:36.708Z"
  },
  {
    "id": "5Yz2djdtDcHMe5FLh77m",
    "key": "a_warm_expressive_oil_painting_created_entirely_by_hand_not_ai_bold_textured_bru",
    "source": "A warm, expressive oil painting created entirely by hand — not AI. Bold, textured brushstrokes and rich colors capture the quiet, peaceful nature of a sleeping cat. This artwork brings a feeling of calm, comfort, and warmth into any space — a unique piece made to be felt, not just seen.",
    "translations": {
      "en": "A warm, expressive oil painting created entirely by hand — not AI. Bold, textured brushstrokes and rich colors capture the quiet, peaceful nature of a sleeping cat. This artwork brings a feeling of calm, comfort, and warmth into any space — a unique piece made to be felt, not just seen.",
      "fr": "Une peinture à l’huile chaleureuse et expressive créée entièrement à la main – et non par l’IA. Des coups de pinceau audacieux et texturés et des couleurs riches capturent la nature calme et paisible d'un chat endormi. Cette œuvre d'art apporte une sensation de calme, de confort et de chaleur dans n'importe quel espace : une pièce unique conçue pour être ressentie, pas seulement vue.",
      "de": "Ein warmes, ausdrucksstarkes Ölgemälde, das vollständig von Hand erstellt wurde – nicht von KI. Kräftige, strukturierte Pinselstriche und satte Farben fangen die ruhige, friedliche Natur einer schlafenden Katze ein. Dieses Kunstwerk bringt ein Gefühl von Ruhe, Komfort und Wärme in jeden Raum – ein einzigartiges Stück, das man fühlen und nicht nur sehen kann.",
      "es": "Una pintura al óleo cálida y expresiva creada totalmente a mano, no con IA. Pinceladas atrevidas y texturizadas y colores intensos capturan la naturaleza tranquila y pacífica de un gato dormido. Esta obra de arte aporta una sensación de calma, comodidad y calidez a cualquier espacio: una pieza única hecha para sentirla, no solo para verla.",
      "uk": "Тепла, виразна картина маслом, створена повністю вручну — без штучного інтелекту. Сміливі, фактурні мазки та насичені кольори передають тихий, спокійний характер сплячого кота. Цей витвір мистецтва приносить відчуття спокою, затишку та тепла в будь-який простір — унікальний твір, створений для того, щоб його відчували, а не просто бачили."
    },
    "createdAt": "2026-01-23T16:54:38.676Z",
    "updatedAt": "2026-01-23T16:54:38.676Z"
  },
  {
    "id": "5aOQ1x9mZ5XX37pzGSTJ",
    "key": "about",
    "translations": {
      "en": "About",
      "fr": "Sur moi",
      "de": "Über mich",
      "es": "Acerca de mí",
      "uk": "Про мене"
    },
    "createdAt": "2025-11-27T10:38:32.731Z",
    "source": "About",
    "updatedAt": "2025-11-27T13:40:03.615Z"
  },
  {
    "id": "nCgbbLEfctZufGat7JXD",
    "key": "access_know_what_personal_information_we_have_about_you",
    "source": "Access/know what personal information we have about you.",
    "translations": {
      "en": "Access/know what personal information we have about you.",
      "fr": "Accéder/connaître les informations personnelles que nous détenons à votre sujet.",
      "de": "Zugriff auf/wissen, welche persönlichen Informationen wir über Sie haben.",
      "es": "Acceder/conocer qué información personal tenemos sobre usted.",
      "uk": "доступ до вашої персональної інформації;"
    },
    "createdAt": "2025-12-05T09:46:53.347Z",
    "updatedAt": "2025-12-05T09:46:53.347Z"
  },
  {
    "id": "3zlcexInIAkhY0QyDpKU",
    "key": "account_information_username_password_security_questions_details",
    "source": "Account information: username, password, security questions/details.",
    "translations": {
      "en": "Account information: username, password, security questions/details.",
      "fr": "Informations sur le compte : nom d'utilisateur, mot de passe, questions/détails de sécurité.",
      "de": "Kontoinformationen: Benutzername, Passwort, Sicherheitsfragen/-details.",
      "es": "Información de la cuenta: nombre de usuario, contraseña, preguntas/detalles de seguridad.",
      "uk": "Інформація про обліковий запис: ім’я користувача, пароль, таємні запитання/подробиці."
    },
    "createdAt": "2025-12-05T09:30:21.361Z",
    "updatedAt": "2025-12-05T09:30:21.361Z"
  },
  {
    "id": "3O8iwMEzFUzmljwosptu",
    "key": "add_a_note_optional",
    "source": "Add a note (optional)",
    "translations": {
      "en": "Add a note (optional)",
      "fr": "Ajouter une note (facultatif)",
      "de": "Fügen Sie eine Notiz hinzu (optional)",
      "es": "Agregar una nota (opcional)",
      "uk": "Додайте примітку (необов'язково)"
    },
    "createdAt": "2025-11-27T14:14:47.785Z",
    "updatedAt": "2025-11-27T14:14:47.785Z"
  },
  {
    "id": "1CGzgMDN3qLNKz6cbTnt",
    "key": "add_photo_buy",
    "source": "Add Photo & Buy",
    "translations": {
      "en": "Add Photo & Buy",
      "fr": "Ajouter une photo et acheter",
      "de": "Foto hinzufügen und kaufen",
      "es": "Agregar foto y comprar",
      "uk": "Додати фото та замовити"
    },
    "createdAt": "2025-11-27T10:47:28.465Z",
    "updatedAt": "2025-11-27T10:47:28.465Z"
  },
  {
    "id": "zxzKKPbstXtMEqsdIefT",
    "key": "add_to_cart",
    "source": "Add to cart",
    "translations": {
      "en": "Add to cart",
      "fr": "Ajouter au panier",
      "de": "In den Warenkorb legen",
      "es": "Añadir a la cesta",
      "uk": "Додати в кошик"
    },
    "createdAt": "2025-11-27T10:46:51.542Z",
    "updatedAt": "2025-11-27T10:46:51.542Z"
  },
  {
    "id": "7Me9UTNT8LBpJuQo5SOG",
    "key": "address_ukraine_sumy_gayova_19_str_40004",
    "source": "Address: Ukraine, Sumy, Gayova 19 str, 40004",
    "translations": {
      "en": "Address: Ukraine, Sumy, Gayova 19 str, 40004",
      "fr": "Adresse : Ukraine, Soumy, rue Gayova 19, 40004",
      "de": "Adresse: Ukraine, Sumy, Gayova 19 str, 40004",
      "es": "Dirección: Ucrania, Sumy, calle Gayova 19, 40004",
      "uk": "Адреса: Україна, м. Суми, вул. Гайова 19, 40004"
    },
    "createdAt": "2025-12-04T15:00:09.420Z",
    "updatedAt": "2025-12-04T15:00:09.420Z"
  },
  {
    "id": "eSKOO2AnS00tMhAxSQyO",
    "key": "aftercare_adjustments",
    "source": "Aftercare & adjustments",
    "translations": {
      "en": "Aftercare & adjustments",
      "fr": "Suivi et ajustements",
      "de": "Nachsorge & Anpassungen",
      "es": "Cuidados posteriores y ajustes",
      "uk": "Супровід і коригування"
    },
    "createdAt": "2025-11-29T14:06:44.478Z",
    "updatedAt": "2025-11-29T14:06:44.478Z"
  },
  {
    "id": "1bGyn1tTde325dTE25Ge",
    "key": "afternoon_nap",
    "source": "Afternoon Nap",
    "translations": {
      "en": "Afternoon Nap",
      "fr": "Sieste",
      "de": "Mittagsschlaf",
      "es": "Siesta por la tarde",
      "uk": "Післяобідній сон"
    },
    "createdAt": "2025-11-27T11:25:28.716Z",
    "updatedAt": "2025-11-27T11:25:28.716Z"
  },
  {
    "id": "gAlLc8yAMlQLgDipne5r",
    "key": "all",
    "source": "All",
    "createdAt": "2025-12-05T10:18:24.437Z",
    "translations": {
      "en": "All",
      "fr": "Tous",
      "de": "Alle",
      "es": "Todo",
      "uk": "Все"
    },
    "updatedAt": "2025-12-05T15:14:43.027Z"
  },
  {
    "id": "ieEqjutolbs79BZpweTl",
    "key": "all_artworks",
    "source": "All Artworks",
    "translations": {
      "en": "All Artworks",
      "fr": "Toutes les oeuvres",
      "de": "Alle Kunstwerke",
      "es": "Todas las obras de arte",
      "uk": "Усі роботи"
    },
    "createdAt": "2025-11-27T11:42:28.825Z",
    "updatedAt": "2025-11-27T11:42:28.825Z"
  },
  {
    "id": "Vt696OYEV2aPi8EzuE7t",
    "key": "all_artworks_are_carefully_packaged_and_shipped_with_full_insurance_at_no_additi",
    "source": "All artworks are carefully packaged and shipped with full insurance at no additional cost.",
    "translations": {
      "en": "All artworks are carefully packaged and shipped with full insurance at no additional cost.",
      "fr": "Toutes les œuvres d’art sont soigneusement emballées et expédiées avec une assurance complète sans frais supplémentaires.",
      "de": "Alle Kunstwerke werden sorgfältig verpackt und ohne zusätzliche Kosten voll versichert versendet.",
      "es": "Todas las obras de arte se empaquetan cuidadosamente y se envían con seguro a todo riesgo sin costo adicional.",
      "uk": "Усі твори мистецтва ретельно упаковуються та відправляються з повним страхуванням без додаткових витрат."
    },
    "createdAt": "2025-11-27T15:16:42.544Z",
    "updatedAt": "2025-11-27T15:16:42.544Z"
  },
  {
    "id": "CVqTp4BkYvDaVTtlbDsN",
    "key": "all_orders_are_processed_within",
    "source": "All orders are processed within",
    "translations": {
      "en": "All orders are processed within",
      "fr": "Toutes les commandes sont traitées dans",
      "de": "Alle Bestellungen werden innerhalb bearbeitet",
      "es": "Todos los pedidos se procesan dentro de",
      "uk": "Всі замовлення обробляються протягом"
    },
    "createdAt": "2025-11-27T14:47:55.179Z",
    "updatedAt": "2025-11-27T14:50:49.252Z"
  },
  {
    "id": "ue5jt1vMBYZhPR2IOUFT",
    "key": "all_orders_are_processed_within_2_3_business_days_custom_orders_are_processed_wi",
    "source": "All orders are processed within 2-3 business days. Custom orders are processed within 2-3 weeks. If there are any unexpected delays, I'll notify you via email.",
    "translations": {
      "en": "All orders are processed within 2-3 business days. Custom orders are processed within 2-3 weeks. If there are any unexpected delays, I'll notify you via email.",
      "fr": "Toutes les commandes sont traitées dans un délai de 2 à 3 jours ouvrables. Les commandes personnalisées sont traitées dans un délai de 2 à 3 semaines. S'il y a des retards inattendus, je vous en informerai par e-mail.",
      "de": "Alle Bestellungen werden innerhalb von 2-3 Werktagen bearbeitet. Sonderanfertigungen werden innerhalb von 2-3 Wochen bearbeitet. Sollte es zu unerwarteten Verzögerungen kommen, benachrichtige ich Sie per E-Mail.",
      "es": "Todos los pedidos se procesan en un plazo de 2 a 3 días hábiles. Los pedidos personalizados se procesan en un plazo de 2 a 3 semanas. Si hay algún retraso inesperado, te lo notificaré por correo electrónico.",
      "uk": "Всі замовлення обробляються протягом 2-3 робочих днів. Індивідуальне замовлення виконується протягом 2-3 тижнів. Якщо виникнуть будь-які несподівані затримки, я повідомлю вас електронною поштою."
    },
    "createdAt": "2025-11-27T14:40:45.240Z",
    "updatedAt": "2025-11-27T14:40:45.240Z"
  },
  {
    "id": "xh1xWJ2MYbMIdKUJ5uxY",
    "key": "all_personalized_artworks_custom_portraits_paintings_created_from_your_photos_or",
    "source": "All personalized artworks (custom portraits, paintings created from your photos or based on your request) are non-returnable and non-refundable.",
    "translations": {
      "en": "All personalized artworks (custom portraits, paintings created from your photos or based on your request) are non-returnable and non-refundable.",
      "fr": "Toutes les œuvres d'art personnalisées (portraits personnalisés, peintures créées à partir de vos photos ou basées sur votre demande) ne sont ni retournables ni remboursables.",
      "de": "Alle personalisierten Kunstwerke (benutzerdefinierte Porträts, Gemälde, die anhand Ihrer Fotos oder auf Grundlage Ihrer Anfrage erstellt wurden) sind vom Umtausch und der Rückerstattung ausgeschlossen.",
      "es": "Todas las obras de arte personalizadas (retratos personalizados, pinturas creadas a partir de sus fotografías o según su solicitud) no son retornables ni reembolsables.",
      "uk": "Усі персоналізовані замовлення (портрети та картини, створені з ваших фотографій або на ваш запит) поверненню та відшкодуванню не підлягають."
    },
    "createdAt": "2025-12-04T13:36:14.411Z",
    "updatedAt": "2025-12-04T13:36:14.411Z"
  },
  {
    "id": "BNNBps2ybn9MabeI2Z8w",
    "key": "all_transactions_are_secure_and_encrypted",
    "source": "All transactions are secure and encrypted.",
    "translations": {
      "en": "All transactions are secure and encrypted.",
      "fr": "Toutes les transactions sont sécurisées et cryptées.",
      "de": "Alle Transaktionen sind sicher und verschlüsselt.",
      "es": "Todas las transacciones son seguras y encriptadas.",
      "uk": "Усі транзакції безпечні та зашифровані."
    },
    "createdAt": "2025-11-27T14:16:41.134Z",
    "updatedAt": "2025-11-27T14:16:41.134Z"
  },
  {
    "id": "Wn58681KLgRMfIt7STLR",
    "key": "alone_in_silence",
    "source": "Alone in silence",
    "translations": {
      "en": "Alone in silence",
      "fr": "Seul en silence",
      "de": "Allein in der Stille",
      "es": "solo en silencio",
      "uk": "Наодинці в тиші"
    },
    "createdAt": "2025-11-27T11:20:48.693Z",
    "updatedAt": "2025-11-27T11:20:48.693Z"
  },
  {
    "id": "gFJUGNrrGdlxba0kZ2IR",
    "key": "amazing_portrait_love_it_so_much_thank_you_daria",
    "createdAt": "2025-12-05T10:42:18.674Z",
    "source": "Amazing portrait 🥰 Love it so much! Thank you Daria!",
    "translations": {
      "en": "Amazing portrait 🥰 Love it so much! Thank you Daria!",
      "fr": "Portrait incroyable 🥰 J'adore tellement ! Merci Daria !",
      "de": "Tolles Porträt 🥰 Ich liebe es so sehr! Danke Daria!",
      "es": "Increíble retrato 🥰 ¡Me encanta! ¡Gracias Daria!",
      "uk": "Дивовижний портрет 🥰 Дуже подобається! Дякую, Дар'я!"
    },
    "updatedAt": "2025-12-05T14:58:53.868Z"
  },
  {
    "id": "dYswaklN24tlKuewZzxj",
    "key": "and_ill_do_my_best_to_assist_you",
    "source": ", and I'll do my best to assist you.",
    "translations": {
      "en": ", and I'll do my best to assist you.",
      "fr": ", et je ferai de mon mieux pour vous aider.",
      "de": ", und ich werde mein Bestes tun, um Ihnen zu helfen.",
      "es": "y haré todo lo posible para ayudarte.",
      "uk": ", і я докладу всіх зусиль, щоб допомогти вам."
    },
    "createdAt": "2025-11-27T15:10:13.093Z",
    "updatedAt": "2025-11-27T15:10:13.093Z"
  },
  {
    "id": "GlT068exyJHCfzpxl9Fd",
    "key": "and_often_sooner",
    "source": "and often sooner.",
    "translations": {
      "en": "and often sooner.",
      "fr": "et souvent plus tôt.",
      "de": "und oft schon früher.",
      "es": "y muchas veces antes.",
      "uk": "і часто раніше."
    },
    "createdAt": "2025-11-29T13:57:54.787Z",
    "updatedAt": "2025-11-29T13:57:54.787Z"
  },
  {
    "id": "ENoUdkuNobbJcKHbzJFr",
    "key": "and_often_sooner_urgent_shipping_questions_are_prioritized_the_same_day",
    "source": "and often sooner. Urgent shipping questions are prioritized the same day.",
    "translations": {
      "en": "and often sooner. Urgent shipping questions are prioritized the same day.",
      "fr": "et souvent plus tôt. Les questions urgentes d’expédition sont prioritaires le jour même.",
      "de": "und oft schon früher. Dringende Versandfragen werden noch am selben Tag priorisiert.",
      "es": "y muchas veces antes. Las consultas urgentes sobre envíos se priorizan el mismo día.",
      "uk": "і часто раніше. Термінові питання щодо доставки розглядаються того ж дня."
    },
    "createdAt": "2025-11-29T13:59:06.303Z",
    "updatedAt": "2025-11-29T13:59:06.303Z"
  },
  {
    "id": "YeLjermcmEib60hhDV0m",
    "key": "animals",
    "source": "Animals",
    "createdAt": "2025-11-27T11:20:26.143Z",
    "translations": {
      "en": "Animals",
      "fr": "Animaux",
      "de": "Tiere",
      "es": "Animales",
      "uk": "Тварини"
    },
    "updatedAt": "2025-11-27T15:32:53.458Z"
  },
  {
    "id": "a8j3Q0D17XirOqG7XZj4",
    "key": "anna",
    "source": "Anna",
    "translations": {
      "en": "Anna",
      "fr": "Anna",
      "de": "Anna",
      "es": "ana",
      "uk": "Анна"
    },
    "createdAt": "2025-12-05T15:09:55.367Z",
    "updatedAt": "2025-12-05T15:09:55.367Z"
  },
  {
    "id": "lnEJ5eBNDhv9JwFTRkgL",
    "key": "any_breed_any_species",
    "source": "Any Breed, Any Species",
    "createdAt": "2026-05-20T11:26:41.013Z",
    "translations": {
      "en": "Any Breed, Any Species",
      "fr": "Toutes races, toutes espèces",
      "de": "Jede Rasse, jede Tierart",
      "es": "Toda raza, toda especie",
      "uk": "Будь-яка порода, будь-який вид тварин"
    },
    "updatedAt": "2026-05-20T11:49:51.251Z"
  },
  {
    "id": "jFkD47rvqg54dhvRsNIW",
    "key": "april_fjord_light",
    "source": "April Fjord Light",
    "translations": {
      "en": "April Fjord Light",
      "fr": "Lumière du fjord d'avril",
      "de": "April Fjordlicht",
      "es": "Luz del fiordo de abril",
      "uk": "Квітень Фіорд"
    },
    "createdAt": "2025-11-27T11:20:04.973Z",
    "updatedAt": "2025-11-27T11:20:04.973Z"
  },
  {
    "id": "PG4DccZpQL7kx6oWmKMd",
    "key": "artwork_story_remember_the_old_wind_up_monkey_that_clashed_brass_cymbals_and_sta",
    "source": "Artwork Story Remember the old wind-up monkey that clashed brass cymbals and startled everyone with a loud “bang”? I’ve captured that mischievous moment in a whirl of blazing reds, electric yellows, and midnight blues. The wide-eyed monkey bursts out of a vortex of color, cymbals mid-crash, while a comic-book star shouts **“BANG”** in the corner. It’s playful, a little chaotic, and impossible to ignore—perfect for anyone who loves bold, conversation-starting art.",
    "translations": {
      "en": "Artwork Story Remember the old wind-up monkey that clashed brass cymbals and startled everyone with a loud “bang”? I’ve captured that mischievous moment in a whirl of blazing reds, electric yellows, and midnight blues. The wide-eyed monkey bursts out of a vortex of color, cymbals mid-crash, while a comic-book star shouts **“BANG”** in the corner. It’s playful, a little chaotic, and impossible to ignore—perfect for anyone who loves bold, conversation-starting art.",
      "fr": "Histoire de l'œuvre d'art Vous vous souvenez du vieux singe à manivelle qui faisait claquer des cymbales en laiton et surprenait tout le monde avec un « bang » fort ? J’ai capturé ce moment espiègle dans un tourbillon de rouges flamboyants, de jaunes électriques et de bleus nuit. Le singe aux yeux écarquillés surgit d'un vortex de couleurs, les cymbales en plein crash, tandis qu'une star de bande dessinée crie ** \"BANG\" ** dans le coin. C’est ludique, un peu chaotique et impossible à ignorer, parfait pour tous ceux qui aiment l’art audacieux et qui suscite la conversation.",
      "de": "Kunstwerk-Geschichte Erinnern Sie sich an den alten aufziehbaren Affen, der mit Messingbecken klirrte und alle mit einem lauten „Knall“ erschreckte? Ich habe diesen schelmischen Moment in einem Wirbel aus leuchtenden Rottönen, leuchtenden Gelbtönen und Mitternachtsblau festgehalten. Der Affe mit großen Augen bricht aus einem Farbwirbel hervor, die Becken krachen mitten im Krachen, während ein Comicstar in der Ecke **„BANG“** ruft. Es ist verspielt, ein wenig chaotisch und unmöglich zu ignorieren – perfekt für alle, die mutige Kunst lieben, die zu Gesprächen anregt.",
      "es": "Historia de la obra de arte ¿Recuerdas el viejo mono de cuerda que hacía chocar los platillos de latón y sorprendía a todos con un fuerte \"bang\"? Capturé ese momento travieso en un torbellino de rojos ardientes, amarillos eléctricos y azules medianoche. El mono con los ojos muy abiertos surge de un vórtice de color, los platillos están a punto de chocar, mientras una estrella de cómic grita **“BANG”** en la esquina. Es divertido, un poco caótico e imposible de ignorar; perfecto para cualquiera que ame el arte audaz que inicia una conversación.",
      "uk": "Історія ілюстрації. Пам’ятаєте стару заводну мавпу, яка стукала по мідних тарілках і налякала всіх гучним «хлопком»? Я зафіксував цей пустотливий момент у вирі палаючих червоних, електричних жовтих і опівнічно-синіх тонів. Мавпа з широко розплющеними очима виривається з кольорового вихору, тарілки тріщать, а зірка коміксів кричить у кутку **\"Бам\"**. Він грайливий, трохи хаотичний, і його неможливо ігнорувати — ідеально підходить для тих, хто любить сміливе мистецтво, яке починає розмову."
    },
    "createdAt": "2026-01-23T17:01:22.281Z",
    "updatedAt": "2026-01-23T17:01:22.281Z"
  },
  {
    "id": "VAHXODULRKxCbApldZcR",
    "key": "artworks",
    "source": "Artworks",
    "createdAt": "2025-11-27T10:32:41.501Z",
    "translations": {
      "en": "Artworks",
      "fr": "Oeuvres",
      "de": "Kunstwerke",
      "es": "Obras de arte",
      "uk": "Роботи"
    },
    "updatedAt": "2025-11-29T14:41:29.188Z"
  },
  {
    "id": "riTtgF7ElGD0A91dbTiW",
    "key": "artworks_collection",
    "source": "Artworks Collection",
    "translations": {
      "en": "Artworks Collection",
      "fr": "Collection d'œuvres d'art",
      "de": "Sammlung Kunstwerke",
      "es": "Colección de obras de arte",
      "uk": "Колекція робіт"
    },
    "createdAt": "2025-11-27T11:37:11.944Z",
    "updatedAt": "2025-11-27T11:37:11.944Z"
  },
  {
    "id": "h4c3n8CAdVNSBDRjSOxc",
    "key": "attach_clear_photos_of_your_pet_or_subject_you_can_upload_up_to_8_images_per_ord",
    "source": "Attach clear photos of your pet or subject. You can upload up to 8 images per order.",
    "translations": {
      "en": "Attach clear photos of your pet or subject. You can upload up to 8 images per order.",
      "fr": "Joignez des photos claires de votre animal ou sujet. Vous pouvez télécharger jusqu'à 8 images par commande.",
      "de": "Fügen Sie klare Fotos Ihres Haustieres oder Motivs bei. Sie können bis zu 8 Bilder pro Bestellung hochladen.",
      "es": "Adjunte fotografías claras de su mascota o sujeto. Puede cargar hasta 8 imágenes por pedido.",
      "uk": "Додайте чіткі фотографії свого улюбленця. Ви можете завантажити до 8 зображень на замовлення."
    },
    "createdAt": "2025-11-27T14:13:30.111Z",
    "updatedAt": "2025-11-27T14:13:30.111Z"
  },
  {
    "id": "tPL84Db01FSYhWQFChCh",
    "key": "australia_other_countries",
    "source": "Australia & Other Countries:",
    "createdAt": "2025-11-27T14:46:40.672Z",
    "translations": {
      "en": "Australia & Other Countries",
      "fr": "Australie et autres pays",
      "de": "Australien und andere Länder",
      "es": "Australia y otros países",
      "uk": "Австралія та інші країни"
    },
    "updatedAt": "2025-11-27T14:58:45.759Z"
  },
  {
    "id": "D1208eHox49xj1Wcb6ZX",
    "key": "australia_other_countries_10_21_business_days",
    "source": "Australia & Other Countries: 10-21 business days",
    "translations": {
      "en": "Australia & Other Countries: 10-21 business days",
      "fr": "Australie et autres pays : 10 à 21 jours ouvrables",
      "de": "Australien und andere Länder: 10–21 Werktage",
      "es": "Australia y otros países: 10-21 días hábiles",
      "uk": "Австралія та інші країни: 10-21 робочий день"
    },
    "createdAt": "2025-11-27T14:42:10.258Z",
    "updatedAt": "2025-11-27T14:42:10.258Z"
  },
  {
    "id": "S3ooM0zYhrP85FSYMUWB",
    "key": "authenticity_certificate_included",
    "source": "Authenticity certificate included",
    "translations": {
      "en": "Authenticity certificate included",
      "fr": "Certificat d'authenticité inclus",
      "de": "Echtheitszertifikat enthalten",
      "es": "Certificado de autenticidad incluido",
      "uk": "Сертифікат автентичності включений"
    },
    "createdAt": "2025-11-27T15:16:58.651Z",
    "updatedAt": "2025-11-27T15:16:58.651Z"
  },
  {
    "id": "GyBHljANSYh1jP4kZkNw",
    "key": "available",
    "source": "Available",
    "translations": {
      "en": "Available",
      "fr": "Disponible",
      "de": "Verfügbar",
      "es": "Disponible",
      "uk": "В наявності"
    },
    "createdAt": "2025-11-27T11:42:57.432Z",
    "updatedAt": "2025-11-27T11:42:57.432Z"
  },
  {
    "id": "oOrwcGUWDhMfg3dKcLpq",
    "key": "back_to_artworks",
    "source": "Back to Artworks",
    "translations": {
      "en": "Back to Artworks",
      "fr": "Retour aux oeuvres",
      "de": "Zurück zu Kunstwerken",
      "es": "Volver a Obras de Arte",
      "uk": "Повернутися до робіт"
    },
    "createdAt": "2025-11-27T15:13:59.881Z",
    "updatedAt": "2025-11-27T15:22:14.588Z"
  },
  {
    "id": "LMET5ZTQiX6NAXnAgdVj",
    "key": "back_to_site",
    "source": "Back to Site",
    "translations": {
      "en": "Back to Site",
      "fr": "Retour au site",
      "de": "Zurück zur Website",
      "es": "Volver al sitio",
      "uk": "Повернутися на сайт"
    },
    "createdAt": "2025-12-05T15:48:38.721Z",
    "updatedAt": "2025-12-05T15:48:38.721Z"
  },
  {
    "id": "orEUvYYmYd64zu0lNFil",
    "key": "bang",
    "source": "BANG!",
    "translations": {
      "en": "BANG!",
      "fr": "CLAQUER!",
      "de": "KNALL!",
      "es": "¡ESTALLIDO!",
      "uk": "БАМ!"
    },
    "createdAt": "2025-11-27T11:22:15.011Z",
    "updatedAt": "2025-11-27T11:22:15.011Z"
  },
  {
    "id": "MJYSdsl8NEzRmqGQ0mDq",
    "key": "before_your_hand_painted_pet_portrait_leaves_the_studio_you_receive_a_high_resol",
    "source": "Before your hand-painted pet portrait leaves the studio, you receive a high-resolution photo of the finished piece. If something needs adjusting, we fix it. Nothing is shipped until you're happy with what you see.",
    "createdAt": "2026-05-20T11:26:24.461Z",
    "translations": {
      "en": "Before your hand-painted pet portrait leaves the studio, you receive a high-resolution photo of the finished piece. If something needs adjusting, we fix it. Nothing is shipped until you're happy with what you see.",
      "fr": "Avant que votre portrait peint à la main ne quitte l'atelier, vous recevez une photo haute résolution de l'œuvre achevée. Si quelque chose mérite d'être ajusté, nous le corrigeons ensemble. Rien n'est expédié tant que vous n'êtes pas pleinement satisfait de ce que vous voyez.",
      "de": "Bevor Ihr handgemaltes Haustierporträt das Atelier verlässt, erhalten Sie ein hochauflösendes Foto des vollendeten Gemäldes. Sollte etwas angepasst werden, korrigieren wir es gemeinsam. Es wird nichts verschickt, bevor Sie rundum zufrieden sind mit dem, was Sie sehen.",
      "es": "Antes de que tu retrato de mascota pintado a mano salga del estudio, recibes una fotografía en alta resolución de la obra terminada. Si hay algo que ajustar, lo corregimos. No enviamos nada hasta que estés satisfecho con lo que ves.",
      "uk": "Перш ніж намальований вручну портрет вашого улюбленця покине студію, ви отримаєте фото завершеної роботи у високій роздільній здатності. Якщо щось потребує виправлення — ми виправимо. Нічого не відправляється, доки ви не задоволені тим, що бачите."
    },
    "updatedAt": "2026-05-20T11:49:51.014Z"
  },
  {
    "id": "5nvK04l1Qo5sKpx9USVW",
    "key": "berlin_germany",
    "source": "Berlin, Germany",
    "translations": {
      "en": "Berlin, Germany",
      "fr": "Berlin, Allemagne",
      "de": "Berlin, Deutschland",
      "es": "Berlín, Alemania",
      "uk": "Берлін, Німеччина"
    },
    "createdAt": "2025-12-05T15:05:57.406Z",
    "updatedAt": "2025-12-05T15:05:57.406Z"
  },
  {
    "id": "EOpXlbVvTqrAUZsNEJS1",
    "key": "best_for_commissions_order_updates_and_sharing_photos",
    "source": "— best for commissions, order updates, and sharing photos.",
    "translations": {
      "en": "— best for commissions, order updates, and sharing photos.",
      "fr": "– idéal pour les commissions, les mises à jour de commandes et le partage de photos.",
      "de": "– am besten für Aufträge, Auftragsaktualisierungen und das Teilen von Fotos.",
      "es": "- lo mejor para comisiones, actualizaciones de pedidos y compartir fotos.",
      "uk": "— найкраще для замовлень, оновлень замовлень і обміну фотографіями."
    },
    "createdAt": "2025-11-29T14:00:18.359Z",
    "updatedAt": "2025-11-29T14:00:18.359Z"
  },
  {
    "id": "fpbVnDj60reNv9EcHqcM",
    "key": "better_together",
    "source": "Better Together",
    "translations": {
      "en": "Better Together",
      "fr": "Mieux ensemble",
      "de": "Gemeinsam besser",
      "es": "Mejor juntos",
      "uk": "Разом краще"
    },
    "createdAt": "2026-02-03T15:23:16.896Z",
    "updatedAt": "2026-02-03T15:23:16.896Z"
  },
  {
    "id": "pg13CNoIeTNwPBX2CuDD",
    "key": "billing_and_account_information",
    "source": "Billing and Account Information",
    "translations": {
      "en": "Billing and Account Information",
      "fr": "Informations de facturation et de compte",
      "de": "Rechnungs- und Kontoinformationen",
      "es": "Información de facturación y cuenta",
      "uk": "Платіжна та облікова інформація"
    },
    "createdAt": "2025-12-04T14:49:46.607Z",
    "updatedAt": "2025-12-04T14:49:46.607Z"
  },
  {
    "id": "oayspnqxCPNL3J5FibmZ",
    "key": "blog",
    "source": "Blog",
    "translations": {
      "en": "Blog",
      "fr": "Blogue",
      "de": "Blog",
      "es": "Blog",
      "uk": "Блог"
    },
    "createdAt": "2025-11-27T10:35:55.258Z",
    "updatedAt": "2025-11-27T10:35:55.258Z"
  },
  {
    "id": "IjyrLAmQlrNsYrVznCai",
    "key": "board",
    "source": "Board",
    "translations": {
      "en": "Board",
      "fr": "Conseil",
      "de": "Planke",
      "es": "Junta",
      "uk": "Дошка"
    },
    "createdAt": "2025-11-27T10:45:54.225Z",
    "updatedAt": "2025-11-27T10:45:54.225Z"
  },
  {
    "id": "HDiIFG0OzLZNgWwFFhh2",
    "key": "breath_of_liberty",
    "source": "Breath of Liberty",
    "translations": {
      "en": "Breath of Liberty",
      "fr": "Souffle de Liberté",
      "de": "Atem der Freiheit",
      "es": "Aliento de libertad",
      "uk": "Дихання Свободи"
    },
    "createdAt": "2025-11-27T11:22:38.117Z",
    "updatedAt": "2025-11-27T11:22:38.117Z"
  },
  {
    "id": "KZt8sWBE5xS0GW2eMbe6",
    "key": "bring_a_burst_of_story_book_magic_to_your_walls_this_one_of_a_kind_painting_feat",
    "source": "Bring a burst of story-book magic to your walls. This one-of-a-kind painting features a grumpy-yet-lovable clown-gnome perched on mossy stone steps, pipe in hand, while blue tits and wildflowers swirl around him in a riot of colour. Lush brushwork, glowing highlights, and dreamy smoke ribbons create a scene that feels plucked from a modern fairy tale—equal parts whimsical and mischievous.",
    "translations": {
      "en": "Bring a burst of story-book magic to your walls. This one-of-a-kind painting features a grumpy-yet-lovable clown-gnome perched on mossy stone steps, pipe in hand, while blue tits and wildflowers swirl around him in a riot of colour. Lush brushwork, glowing highlights, and dreamy smoke ribbons create a scene that feels plucked from a modern fairy tale—equal parts whimsical and mischievous.",
      "fr": "Apportez un éclat de magie de livre d'histoires à vos murs. Cette peinture unique en son genre représente un gnome-clown grincheux mais adorable perché sur des marches de pierre moussues, une pipe à la main, tandis que des mésanges bleues et des fleurs sauvages tourbillonnent autour de lui dans une explosion de couleurs. Un pinceau luxuriant, des reflets brillants et des rubans de fumée de rêve créent une scène qui semble tirée d'un conte de fées moderne, à la fois fantaisiste et espiègle.",
      "de": "Bringen Sie einen Hauch von Märchenbuchmagie an Ihre Wände. Dieses einzigartige Gemälde zeigt einen mürrischen, aber liebenswerten Clown-Zwerg, der mit der Pfeife in der Hand auf moosigen Steinstufen sitzt, während Blaumeisen und Wildblumen in einem Farbenrausch um ihn herumwirbeln. Üppige Pinselführung, leuchtende Highlights und verträumte Rauchbänder schaffen eine Szene, die einem modernen Märchen entsprungen wirkt – zu gleichen Teilen skurril und schelmisch.",
      "es": "Lleva una explosión de magia de libro de cuentos a tus paredes. Esta pintura única presenta a un gnomo-payaso gruñón pero adorable encaramado sobre escalones de piedra cubiertos de musgo, pipa en mano, mientras los herrerillos azules y las flores silvestres se arremolinan a su alrededor en un derroche de color. Pinceladas exuberantes, reflejos brillantes y cintas de humo de ensueño crean una escena que parece sacada de un cuento de hadas moderno, a partes iguales caprichosa y traviesa.",
      "uk": "Принесіть у свої стіни сплеск магії книжкових історій. На цій унікальній картині зображений сварливий, але милий гном-клоун, який сидить на порослих мохом кам’яних сходах із трубкою в руці, а блакитні синиці та польові квіти кружляють навколо нього у буйстві кольорів. Яскравий малюнок, сяючі відблиски та мрійливі димові стрічки створюють сцену, яка ніби взята із сучасної казки — рівною мірою химерною та пустотливою."
    },
    "createdAt": "2026-01-23T16:59:24.163Z",
    "updatedAt": "2026-01-23T16:59:24.163Z"
  },
  {
    "id": "riFZSG0kT70bVe2UgPUb",
    "key": "bring_the_sound_of_the_waves_and_the_freedom_of_the_open_sky_into_your_home_with",
    "source": "Bring the sound of the waves and the freedom of the open sky into your home with this textured oil painting of seagulls at the beach. The artwork captures the playful motion of seagulls in flight and on the sand, painted with expressive brushstrokes that bring life and energy to the scene. Each piece is created with rich oil paints using a textured technique, giving the surface depth, vibrant color, and a sense of movement that feels almost alive.",
    "translations": {
      "en": "Bring the sound of the waves and the freedom of the open sky into your home with this textured oil painting of seagulls at the beach. The artwork captures the playful motion of seagulls in flight and on the sand, painted with expressive brushstrokes that bring life and energy to the scene. Each piece is created with rich oil paints using a textured technique, giving the surface depth, vibrant color, and a sense of movement that feels almost alive.",
      "fr": "Apportez le bruit des vagues et la liberté du ciel ouvert dans votre maison avec cette peinture à l'huile texturée représentant des mouettes à la plage. L’œuvre capture le mouvement ludique des mouettes en vol et sur le sable, peint avec des coups de pinceau expressifs qui apportent vie et énergie à la scène. Chaque pièce est créée avec de riches peintures à l'huile en utilisant une technique texturée, donnant à la surface une profondeur, des couleurs vibrantes et une sensation de mouvement presque vivante.",
      "de": "Bringen Sie das Rauschen der Wellen und die Freiheit des offenen Himmels mit diesem strukturierten Ölgemälde von Möwen am Strand in Ihr Zuhause. Das Kunstwerk fängt die spielerische Bewegung von Möwen im Flug und auf dem Sand ein, gemalt mit ausdrucksstarken Pinselstrichen, die der Szene Leben und Energie verleihen. Jedes Stück ist mit satten Ölfarben in einer Strukturtechnik gestaltet, die der Oberfläche Tiefe, lebendige Farben und ein Gefühl von Bewegung verleiht, die sich fast lebendig anfühlt.",
      "es": "Lleva el sonido de las olas y la libertad del cielo abierto a tu hogar con este óleo texturizado de gaviotas en la playa. La obra de arte captura el movimiento juguetón de las gaviotas en vuelo y sobre la arena, pintada con pinceladas expresivas que aportan vida y energía a la escena. Cada pieza está creada con ricas pinturas al óleo utilizando una técnica de textura, dando a la superficie profundidad, colores vibrantes y una sensación de movimiento que se siente casi viva.",
      "uk": "Принесіть шум хвиль і свободу відкритого неба у свій дім за допомогою цієї фактурної олійної картини із зображенням чайок на пляжі. Твір мистецтва відображає грайливі рухи чайок у польоті та на піску, намальовані виразними мазками, які привносять життя та енергію в сцену. Кожен виріб створено насиченими олійними фарбами з використанням текстурної техніки, що надає поверхні глибини, яскравих кольорів і відчуття руху, яке виглядає майже живим."
    },
    "createdAt": "2026-01-23T16:56:38.940Z",
    "updatedAt": "2026-01-23T16:56:38.940Z"
  },
  {
    "id": "9zPJhvNHjP9i8IZp5dcB",
    "key": "browse_all",
    "source": "Browse all",
    "translations": {
      "en": "Browse all",
      "fr": "Parcourir tout",
      "de": "Alle durchsuchen",
      "es": "Explorar todo",
      "uk": "Переглянути все"
    },
    "createdAt": "2025-11-29T13:38:41.168Z",
    "updatedAt": "2025-11-29T13:38:41.168Z"
  },
  {
    "id": "yyUAfqqEjnhk5xjQzvyL",
    "key": "browse_my_original_oil_paintings_one_of_a_kind_hand_painted_artworks_with_rich_t",
    "source": "Browse my original oil paintings—one-of-a-kind, hand-painted artworks with rich texture and timeless color, available with worldwide shipping.",
    "createdAt": "2025-11-27T11:40:44.231Z",
    "translations": {
      "en": "Browse my original oil paintings—one-of-a-kind, hand-painted artworks with rich texture and timeless color, available with worldwide shipping.",
      "fr": "Parcourez mes peintures à l'huile originales : des œuvres d'art uniques en leur genre, peintes à la main avec une texture riche et des couleurs intemporelles, disponibles avec expédition dans le monde entier.",
      "de": "Stöbern Sie in meinen Original-Ölgemälden – einzigartige, handgemalte Kunstwerke mit reichhaltiger Textur und zeitlosen Farben, erhältlich mit weltweitem Versand.",
      "es": "Explore mis pinturas al óleo originales: obras de arte únicas, pintadas a mano, con textura rica y colores atemporales, disponibles con envío a todo el mundo.",
      "uk": "Перегляньте мої оригінальні картини маслом — унікальні твори мистецтва, написані вручну, із багатою текстурою та стійкими кольорами, доступні з доставкою по всьому світу."
    },
    "updatedAt": "2025-12-05T10:16:53.046Z"
  },
  {
    "id": "rkbh0Ng2vBrCkmDLzLXb",
    "key": "buy_now",
    "source": "Buy now",
    "translations": {
      "en": "Buy now",
      "fr": "Acheter maintenant",
      "de": "Jetzt kaufen",
      "es": "Comprar ahora",
      "uk": "Купити"
    },
    "createdAt": "2025-11-27T15:14:27.447Z",
    "updatedAt": "2025-11-27T15:14:27.447Z"
  },
  {
    "id": "kGFRaLK7shu7xwDzNDct",
    "key": "buyers_are_responsible_for_any_customs_and_import_taxes_that_may_apply_im_not_re",
    "source": "Buyers are responsible for any customs and import taxes that may apply. I'm not responsible for delays due to customs.",
    "translations": {
      "en": "Buyers are responsible for any customs and import taxes that may apply. I'm not responsible for delays due to customs.",
      "fr": "Les acheteurs sont responsables de toutes les taxes douanières et d'importation qui peuvent s'appliquer. Je ne suis pas responsable des retards dus aux douanes.",
      "de": "Der Käufer ist für eventuell anfallende Zoll- und Einfuhrsteuern verantwortlich. Ich bin nicht verantwortlich für Verzögerungen aufgrund des Zolls.",
      "es": "Los compradores son responsables de los impuestos aduaneros y de importación que puedan aplicarse. No soy responsable de retrasos debido a la aduana.",
      "uk": "Покупці несуть відповідальність за будь-які митні та імпортні податки, які можуть застосовуватися. Я не несу відповідальності за затримки через митницю."
    },
    "createdAt": "2025-11-27T14:42:55.855Z",
    "updatedAt": "2025-11-27T14:42:55.855Z"
  },
  {
    "id": "QkO7MjOYgzjB1VYxVVub",
    "key": "by_agreeing_to_these_terms_you_represent_that_you_are_at_least_the_age_of_majori",
    "source": "By agreeing to these Terms, you represent that you are at least the age of majority in your place of residence. You may not use our products for any illegal or unauthorized purpose, nor may you violate any laws in your jurisdiction. You must not transmit any worms, viruses, or destructive code.",
    "translations": {
      "en": "By agreeing to these Terms, you represent that you are at least the age of majority in your place of residence. You may not use our products for any illegal or unauthorized purpose, nor may you violate any laws in your jurisdiction. You must not transmit any worms, viruses, or destructive code.",
      "fr": "En acceptant ces Conditions, vous déclarez que vous avez au moins l'âge de la majorité dans votre lieu de résidence. Vous ne pouvez pas utiliser nos produits à des fins illégales ou non autorisées, ni enfreindre les lois de votre juridiction. Vous ne devez transmettre aucun vers, virus ou code destructeur.",
      "de": "Indem Sie diesen Bedingungen zustimmen, erklären Sie, dass Sie an Ihrem Wohnort mindestens die Volljährigkeit erreicht haben. Sie dürfen unsere Produkte nicht für illegale oder unbefugte Zwecke verwenden und auch nicht gegen Gesetze in Ihrem Rechtsgebiet verstoßen. Sie dürfen keine Würmer, Viren oder zerstörerischen Code übertragen.",
      "es": "Al aceptar estos Términos, usted declara que tiene al menos la mayoría de edad en su lugar de residencia. No puede utilizar nuestros productos para ningún propósito ilegal o no autorizado, ni puede violar ninguna ley en su jurisdicción. No debe transmitir ningún gusano, virus o código destructivo.",
      "uk": "Погоджуючись із цими Умовами, ви підтверджуєте, що вам виповнилося повноліття відповідно до законодавства вашої країни проживання.\nВи не можете використовувати нашу продукцію з незаконною або несанкціонованою метою, а також порушувати будь-які закони вашої юрисдикції.\nВам заборонено передавати будь-які віруси або шкідливий код."
    },
    "createdAt": "2025-12-04T14:42:59.783Z",
    "updatedAt": "2025-12-04T14:42:59.783Z"
  },
  {
    "id": "oJPRKTQPvtQKNVfIvUKY",
    "key": "certain_products_or_services_may_be_available_exclusively_online_and_may_have_li",
    "source": "Certain products or services may be available exclusively online and may have limited quantities. Descriptions and pricing may change at our sole discretion.",
    "translations": {
      "en": "Certain products or services may be available exclusively online and may have limited quantities. Descriptions and pricing may change at our sole discretion.",
      "fr": "Certains produits ou services peuvent être disponibles exclusivement en ligne et avoir des quantités limitées. Les descriptions et les prix peuvent changer à notre seule discrétion.",
      "de": "Bestimmte Produkte oder Dienstleistungen sind möglicherweise ausschließlich online verfügbar und in begrenzten Mengen verfügbar. Beschreibungen und Preise können nach unserem alleinigen Ermessen geändert werden.",
      "es": "Ciertos productos o servicios pueden estar disponibles exclusivamente en línea y pueden tener cantidades limitadas. Las descripciones y los precios pueden cambiar a nuestro exclusivo criterio.",
      "uk": "Деякі товари або послуги можуть бути доступні виключно онлайн та мати обмежену кількість. Опис та ціни можуть змінюватися на наш власний розсуд."
    },
    "createdAt": "2025-12-04T14:49:02.488Z",
    "updatedAt": "2025-12-04T14:49:02.488Z"
  },
  {
    "id": "GklLUzeWllu77RWE7B9a",
    "key": "checkout",
    "source": "Checkout",
    "translations": {
      "en": "Checkout",
      "fr": "Vérifier",
      "de": "Kasse",
      "es": "Verificar",
      "uk": "Оплата"
    },
    "createdAt": "2025-11-27T14:09:02.091Z",
    "updatedAt": "2025-11-27T14:09:02.091Z"
  },
  {
    "id": "9P0eLC6FJvLGLamvYh6O",
    "key": "children_s_data",
    "source": "Children’s data",
    "translations": {
      "en": "Children’s data",
      "fr": "Données sur les enfants",
      "de": "Kinderdaten",
      "es": "Datos de los niños",
      "uk": "Дані дітей"
    },
    "createdAt": "2025-12-05T09:44:03.715Z",
    "updatedAt": "2025-12-05T09:44:03.715Z"
  },
  {
    "id": "SDul18pUXb4ddHZkFLHJ",
    "key": "choose_oil_for_rich_layered_realism_the_kind_of_depth_you_see_in_gallery_portrai",
    "source": "Choose oil for rich, layered realism — the kind of depth you see in gallery portraits. Choose ink for bold linework and expressive character. Both are painted on archival materials with lightfast pigments, so the colors stay true for decades, not seasons.",
    "createdAt": "2026-05-20T11:24:29.810Z",
    "translations": {
      "en": "Choose oil for rich, layered realism — the kind of depth you see in gallery portraits. Choose ink for bold linework and expressive character. Both are painted on archival materials with lightfast pigments, so the colors stay true for decades, not seasons.",
      "fr": "Optez pour l'huile si vous cherchez un réalisme riche et profond — la même intensité que dans les portraits de grande galerie. Choisissez l'encre pour un trait affirmé et un caractère expressif. Les deux techniques sont exécutées sur des supports de conservation, avec des pigments grand teint, pour que les couleurs restent éclatantes des décennies durant.",
      "de": "Wählen Sie Öl für satten, vielschichtigen Realismus – jene Tiefe, die man aus klassischen Galerieporträts kennt. Wählen Sie Tusche für ausdrucksstarke Linien und lebendigen Charakter. Beide Techniken werden auf säurefreien Trägern mit lichtechten Pigmenten ausgeführt, sodass die Farben nicht nur eine Saison, sondern Jahrzehnte lang leuchten.",
      "es": "Elige el óleo para un realismo rico y con profundidad, el tipo de luz que ves en los retratos de galería. Elige la tinta para un trazo expresivo y lleno de carácter. Ambas técnicas se ejecutan sobre materiales de conservación artística con pigmentos resistentes a la luz, para que los colores se mantengan fieles durante décadas.",
      "uk": "Оберіть олію — і отримаєте насичений, багатошаровий реалізм із тією глибиною, яку бачиш на галерейних портретах. Оберіть туш — і матимете виразну лінію та сильний характер. Обидва медіуми наносяться на архівні основи зі світлостійкими пігментами, тому кольори залишаються незмінними десятиліттями, а не сезонами."
    },
    "updatedAt": "2026-05-20T11:49:49.092Z"
  },
  {
    "id": "N8GWqmSg4YJlG9KVBGaR",
    "key": "choose_the_style_that_tells_your_pet_s_story_upload_your_photos_select_a_size_an",
    "source": "Choose the style that tells your pet’s story. Upload your photos, select a size, and order with ease — each hand-painted portrait is made with love and ships worldwide.",
    "translations": {
      "en": "Choose the style that tells your pet’s story. Upload your photos, select a size, and order with ease — each hand-painted portrait is made with love and ships worldwide.",
      "fr": "Choisissez le style qui raconte l’histoire de votre animal. Téléchargez vos photos, sélectionnez une taille et commandez facilement : chaque portrait peint à la main est réalisé avec amour et expédié dans le monde entier.",
      "de": "Wählen Sie den Stil, der die Geschichte Ihres Haustiers erzählt. Laden Sie Ihre Fotos hoch, wählen Sie eine Größe aus und bestellen Sie ganz einfach – jedes handgemalte Porträt wird mit Liebe hergestellt und weltweit versendet.",
      "es": "Elige el estilo que cuente la historia de tu mascota. Sube tus fotos, selecciona un tamaño y haz tu pedido con facilidad: cada retrato pintado a mano se hace con amor y se envía a todo el mundo.",
      "uk": "Виберіть стиль, який розповідає історію вашого вихованця. Завантажуйте свої фотографії, вибирайте розмір і з легкістю замовляйте — кожен намальований вручну портрет створено з любов’ю та доставляється по всьому світу."
    },
    "createdAt": "2025-11-27T12:37:19.484Z",
    "updatedAt": "2025-11-27T12:37:19.484Z"
  },
  {
    "id": "HWgRdF8VljUFNI175hVK",
    "key": "circle",
    "source": "Circle",
    "translations": {
      "en": "Circle",
      "fr": "Cercle",
      "de": "Kreis",
      "es": "Círculo",
      "uk": "Коло"
    },
    "createdAt": "2025-11-27T10:45:40.460Z",
    "updatedAt": "2025-11-27T10:45:40.460Z"
  },
  {
    "id": "C2ESYAXJcDoS4gvdAOHe",
    "key": "clear_cart",
    "source": "Clear cart",
    "translations": {
      "en": "Clear cart",
      "fr": "Vider le panier",
      "de": "Warenkorb leeren",
      "es": "Limpiar carrito",
      "uk": "Очистити кошик"
    },
    "createdAt": "2025-11-27T14:09:15.972Z",
    "updatedAt": "2025-11-27T14:09:15.972Z"
  },
  {
    "id": "ps107sbjILdcBsARWyIR",
    "key": "clear_details_help_me_serve_you_faster_when_reaching_out_please_include",
    "source": "Clear details help me serve you faster. When reaching out, please include:",
    "translations": {
      "en": "Clear details help me serve you faster. When reaching out, please include:",
      "fr": "Des détails clairs m'aident à vous servir plus rapidement. Lorsque vous nous contactez, veuillez inclure :",
      "de": "Klare Details helfen mir, Sie schneller zu bedienen. Bitte geben Sie bei Ihrer Kontaktaufnahme Folgendes an:",
      "es": "Los detalles claros me ayudan a servirle más rápido. Cuando se comunique, incluya:",
      "uk": "Чіткі деталі допомагають мені обслуговувати вас швидше. Під час звернення додайте:"
    },
    "createdAt": "2025-11-29T14:12:57.646Z",
    "updatedAt": "2025-11-29T14:12:57.646Z"
  },
  {
    "id": "gtfhADvuh9azzP6el4F8",
    "key": "clear_steps_for_returns_refunds_and_cancellations_for_both_custom_artwork_and_re",
    "source": "Clear steps for returns, refunds, and cancellations for both custom artwork and ready-made pieces.",
    "translations": {
      "en": "Clear steps for returns, refunds, and cancellations for both custom artwork and ready-made pieces.",
      "fr": "Des étapes claires pour les retours, les remboursements et les annulations des œuvres d'art personnalisées et des pièces prêtes à l'emploi.",
      "de": "Klare Schritte für Rücksendungen, Rückerstattungen und Stornierungen sowohl für individuelle Kunstwerke als auch für fertige Stücke.",
      "es": "Pasos claros para devoluciones, reembolsos y cancelaciones tanto de obras de arte personalizadas como de piezas ya hechas.",
      "uk": "Чіткі кроки щодо повернень, відшкодувань і скасувань як для творів мистецтва під замовлення, так і для готових виробів."
    },
    "createdAt": "2025-12-04T12:45:37.802Z",
    "updatedAt": "2025-12-04T12:45:37.802Z"
  },
  {
    "id": "o0lBoyMXUfXd4ZYUDnMz",
    "key": "click_to_upload",
    "source": "Click to upload",
    "translations": {
      "en": "Click to upload",
      "fr": "Cliquez pour télécharger",
      "de": "Klicken Sie zum Hochladen",
      "es": "Haga clic para cargar",
      "uk": "Натисніть, щоб завантажити"
    },
    "createdAt": "2025-11-27T15:24:56.378Z",
    "updatedAt": "2025-11-27T15:24:56.378Z"
  },
  {
    "id": "4eMWufThPQ0jagnXaBPs",
    "key": "click_to_upload_or_drag_drop",
    "source": "Click to upload or drag & drop",
    "translations": {
      "en": "Click to upload or drag & drop",
      "fr": "Cliquez pour télécharger ou glisser-déposer",
      "de": "Klicken Sie zum Hochladen oder per Drag & Drop",
      "es": "Haga clic para cargar o arrastre y suelte",
      "uk": "Натисніть, щоб завантажити, або перетягніть"
    },
    "createdAt": "2025-11-27T14:14:05.487Z",
    "updatedAt": "2025-11-27T14:14:05.487Z"
  },
  {
    "id": "R1Im8ewBZQiTYLtLvhfN",
    "key": "commission",
    "source": "Commission",
    "translations": {
      "en": "Commission",
      "fr": "Commission",
      "de": "Kommission",
      "es": "Comisión",
      "uk": "Замовити"
    },
    "createdAt": "2025-11-27T10:33:56.429Z",
    "updatedAt": "2025-11-27T10:33:56.429Z"
  },
  {
    "id": "GJuMPslCFX4az8xLJWOx",
    "key": "commission_a_bespoke_hand_painted_pet_portrait_each_piece_includes_a_collaborati",
    "source": "Commission a bespoke hand-painted pet portrait. Each piece includes a collaborative brief, is created from your photos with professional oil paints, and finished with protective varnish.",
    "translations": {
      "en": "Commission a bespoke hand-painted pet portrait. Each piece includes a collaborative brief, is created from your photos with professional oil paints, and finished with protective varnish.",
      "fr": "Commandez un portrait d'animal de compagnie sur mesure, peint à la main. Chaque pièce comprend un brief collaboratif, est créée à partir de vos photos avec des peintures à l'huile professionnelles et finie avec un vernis protecteur.",
      "de": "Geben Sie ein maßgeschneidertes handgemaltes Haustierporträt in Auftrag. Jedes Stück enthält ein gemeinsames Briefing, wird aus Ihren Fotos mit professionellen Ölfarben erstellt und mit Schutzlack versehen.",
      "es": "Encarga un retrato de mascota pintado a mano a medida. Cada pieza incluye un resumen colaborativo, se crea a partir de sus fotografías con pinturas al óleo profesionales y se termina con barniz protector.",
      "uk": "Замовте портрет домашньої тварини, розписаний вручну. Кожен твір містить спільне резюме, створене з ваших фотографій професійними олійними фарбами та покрите захисним лаком."
    },
    "createdAt": "2025-11-27T10:43:01.859Z",
    "updatedAt": "2025-11-27T10:43:01.859Z"
  },
  {
    "id": "dq6P2LT4apg6Lfbjgaib",
    "key": "commission_a_bespoke_ink_pet_portrait_each_piece_is_hand_drawn_from_your_photos_",
    "source": "Commission a bespoke ink pet portrait. Each piece is hand-drawn from your photos and can be finished as a postcard or framed artwork.",
    "translations": {
      "en": "Commission a bespoke ink pet portrait. Each piece is hand-drawn from your photos and can be finished as a postcard or framed artwork.",
      "fr": "Commandez un portrait d'animal à l'encre sur mesure. Chaque pièce est dessinée à la main à partir de vos photos et peut être finie sous forme de carte postale ou d’œuvre d’art encadrée.",
      "de": "Geben Sie ein maßgeschneidertes Haustierporträt mit Tinte in Auftrag. Jedes Stück wird anhand Ihrer Fotos handgezeichnet und kann als Postkarte oder gerahmtes Kunstwerk fertiggestellt werden.",
      "es": "Encarga un retrato de mascota en tinta personalizado. Cada pieza está dibujada a mano a partir de sus fotografías y se puede terminar como una postal o una obra de arte enmarcada.",
      "uk": "Замовте портрет домашньої тварини чорнилом на замовлення. Кожна частина намальована вручну з ваших фотографій і може бути оформлена як листівка або в рамці."
    },
    "createdAt": "2025-11-27T10:42:20.762Z",
    "updatedAt": "2025-11-27T10:42:20.762Z"
  },
  {
    "id": "53RMCtIo1IEe0Huzs8aQ",
    "key": "commission_a_hand_painted_portrait_of_your_pet",
    "source": "Commission a hand-painted portrait of your pet.",
    "translations": {
      "en": "Commission a hand-painted portrait of your pet.",
      "fr": "Commandez un portrait peint à la main de votre animal de compagnie.",
      "de": "Geben Sie ein handgemaltes Porträt Ihres Haustieres in Auftrag.",
      "es": "Encarga un retrato pintado a mano de tu mascota.",
      "uk": "Замовте портрет вашого улюбленця намальований з любов'ю."
    },
    "createdAt": "2025-11-27T11:48:39.691Z",
    "updatedAt": "2025-11-27T11:48:39.691Z"
  },
  {
    "id": "4U8Laqc4dq0opZyVCx10",
    "key": "commission_a_pet_portrait",
    "source": "Commission a pet portrait",
    "createdAt": "2025-11-27T11:10:59.411Z",
    "updatedAt": "2025-11-27T11:10:59.411Z",
    "translations": {
      "en": "Commission a pet portrait",
      "fr": "Commandez un portrait d'animal de compagnie",
      "de": "Geben Sie ein Haustierporträt in Auftrag",
      "es": "Encargar un retrato de mascota",
      "uk": "Замовте портрет улюбленця"
    }
  },
  {
    "id": "DjAhU1nNfY3VNRGJjBN3",
    "key": "commission_a_story",
    "source": "Commission a story",
    "translations": {
      "en": "Commission a story",
      "fr": "Commander une histoire",
      "de": "Geben Sie eine Geschichte in Auftrag",
      "es": "encargar una historia",
      "uk": "Замовте історію"
    },
    "createdAt": "2025-12-05T20:03:29.609Z",
    "updatedAt": "2025-12-05T20:03:29.609Z"
  },
  {
    "id": "zW0aDsFGKEKh7q0HBwQ7",
    "key": "commission_clients_are_always_welcome_to_share_any_specific_ideas_or_details_for",
    "source": "Commission clients are always welcome to share any specific ideas or details for their pet portrait. If you want to clarify the pose, mood, background, or any important details, just message me and I will gladly include them.",
    "translations": {
      "en": "Commission clients are always welcome to share any specific ideas or details for their pet portrait. If you want to clarify the pose, mood, background, or any important details, just message me and I will gladly include them.",
      "fr": "Les clients de la commission sont toujours invités à partager des idées ou des détails spécifiques pour leur portrait d'animal de compagnie. Si vous souhaitez clarifier la pose, l’ambiance, l’arrière-plan ou tout autre détail important, envoyez-moi simplement un message et je les inclurai avec plaisir.",
      "de": "Auftragskunden sind jederzeit herzlich willkommen, uns spezifische Ideen oder Details für ihr Haustierporträt mitzuteilen. Wenn Sie die Pose, Stimmung, den Hintergrund oder andere wichtige Details klären möchten, schreiben Sie mir einfach eine Nachricht und ich werde sie gerne hinzufügen.",
      "es": "Los clientes de la comisión siempre son bienvenidos a compartir ideas o detalles específicos para el retrato de su mascota. Si quieres aclarar la pose, el estado de ánimo, el fondo o algún detalle importante, envíame un mensaje y con gusto los incluiré.",
      "uk": "Замовники завжди раді поділитися будь-якими конкретними ідеями чи деталями для портрета свого улюбленця. Якщо ви хочете уточнити позу, настрій, фон або будь-які важливі деталі, просто напишіть мені, і я з радістю їх додам."
    },
    "createdAt": "2025-11-29T14:06:06.804Z",
    "updatedAt": "2025-11-29T14:06:06.804Z"
  },
  {
    "id": "cCp6fAsNnC3mNDCmHNsZ",
    "key": "commission_support",
    "source": "Commission support",
    "translations": {
      "en": "Commission support",
      "fr": "Soutien de la Commission",
      "de": "Unterstützung durch die Kommission",
      "es": "Apoyo de la Comisión",
      "uk": "Підтримка замовлень"
    },
    "createdAt": "2025-11-29T14:02:26.163Z",
    "updatedAt": "2025-11-29T14:02:26.163Z"
  },
  {
    "id": "N5DW1SC4XeQ57msfIu8v",
    "key": "communicating_with_you_and_service_improvement_customer_support_and_improving_th",
    "source": "Communicating with you and service improvement: customer support and improving the Services (Art. 6(1)(f) GDPR).",
    "translations": {
      "en": "Communicating with you and service improvement: customer support and improving the Services (Art. 6(1)(f) GDPR).",
      "fr": "Communication avec vous et amélioration du service : support client et amélioration des Services (Art. 6(1)(f) RGPD).",
      "de": "Kommunikation mit Ihnen und Serviceverbesserung: Kundenbetreuung und Verbesserung der Dienste (Art. 6(1)(f) DSGVO).",
      "es": "Comunicación con usted y mejora del servicio: atención al cliente y mejora de los Servicios (Art. 6(1)(f) GDPR).",
      "uk": "Комунікація та вдосконалення сервісу: підтримка клієнтів, аналіз роботи сайту, покращення послуг."
    },
    "createdAt": "2025-12-05T09:35:46.645Z",
    "updatedAt": "2025-12-05T09:35:46.645Z"
  },
  {
    "id": "uCqTtYtp2rrLoRyxazLv",
    "key": "complaints",
    "source": "Complaints",
    "translations": {
      "en": "Complaints",
      "fr": "Plaintes",
      "de": "Beschwerden",
      "es": "Quejas",
      "uk": "Скарги"
    },
    "createdAt": "2025-12-05T09:51:06.730Z",
    "updatedAt": "2025-12-05T09:51:06.730Z"
  },
  {
    "id": "kRrjjWq693Yoe6ikoHIB",
    "key": "contact",
    "source": "Contact",
    "translations": {
      "en": "Contact",
      "fr": "Contact",
      "de": "Kontakt",
      "es": "Contacto",
      "uk": "Контакт"
    },
    "createdAt": "2025-11-27T10:36:19.252Z",
    "updatedAt": "2025-11-27T10:36:19.252Z"
  },
  {
    "id": "3OFkxvst8tV190lTG4eF",
    "key": "contact_details_name_address_phone_number_email",
    "source": "Contact details: name, address, phone number, email.",
    "translations": {
      "en": "Contact details: name, address, phone number, email.",
      "fr": "Coordonnées : nom, adresse, numéro de téléphone, email.",
      "de": "Kontaktdaten: Name, Adresse, Telefonnummer, E-Mail.",
      "es": "Datos de contacto: nombre, dirección, número de teléfono, correo electrónico.",
      "uk": "Контактна інформація: ПІБ, адреса, номер телефону, email."
    },
    "createdAt": "2025-12-05T09:29:12.365Z",
    "updatedAt": "2025-12-05T09:29:12.365Z"
  },
  {
    "id": "ZQXG0vkY9yy9rV4NB4f1",
    "key": "contact_information",
    "source": "Contact Information",
    "translations": {
      "en": "Contact Information",
      "fr": "Coordonnées",
      "de": "Kontaktinformationen",
      "es": "Información del contacto",
      "uk": "Контактна інформація"
    },
    "createdAt": "2025-12-04T14:59:04.170Z",
    "updatedAt": "2025-12-04T14:59:04.170Z"
  },
  {
    "id": "qt7VH1cgjJnR6LTVcEFp",
    "key": "contact_us_within_48_hours_of_delivery",
    "source": "Contact us within 48 hours of delivery.",
    "translations": {
      "en": "Contact us within 48 hours of delivery.",
      "fr": "Contactez-nous dans les 48 heures suivant la livraison.",
      "de": "Kontaktieren Sie uns innerhalb von 48 Stunden nach Lieferung.",
      "es": "Contáctenos dentro de las 48 horas posteriores a la entrega.",
      "uk": "Зв’яжіться з нами протягом 48 годин."
    },
    "createdAt": "2025-12-04T13:02:39.198Z",
    "updatedAt": "2025-12-04T13:02:39.198Z"
  },
  {
    "id": "Q7qfHgAdbVECL5Ve5dEg",
    "key": "cookies_and_tracking",
    "source": "Cookies and tracking",
    "translations": {
      "en": "Cookies and tracking",
      "fr": "Cookies et suivi",
      "de": "Cookies und Tracking",
      "es": "Cookies y seguimiento",
      "uk": "Файли cookie та технології відстеження"
    },
    "createdAt": "2025-12-05T09:36:14.734Z",
    "updatedAt": "2025-12-05T09:36:14.734Z"
  },
  {
    "id": "Yg3p3Gqmwy85HxLSnMX1",
    "key": "cozy_love",
    "source": "Cozy Love",
    "translations": {
      "en": "Cozy Love",
      "fr": "Amour douillet",
      "de": "Gemütliche Liebe",
      "es": "Amor acogedor",
      "uk": "Затишне кохання"
    },
    "createdAt": "2026-01-28T10:49:50.875Z",
    "updatedAt": "2026-01-28T10:49:50.875Z"
  },
  {
    "id": "d8xBuKy4xRKDRWcFrnx2",
    "key": "creating_oil_paintings_is_my_true_passion_and_i_d_be_honored_to_paint_one_for_yo",
    "source": "Creating oil paintings is my true passion, and I’d be honored to paint one for you.",
    "translations": {
      "en": "Creating oil paintings is my true passion, and I’d be honored to paint one for you.",
      "fr": "Créer des peintures à l’huile est ma véritable passion et je serais honoré d’en peindre une pour vous.",
      "de": "Das Erstellen von Ölgemälden ist meine wahre Leidenschaft und es wäre mir eine Ehre, eines für Sie zu malen.",
      "es": "Crear pinturas al óleo es mi verdadera pasión y sería un honor para mí pintar una para ti.",
      "uk": "Створення картин маслом — моя справжня пристрасть, і я буду рада творити для вас."
    },
    "createdAt": "2025-11-27T12:40:33.919Z",
    "updatedAt": "2025-11-27T12:40:33.919Z"
  },
  {
    "id": "CdKzCY6A96hgjENu3x6s",
    "key": "custom_artwork_can_be_cancelled_within_24_hours_after_purchase",
    "source": "Custom artwork can be cancelled within 24 hours after purchase.",
    "translations": {
      "en": "Custom artwork can be cancelled within 24 hours after purchase.",
      "fr": "Les illustrations personnalisées peuvent être annulées dans les 24 heures suivant l’achat.",
      "de": "Benutzerdefinierte Kunstwerke können innerhalb von 24 Stunden nach dem Kauf storniert werden.",
      "es": "Las ilustraciones personalizadas se pueden cancelar dentro de las 24 horas posteriores a la compra.",
      "uk": "Кастомні роботи можна скасувати лише протягом 24 годин після оформлення."
    },
    "createdAt": "2025-12-04T13:18:04.727Z",
    "updatedAt": "2025-12-04T13:18:04.727Z"
  },
  {
    "id": "W06yxjYM7sOFOvRogexD",
    "key": "custom_ink_painting",
    "source": "Custom Ink Painting",
    "translations": {
      "en": "Custom Ink Painting",
      "fr": "Portrait à l'encre",
      "de": "Tuscheporträt",
      "es": "Retrato en tinta",
      "uk": "Портрет чорнилом"
    },
    "createdAt": "2025-12-06T15:07:54.671Z",
    "updatedAt": "2025-12-06T15:07:54.671Z"
  },
  {
    "id": "qiHv039NO1f5mpxB4O2w",
    "key": "custom_orders_are_processed_within",
    "createdAt": "2025-11-27T14:48:36.472Z",
    "translations": {
      "en": ". Custom orders are processed within",
      "fr": ". Les commandes personnalisées sont traitées dans",
      "de": ". Sonderanfertigungen werden innerhalb bearbeitet",
      "es": ". Los pedidos personalizados se procesan dentro de",
      "uk": ". Індивідуальні замовлення обробляються протягом"
    },
    "source": ". Custom orders are processed within",
    "updatedAt": "2025-11-27T14:53:26.441Z"
  },
  {
    "id": "jrazmuyTPsyg8lgHoCZG",
    "key": "custom_paintings_in_oil_ink",
    "source": "Custom paintings in oil & ink",
    "translations": {
      "en": "Custom paintings in oil & ink",
      "fr": "Peintures personnalisées à l'huile et à l'encre",
      "de": "Individuelle Gemälde in Öl und Tinte",
      "es": "Cuadros personalizados en óleo y tinta.",
      "uk": "Картини на замовлення олією та чорнилами"
    },
    "createdAt": "2025-11-27T12:32:53.356Z",
    "updatedAt": "2025-11-27T12:32:53.356Z"
  },
  {
    "id": "MrZOxiZq6n3RZcyCZFCq",
    "key": "custom_pet_portrait",
    "source": "Custom pet portrait",
    "translations": {
      "en": "Custom pet portrait",
      "fr": "Portrait d'animal personnalisé",
      "de": "Individuelles Haustierportrait",
      "es": "Retrato de mascota personalizado",
      "uk": "Індивідуальний портрет домашньої тварини"
    },
    "createdAt": "2026-01-28T10:54:49.641Z",
    "updatedAt": "2026-01-28T10:54:49.641Z"
  },
  {
    "id": "3MUxO7o3zpiShDVa7TsZ",
    "key": "custom_pet_portrait_oil_painting",
    "source": "Custom Pet Portrait Oil Painting",
    "translations": {
      "en": "Portrait in oil paints",
      "fr": "Portrait à la peinture à l'huile",
      "de": "Porträt in Ölfarben",
      "es": "Retrato en pinturas al óleo",
      "uk": "Портрет олійними фарбами"
    },
    "createdAt": "2025-12-05T09:48:05.683Z",
    "updatedAt": "2025-12-05T09:48:05.683Z"
  },
  {
    "id": "oI92HXEjbCqWst8ygG8d",
    "key": "custom_pet_portraits",
    "source": "Custom Pet Portraits",
    "createdAt": "2025-11-27T10:39:03.021Z",
    "translations": {
      "en": "Custom Pet Portraits",
      "fr": "Portraits d'animaux personnalisés",
      "de": "Individuelle Haustierporträts",
      "es": "Retratos de mascotas personalizados",
      "uk": "Портрети для ваших улюбленців"
    },
    "updatedAt": "2025-11-27T13:25:48.036Z"
  },
  {
    "id": "NcI2SLnwIwd5FNo5t4Hn",
    "key": "custom_pet_portraits_in_ink_and_oil_hand_painted_from_your_photos_shipped_worldw",
    "source": "Custom pet portraits in ink and oil — hand-painted from your photos, shipped worldwide.",
    "createdAt": "2025-11-27T11:28:00.086Z",
    "translations": {
      "en": "Custom pet portraits in ink and oil — hand-painted from your photos, shipped worldwide.",
      "fr": "Portraits d'animaux de compagnie personnalisés à l'encre et à l'huile — peints à la main à partir de vos photos, expédiés dans le monde entier.",
      "de": "Individuelle Tierporträts in Tinte und Öl – handgemalt nach Ihren Fotos, weltweit versendet.",
      "es": "Retratos de mascotas personalizados en tinta y óleo, pintados a mano a partir de sus fotografías y enviados a todo el mundo.",
      "uk": "Унікальні портрети домашніх тварин чорнилом або олійними фарбами — намальовані вручну по вашим фото. Доставка по всьому світу."
    },
    "updatedAt": "2025-11-27T15:23:38.531Z"
  },
  {
    "id": "rQAiBkDE5rejPDiHWrFz",
    "key": "customer_support",
    "source": "Customer Support",
    "translations": {
      "en": "Customer Support",
      "fr": "Service client",
      "de": "Kundensupport",
      "es": "Atención al cliente",
      "uk": "Підтримка клієнтів"
    },
    "createdAt": "2025-11-29T13:39:29.152Z",
    "updatedAt": "2025-11-29T13:39:29.152Z"
  },
  {
    "id": "RMEGoJo9Ab4wI8lB9tfn",
    "key": "customer_support_information_you_include_in_communications_with_us",
    "source": "Customer support information you include in communications with us.",
    "translations": {
      "en": "Customer support information you include in communications with us.",
      "fr": "Informations de support client que vous incluez dans les communications avec nous.",
      "de": "Kundensupportinformationen, die Sie in die Kommunikation mit uns einbeziehen.",
      "es": "Información de atención al cliente que usted incluye en las comunicaciones con nosotros.",
      "uk": "Інформація, яку ви надаєте у зверненнях до служби підтримки."
    },
    "createdAt": "2025-12-05T09:30:57.153Z",
    "updatedAt": "2025-12-05T09:30:57.153Z"
  },
  {
    "id": "lko03By3wdew6MR5Gf4v",
    "key": "customs_import_taxes",
    "source": "Customs & Import Taxes",
    "translations": {
      "en": "Customs & Import Taxes",
      "fr": "Taxes de douane et d'importation",
      "de": "Zoll- und Einfuhrsteuern",
      "es": "Aduanas e Impuestos de Importación",
      "uk": "Митниця та імпортні податки"
    },
    "createdAt": "2025-11-27T14:42:37.208Z",
    "updatedAt": "2025-11-27T14:42:37.208Z"
  },
  {
    "id": "7R6MoRYr0xJPzI9dC7pU",
    "key": "daria_chizh",
    "source": "Daria Chizh",
    "translations": {
      "en": "Daria Chizh",
      "fr": "Daria Chizh",
      "de": "Daria Chizh",
      "es": "Daria Chizh",
      "uk": "Дар'я Чиж"
    },
    "createdAt": "2025-12-04T14:59:34.553Z",
    "updatedAt": "2025-12-04T14:59:34.553Z"
  },
  {
    "id": "105PIIrVSclyBtmEubzK",
    "key": "daria_chizh_art_studio",
    "source": "Daria Chizh Art Studio",
    "translations": {
      "en": "Daria Chizh Art Studio",
      "fr": "Studio d'art Daria Chizh",
      "de": "Daria Chizh Kunststudio",
      "es": "Estudio de arte Daria Chizh",
      "uk": "Арт-студія Дарії Чиж"
    },
    "createdAt": "2025-11-27T14:09:43.625Z",
    "updatedAt": "2025-11-27T14:09:43.625Z"
  },
  {
    "id": "zU4uTGMfxOYETx9U3JVv",
    "key": "delete_correct_or_restrict_processing_of_your_personal_information",
    "source": "Delete, correct, or restrict processing of your personal information.",
    "translations": {
      "en": "Delete, correct, or restrict processing of your personal information.",
      "fr": "Supprimer, corriger ou restreindre le traitement de vos informations personnelles.",
      "de": "Löschen, korrigieren oder beschränken Sie die Verarbeitung Ihrer personenbezogenen Daten.",
      "es": "Eliminar, corregir o restringir el procesamiento de su información personal.",
      "uk": "Видалення, коригування або обмеження обробки даних;"
    },
    "createdAt": "2025-12-05T09:47:21.638Z",
    "updatedAt": "2025-12-05T09:47:21.638Z"
  },
  {
    "id": "xWdODXPQYkySGva15MJi",
    "key": "delivery",
    "source": "Delivery",
    "translations": {
      "en": "Delivery",
      "fr": "Livraison",
      "de": "Lieferung",
      "es": "Entrega",
      "uk": "Доставка"
    },
    "createdAt": "2025-11-27T14:15:30.501Z",
    "updatedAt": "2025-11-27T14:15:30.501Z"
  },
  {
    "id": "SDGbwQ9WvgYvhcP5Dlqz",
    "key": "delivery_was_fast_portrait_is_stunning_we_are_happy_with_your_service_thank_you",
    "createdAt": "2025-12-05T10:46:26.120Z",
    "source": "Delivery was fast, portrait is stunning, we are happy with your service. Thank you.",
    "translations": {
      "en": "Delivery was fast, portrait is stunning, we are happy with your service. Thank you.",
      "fr": "La livraison a été rapide, le portrait est magnifique, nous sommes satisfaits de votre service. Merci.",
      "de": "Die Lieferung war schnell, das Porträt ist atemberaubend, wir sind mit Ihrem Service zufrieden. Vielen Dank.",
      "es": "La entrega fue rápida, el retrato es impresionante, estamos contentos con su servicio. Gracias.",
      "uk": "Доставка була швидкою, портрет приголомшливий, ми задоволені вашими послугами. Дякуємо."
    },
    "updatedAt": "2025-12-05T15:13:05.237Z"
  },
  {
    "id": "PRUhrKtjvM89Ns4JUFv0",
    "key": "depending_on_your_location_you_may_have_rights_to",
    "source": "Depending on your location, you may have rights to:",
    "translations": {
      "en": "Depending on your location, you may have rights to:",
      "fr": "En fonction de votre situation géographique, vous pouvez avoir le droit de :",
      "de": "Abhängig von Ihrem Standort haben Sie möglicherweise folgende Rechte:",
      "es": "Dependiendo de su ubicación, es posible que tenga derechos a:",
      "uk": "Залежно від законодавства вашої країни, ви можете мати право на:"
    },
    "createdAt": "2025-12-05T09:46:30.618Z",
    "updatedAt": "2025-12-05T09:46:30.618Z"
  },
  {
    "id": "P0pXkryPllqvVlgYcGLe",
    "key": "dimensions",
    "source": "Dimensions",
    "translations": {
      "en": "Dimensions",
      "fr": "Dimensions",
      "de": "Abmessungen",
      "es": "Dimensiones",
      "uk": "Розміри"
    },
    "createdAt": "2025-11-27T15:18:56.626Z",
    "updatedAt": "2025-11-27T15:18:56.626Z"
  },
  {
    "id": "I7bSfpEFDctOK8Piud5j",
    "key": "direct_line",
    "createdAt": "2025-11-27T13:33:41.693Z",
    "translations": {
      "en": "Direct line",
      "fr": "Ligne directe",
      "de": "Direkter Draht",
      "es": "linea directa",
      "uk": "Телефон"
    },
    "source": "Direct line",
    "updatedAt": "2025-11-27T13:38:14.295Z"
  },
  {
    "id": "iUhsjVn0ulRUuat6TGew",
    "key": "disclaimer_limitation_of_liability",
    "source": "Disclaimer & Limitation of Liability",
    "translations": {
      "en": "Disclaimer & Limitation of Liability",
      "fr": "Avis de non-responsabilité et limitation de responsabilité",
      "de": "Haftungsausschluss und Haftungsbeschränkung",
      "es": "Descargo de responsabilidad y limitación de responsabilidad",
      "uk": "Відмова від гарантій та обмеження відповідальності"
    },
    "createdAt": "2025-12-04T14:55:51.860Z",
    "updatedAt": "2025-12-04T14:55:51.860Z"
  },
  {
    "id": "WhvuWdmbTQ20Xkm4inT6",
    "key": "discover_expressive_portraits_and_soulful_pet_commissions_crafted_in_unique_sign",
    "source": "Discover expressive portraits and soulful pet commissions crafted in unique signature palette.",
    "translations": {
      "en": "Discover expressive portraits and soulful pet commissions crafted in unique signature palette.",
      "fr": "Découvrez des portraits expressifs et des commandes d'animaux de compagnie émouvantes réalisées dans une palette de signature unique.",
      "de": "Entdecken Sie ausdrucksstarke Porträts und gefühlvolle Haustieraufträge in einer einzigartigen, charakteristischen Palette.",
      "es": "Descubra retratos expresivos y encargos de mascotas conmovedores elaborados en una paleta exclusiva y exclusiva.",
      "uk": "Відкрийте для себе виразні портрети домашніх тварин, створені в унікальній фірмовій палітрі."
    },
    "createdAt": "2025-11-27T10:59:11.717Z",
    "updatedAt": "2025-11-27T10:59:11.717Z"
  },
  {
    "id": "b20jLDxPHupK94aRuH6L",
    "key": "dmytro",
    "source": "Dmytro",
    "translations": {
      "en": "Dmytro",
      "fr": "Dmytro",
      "de": "Dmytro",
      "es": "Dmitró",
      "uk": "Дмитро"
    },
    "createdAt": "2025-12-05T15:10:07.070Z",
    "updatedAt": "2025-12-05T15:10:07.070Z"
  },
  {
    "id": "2LuLvGlKZRgMW9J2CA6p",
    "key": "dogs_cats_horses_rabbits_birds_every_animal_is_welcome_each_pet_portrait_is_stud",
    "source": "Dogs, cats, horses, rabbits, birds — every animal is welcome. Each pet portrait is studied from your photo so the markings, coat texture, and expression are specific to your animal, not a generic stand-in.",
    "createdAt": "2026-05-20T11:26:52.366Z",
    "translations": {
      "en": "Dogs, cats, horses, rabbits, birds — every animal is welcome. Each pet portrait is studied from your photo so the markings, coat texture, and expression are specific to your animal, not a generic stand-in.",
      "fr": "Chiens, chats, chevaux, lapins, oiseaux — tous les animaux sont les bienvenus. Chaque portrait est étudié d'après votre photo, pour que les marques, la texture du pelage et l'expression soient fidèles à votre compagnon — et non à une silhouette sans âme.",
      "de": "Hunde, Katzen, Pferde, Kaninchen, Vögel – jedes Tier ist willkommen. Jedes Haustierporträt wird sorgfältig nach Ihrem Foto gestaltet, sodass Zeichnung, Fellstruktur und Ausdruck ganz auf Ihr Tier abgestimmt sind – kein austauschbares Allgemeinbild, sondern ein echtes Porträt.",
      "es": "Perros, gatos, caballos, conejos, pájaros — todos los animales son bienvenidos. Cada retrato se estudia a partir de tu foto para que las marcas, la textura del pelaje y la expresión sean las de tu animal, no las de una imagen genérica.",
      "uk": "Собаки, коти, коні, кролики, птахи — тут раді будь-якій тварині. Кожен портрет створюється за вашим фото: плями, текстура шерсті та вираз морди — все це специфічно для вашого улюбленця, а не шаблонне зображення."
    },
    "updatedAt": "2026-05-20T11:49:51.493Z"
  },
  {
    "id": "2ROxJyPAcEliw7eRqKaJ",
    "key": "dynamic_brushstrokes_and_dramatic_lighting_highlight_the_raw_strength_of_the_bir",
    "source": "Dynamic brushstrokes and dramatic lighting highlight the raw strength of the bird against sweeping clouds and distant mountains. The composition evokes freedom, resilience, and the untamed spirit of nature — a striking piece that adds movement, depth, and power to any space.",
    "translations": {
      "en": "Dynamic brushstrokes and dramatic lighting highlight the raw strength of the bird against sweeping clouds and distant mountains. The composition evokes freedom, resilience, and the untamed spirit of nature — a striking piece that adds movement, depth, and power to any space.",
      "fr": "Des coups de pinceau dynamiques et un éclairage spectaculaire mettent en valeur la force brute de l'oiseau contre les nuages ​​​​et les montagnes lointaines. La composition évoque la liberté, la résilience et l'esprit indompté de la nature — une pièce saisissante qui ajoute du mouvement, de la profondeur et de la puissance à n'importe quel espace.",
      "de": "Dynamische Pinselstriche und dramatische Beleuchtung unterstreichen die rohe Kraft des Vogels vor weiten Wolken und fernen Bergen. Die Komposition beschwört Freiheit, Widerstandsfähigkeit und den ungezähmten Geist der Natur – ein beeindruckendes Stück, das jedem Raum Bewegung, Tiefe und Kraft verleiht.",
      "es": "Las pinceladas dinámicas y la iluminación espectacular resaltan la fuerza bruta del pájaro contra las amplias nubes y las montañas distantes. La composición evoca libertad, resiliencia y el espíritu indómito de la naturaleza: una pieza sorprendente que agrega movimiento, profundidad y poder a cualquier espacio.",
      "uk": "Динамічні мазки пензля та ефектне освітлення підкреслюють сильну силу птаха на тлі широких хмар і далеких гір. Композиція пробуджує свободу, стійкість і неприборканий дух природи — вражаючий твір, який додає руху, глибини та сили будь-якому простору."
    },
    "createdAt": "2026-01-28T10:53:41.182Z",
    "updatedAt": "2026-01-28T10:53:41.182Z"
  },
  {
    "id": "yCuMyJYtpBmCFKYgysgK",
    "key": "email",
    "createdAt": "2025-11-27T13:31:51.763Z",
    "translations": {
      "en": "Email",
      "fr": "E-mail *",
      "de": "E-Mail",
      "es": "Correo electrónico *",
      "uk": "Електронна пошта"
    },
    "source": "Email",
    "updatedAt": "2025-11-27T13:35:45.558Z"
  },
  {
    "id": "mSoK8axNiLncXpGpSnhu",
    "key": "europe",
    "source": "Europe:",
    "createdAt": "2025-11-27T14:46:06.442Z",
    "translations": {
      "en": "Europe",
      "fr": "Europe",
      "de": "Europa",
      "es": "Europa",
      "uk": "Європа"
    },
    "updatedAt": "2025-11-27T14:58:10.975Z"
  },
  {
    "id": "HUc3gsXHqoFIGeN0dbhs",
    "key": "europe_5_12_business_days",
    "source": "Europe: 5-12 business days",
    "translations": {
      "en": "Europe: 5-12 business days",
      "fr": "Europe : 5 à 12 jours ouvrables",
      "de": "Europa: 5-12 Werktage",
      "es": "Europa: 5-12 días hábiles",
      "uk": "Європа: 5-12 робочих днів"
    },
    "createdAt": "2025-11-27T14:41:59.162Z",
    "updatedAt": "2025-11-27T14:41:59.162Z"
  },
  {
    "id": "2q0hc03iiQT28vGJa5Sj",
    "key": "evening_calm",
    "source": "Evening calm",
    "translations": {
      "en": "Evening calm",
      "fr": "Soirée calme",
      "de": "Abendstille",
      "es": "Calma nocturna",
      "uk": "Вечірній спокій"
    },
    "createdAt": "2025-12-05T10:03:43.414Z",
    "updatedAt": "2025-12-05T10:03:43.414Z"
  },
  {
    "id": "fOVLWiAKftu76iGWuRbC",
    "key": "every_custom_pet_portrait_is_a_hand_painted_oil_portrait_from_your_photo_created",
    "source": "Every custom pet portrait is a hand-painted oil portrait from your photo, created to capture your pet’s true personality. It’s a unique gift for pet lovers and pet parents — crafted with care and shipped worldwide.",
    "translations": {
      "en": "Every custom pet portrait is a hand-painted oil portrait from your photo, created to capture your pet’s true personality. It’s a unique gift for pet lovers and pet parents — crafted with care and shipped worldwide.",
      "fr": "Chaque portrait d’animal personnalisé est un portrait à l’huile peint à la main à partir de votre photo, créé pour capturer la véritable personnalité de votre animal. C’est un cadeau unique pour les amoureux des animaux et les parents d’animaux – conçu avec soin et expédié dans le monde entier.",
      "de": "Bei jedem individuellen Haustierporträt handelt es sich um ein von Ihrem Foto handgemaltes Ölporträt, das die wahre Persönlichkeit Ihres Haustieres einfängt. Es ist ein einzigartiges Geschenk für Tierliebhaber und Tiereltern – mit Sorgfalt gefertigt und weltweit verschickt.",
      "es": "Cada retrato de mascota personalizado es un retrato al óleo pintado a mano a partir de su fotografía, creado para capturar la verdadera personalidad de su mascota. Es un regalo único para los amantes y padres de mascotas: elaborado con cuidado y enviado a todo el mundo.",
      "uk": "Кожен нестандартний портрет домашнього улюбленця — це портрет, намальований маслом вручну з вашої фотографії, створений, щоб відобразити справжню особистість вашого вихованця. Це унікальний подарунок для любителів домашніх тварин — ретельно виготовлений і доставлений по всьому світу."
    },
    "createdAt": "2025-11-27T14:30:50.140Z",
    "updatedAt": "2025-11-27T14:30:50.140Z"
  },
  {
    "id": "wiLU95sUa4HwmHQ5SGPF",
    "key": "every_finished_painting_ships_internationally_in_protective_archival_packaging_c",
    "source": "Every finished painting ships internationally in protective archival packaging. Customers in the US, UK, Europe, Canada, and Australia have received their portraits in perfect condition. Tracking is included so you know where your artwork is.",
    "createdAt": "2026-05-20T11:25:56.151Z",
    "translations": {
      "en": "Every finished painting ships internationally in protective archival packaging. Customers in the US, UK, Europe, Canada, and Australia have received their portraits in perfect condition. Tracking is included so you know where your artwork is.",
      "fr": "Chaque œuvre achevée est expédiée à l'international dans un emballage de conservation protecteur. Des clients aux États-Unis, au Royaume-Uni, en Europe, au Canada et en Australie ont reçu leur portrait en parfait état. Un numéro de suivi est fourni pour que vous sachiez à tout moment où se trouve votre tableau.",
      "de": "Jedes fertige Gemälde wird international in einer stoßfesten Schutzverpackung verschickt. Kunden in den USA, Großbritannien, Europa, Kanada und Australien haben ihre Porträts in einwandfreiem Zustand erhalten. Eine Sendungsverfolgung ist selbstverständlich inklusive – so wissen Sie jederzeit, wo sich Ihr Kunstwerk befindet.",
      "es": "Cada pintura terminada se envía a todo el mundo con embalaje artístico protector. Clientes en EE. UU., Reino Unido, Europa, Canadá y Australia han recibido sus retratos en perfectas condiciones. El seguimiento del envío está incluido para que sepas en todo momento dónde está tu obra.",
      "uk": "Кожна готова картина відправляється за кордон у захисній архівній упаковці. Клієнти зі США, Великобританії, Європи, Канади та Австралії отримують свої портрети в ідеальному стані. До кожного замовлення додається трекінг — ви завжди знаєте, де зараз ваша робота."
    },
    "updatedAt": "2026-05-20T11:49:50.219Z"
  },
  {
    "id": "DcCrxzQTw2poZEYMOInw",
    "key": "every_pet_portrait_hand_painted_from_your_photo",
    "source": "Every Pet Portrait, Hand-Painted from Your Photo",
    "createdAt": "2026-05-20T11:21:29.637Z",
    "translations": {
      "en": "Every Pet Portrait, Hand-Painted from Your Photo",
      "fr": "Chaque portrait, peint à la main d'après votre photo",
      "de": "Jedes Haustierporträt – handgemalt nach Ihrem Foto",
      "es": "Cada retrato de mascota, pintado a mano desde tu foto",
      "uk": "Кожен портрет домашнього улюбленця — намальований вручну за вашим фото"
    },
    "updatedAt": "2026-05-20T11:49:47.509Z"
  },
  {
    "id": "3SQ35RyPshrZ8iP8vVln",
    "key": "every_portrait_tells_a_story_heres_what_customers_say_after_receiving_theirs",
    "source": "Every portrait tells a story. Here's what customers say after receiving theirs.",
    "translations": {
      "en": "Every portrait tells a story. Here's what customers say after receiving theirs.",
      "fr": "Chaque portrait raconte une histoire. Voici ce que disent les clients après avoir reçu le leur.",
      "de": "Jedes Porträt erzählt eine Geschichte. Das sagen Kunden, nachdem sie ihr Produkt erhalten haben.",
      "es": "Cada retrato cuenta una historia. Esto es lo que dicen los clientes después de recibir el suyo.",
      "uk": "Кожен портрет розповідає історію. Ось що кажуть клієнти після отримання свого."
    },
    "createdAt": "2025-12-05T10:25:23.154Z",
    "updatedAt": "2025-12-05T10:25:23.154Z"
  },
  {
    "id": "clhuJa4irRbzhQj2GVn9",
    "key": "family_bunnies",
    "source": "Family Bunnies",
    "translations": {
      "en": "Family Bunnies",
      "fr": "Lapins de la famille",
      "de": "Familienhasen",
      "es": "Conejitos familiares",
      "uk": "Сімейні зайчики"
    },
    "createdAt": "2026-02-03T15:24:03.716Z",
    "updatedAt": "2026-02-03T15:24:03.716Z"
  },
  {
    "id": "7KvcNjshimyno8CFjaVq",
    "key": "featured",
    "source": "Featured",
    "translations": {
      "en": "Featured",
      "fr": "En vedette",
      "de": "Hervorgehoben",
      "es": "Presentado",
      "uk": "Рекомендовані"
    },
    "createdAt": "2025-12-05T15:43:07.070Z",
    "updatedAt": "2025-12-05T15:43:07.070Z"
  },
  {
    "id": "LhpaD69tgxRXdZ4M9r3d",
    "key": "fill_order_details",
    "source": "Fill order details",
    "translations": {
      "en": "Fill order details",
      "fr": "Remplissez les détails de la commande",
      "de": "Geben Sie die Bestelldetails ein",
      "es": "Completar los detalles del pedido",
      "uk": "Заповнити деталі замовлення"
    },
    "createdAt": "2025-11-27T14:11:31.769Z",
    "updatedAt": "2025-11-27T14:11:31.769Z"
  },
  {
    "id": "kBBLMiyFTlbeXpxfiqDp",
    "key": "flamingo",
    "source": "Flamingo",
    "translations": {
      "en": "Flamingo",
      "fr": "Flamant",
      "de": "Flamingo",
      "es": "Flamenco",
      "uk": "Фламінго"
    },
    "createdAt": "2025-12-05T10:02:20.358Z",
    "updatedAt": "2025-12-05T10:02:20.358Z"
  },
  {
    "id": "BxJedoL5twMMrFepu6Qj",
    "key": "fluffy_love",
    "source": "Fluffy Love",
    "translations": {
      "en": "Fluffy Love",
      "fr": "Amour moelleux",
      "de": "Flauschige Liebe",
      "es": "Amor esponjoso",
      "uk": "Пухнаста любов"
    },
    "createdAt": "2026-01-15T17:12:41.515Z",
    "updatedAt": "2026-01-15T17:12:41.515Z"
  },
  {
    "id": "LNNhnNaUK5tac7cLH5yU",
    "key": "for_any_return_or_refund_questions_please_contact",
    "source": "For any return or refund questions, please contact:",
    "translations": {
      "en": "For any return or refund questions, please contact:",
      "fr": "Pour toute question de retour ou de remboursement, veuillez contacter :",
      "de": "Bei Fragen zur Rückgabe oder Rückerstattung wenden Sie sich bitte an:",
      "es": "Para cualquier pregunta sobre devolución o reembolso, comuníquese con:",
      "uk": "З питань повернення та відшкодування звертайтесь:"
    },
    "createdAt": "2025-12-04T13:19:50.182Z",
    "updatedAt": "2025-12-04T13:19:50.182Z"
  },
  {
    "id": "2U0UALZ6nEOnmgRTCg6q",
    "key": "for_questions_or_to_exercise_your_rights_contact_us_at",
    "source": "For questions or to exercise your rights, contact us at",
    "translations": {
      "en": "For questions or to exercise your rights, contact us at",
      "fr": "Pour toute question ou pour exercer vos droits, contactez-nous au",
      "de": "Bei Fragen oder zur Ausübung Ihrer Rechte kontaktieren Sie uns unter",
      "es": "Para preguntas o para ejercer sus derechos, contáctenos en",
      "uk": "Якщо у вас виникли запитання або щоб скористатися своїми правами, зв’яжіться з нами за адресою"
    },
    "createdAt": "2025-12-05T09:55:36.477Z",
    "updatedAt": "2025-12-05T09:55:36.477Z"
  },
  {
    "id": "b4YdNNjVcxJ0wEfgtGHd",
    "key": "for_the_tracking_information_to_update",
    "source": "for the tracking information to update.",
    "translations": {
      "en": "- for the tracking information to update.",
      "fr": "- pour que les informations de suivi soient mises à jour.",
      "de": "- damit die Tracking-Informationen aktualisiert werden.",
      "es": "- para que se actualice la información de seguimiento.",
      "uk": "- для оновлення інформації про відстеження."
    },
    "createdAt": "2025-11-27T15:11:32.759Z",
    "updatedAt": "2025-11-27T15:11:32.759Z"
  },
  {
    "id": "AAPb4vgy7uYqyLXGW8Xo",
    "key": "free",
    "source": "Free",
    "translations": {
      "en": "Free",
      "fr": "Gratuit",
      "de": "Frei",
      "es": "Gratis",
      "uk": "Безкоштовно"
    },
    "createdAt": "2025-11-27T14:20:06.465Z",
    "updatedAt": "2025-11-27T14:20:06.465Z"
  },
  {
    "id": "Yjud8MIeeGcqyfe0LOHM",
    "key": "free_shipping_all_over_the_world",
    "source": "Free shipping all over the world.",
    "translations": {
      "en": "Free shipping all over the world.",
      "fr": "Livraison gratuite partout dans le monde.",
      "de": "Kostenloser Versand in die ganze Welt.",
      "es": "Envío gratuito a todo el mundo.",
      "uk": "Безкоштовна доставка по всьому світу."
    },
    "createdAt": "2025-11-27T14:42:23.569Z",
    "updatedAt": "2025-11-27T14:42:23.569Z"
  },
  {
    "id": "Uq6E4xi3dUatGI3zXY4O",
    "key": "free_worldwide_shipping",
    "source": "Free worldwide shipping.",
    "translations": {
      "en": "Free worldwide shipping.",
      "fr": "Livraison gratuite dans le monde entier.",
      "de": "Kostenloser weltweiter Versand.",
      "es": "Envío gratuito a todo el mundo.",
      "uk": "Безкоштовна доставка по всьому світу."
    },
    "createdAt": "2025-11-27T10:44:27.114Z",
    "updatedAt": "2025-11-27T10:44:27.114Z"
  },
  {
    "id": "Be2N2V0nwCjeTVWx7aS8",
    "key": "frieda",
    "source": "Frieda",
    "translations": {
      "en": "Frieda",
      "fr": "Frieda",
      "de": "Frieda",
      "es": "frida",
      "uk": "Фріда"
    },
    "createdAt": "2025-12-05T10:19:48.667Z",
    "updatedAt": "2025-12-05T10:19:48.667Z"
  },
  {
    "id": "85vaqpVtSe6dMEw4WtGA",
    "key": "from_dog_portrait_paintings_and_cat_portrait_paintings_to_pet_memorial_portraits",
    "source": "From dog portrait paintings and cat portrait paintings to pet memorial portraits and bespoke custom animal artwork, I create each realistic pet painting with layered texture and archival-quality pigments for long-lasting color.",
    "translations": {
      "en": "From dog portrait paintings and cat portrait paintings to pet memorial portraits and bespoke custom animal artwork, I create each realistic pet painting with layered texture and archival-quality pigments for long-lasting color.",
      "fr": "Des peintures de portraits de chiens et de chats aux portraits commémoratifs d'animaux de compagnie et aux œuvres d'art animalières personnalisées sur mesure, je crée chaque peinture d'animal de compagnie réaliste avec une texture en couches et des pigments de qualité archive pour une couleur durable.",
      "de": "Von Hundeporträts und Katzenporträts bis hin zu Haustier-Gedenkporträts und maßgeschneiderten Tierkunstwerken erstelle ich jedes realistische Haustiergemälde mit mehrschichtiger Textur und Pigmenten in Archivqualität für langanhaltende Farben.",
      "es": "Desde retratos de perros y gatos hasta retratos conmemorativos de mascotas y obras de arte de animales personalizadas, creo cada pintura realista de mascotas con textura en capas y pigmentos de calidad de archivo para un color duradero.",
      "uk": "Створюю портрети собак і портрети котів, а також меморіальні портрети домашніх тварин на замовлення. Кожна картина улюбленця має багатошарову текстуру та виконана архівними пігментами, щоб зберегти красу й колір на довгі роки."
    },
    "createdAt": "2025-11-27T11:06:15.850Z",
    "updatedAt": "2025-11-27T11:06:15.850Z"
  },
  {
    "id": "PkpZ4E0024mmtlDFvY6U",
    "key": "general_conditions",
    "source": "General Conditions",
    "translations": {
      "en": "General Conditions",
      "fr": "Conditions générales",
      "de": "Allgemeine Geschäftsbedingungen",
      "es": "Condiciones Generales",
      "uk": "Загальні умови"
    },
    "createdAt": "2025-12-04T14:44:08.564Z",
    "updatedAt": "2025-12-04T14:44:08.564Z"
  },
  {
    "id": "VoY55gXth9PwawS909X8",
    "key": "go_to_the_commission_page",
    "createdAt": "2025-11-27T12:29:36.055Z",
    "translations": {
      "en": "Go to the Commission page",
      "fr": "Accédez à la page Commissions.",
      "de": "Gehen Sie zur Kommissionsseite",
      "es": "Vaya a la página de la Comisión.",
      "uk": "Перейдіть на сторінку замовлення"
    },
    "source": "Go to the Commission page",
    "updatedAt": "2025-11-27T12:30:21.438Z"
  },
  {
    "id": "6G7KE3fdlNAmzPvmilqd",
    "key": "governing_law",
    "source": "Governing Law",
    "translations": {
      "en": "Governing Law",
      "fr": "Loi applicable",
      "de": "Geltendes Recht",
      "es": "Ley aplicable",
      "uk": "Застосовне право"
    },
    "createdAt": "2025-12-04T14:56:56.869Z",
    "updatedAt": "2025-12-04T14:56:56.869Z"
  },
  {
    "id": "bAR9LheSJiavrQkzPaj3",
    "key": "hand_painted_with_love",
    "source": "Hand-painted with love",
    "translations": {
      "en": "Hand-painted with love",
      "fr": "Peint à la main avec amour",
      "de": "Mit Liebe handbemalt",
      "es": "Pintado a mano con amor.",
      "uk": "Написано вручну з любов'ю"
    },
    "createdAt": "2025-12-05T10:47:38.467Z",
    "updatedAt": "2025-12-05T10:47:38.467Z"
  },
  {
    "id": "OMUwyzFGxVqqdlPAYJef",
    "key": "heartfelt_stories_from_our_happy_customers",
    "source": "Heartfelt stories from our happy customers.",
    "translations": {
      "en": "Heartfelt stories from our happy customers.",
      "fr": "Histoires sincères de nos clients satisfaits.",
      "de": "Herzliche Geschichten von unseren zufriedenen Kunden.",
      "es": "Historias sinceras de nuestros clientes satisfechos.",
      "uk": "Щирі історії від наших щасливих клієнтів."
    },
    "createdAt": "2025-12-05T10:41:48.408Z",
    "updatedAt": "2025-12-05T10:41:48.408Z"
  },
  {
    "id": "qgUn8FK8aJl8fjtLBOWO",
    "key": "hello",
    "source": "Hello",
    "translations": {
      "en": "Hello",
      "fr": "Bonjour",
      "de": "Hallo",
      "es": "Hola",
      "uk": "Привіт"
    },
    "createdAt": "2025-11-27T12:11:32.195Z",
    "updatedAt": "2025-11-27T12:11:32.195Z"
  },
  {
    "id": "76PQWSzy1Cxv8ZSJQbkw",
    "key": "home",
    "source": "Home",
    "translations": {
      "en": "Home",
      "fr": "Maison",
      "de": "Heim",
      "es": "Hogar",
      "uk": "Головна"
    },
    "createdAt": "2025-11-27T10:28:40.041Z",
    "updatedAt": "2025-11-27T10:28:40.041Z"
  },
  {
    "id": "LogOWIDpg6YX5s4mLVEP",
    "key": "home.trendingContext",
    "source": "Based on live engagement",
    "translations": {
      "en": "Based on live engagement",
      "fr": "Basé sur un engagement en direct",
      "de": "Basierend auf Live-Engagement",
      "es": "Basado en interacción en vivo",
      "uk": "На основі переглядів"
    },
    "createdAt": "2025-11-29T14:47:33.007Z",
    "updatedAt": "2025-11-29T14:47:33.007Z"
  },
  {
    "id": "XsokefHqEYJXWuOenmra",
    "key": "home.trendingContextWithCountry",
    "createdAt": "2025-11-29T14:35:22.416Z",
    "source": "Based on live engagement from collectors in {{country}}",
    "translations": {
      "en": "Based on live engagement from collectors in {{country}}",
      "fr": "Basé sur l'engagement en direct de collectionneurs de {{country}}",
      "de": "Basierend auf Live-Interaktionen von Sammlern in {{country}}",
      "es": "Basado en la participación en vivo de coleccionistas en {{country}}",
      "uk": "На основі переглядів в {{country}}"
    },
    "updatedAt": "2025-11-29T14:46:33.793Z"
  },
  {
    "id": "DfLrojNPPaJAyRDwJqkw",
    "key": "how_to_reach_me",
    "source": "How to reach me",
    "translations": {
      "en": "How to reach me",
      "fr": "Comment me joindre",
      "de": "So erreichen Sie mich",
      "es": "como llegar a mi",
      "uk": "Як звʼязатися зі мною"
    },
    "createdAt": "2025-11-29T13:42:58.138Z",
    "updatedAt": "2025-11-29T13:42:58.138Z"
  },
  {
    "id": "u0sOwY1BCo1bQM2ZC5OP",
    "key": "how_we_collect_and_use_your_personal_information",
    "source": "How we collect and use your personal information",
    "translations": {
      "en": "How we collect and use your personal information",
      "fr": "Comment nous collectons et utilisons vos informations personnelles",
      "de": "Wie wir Ihre personenbezogenen Daten erfassen und verwenden",
      "es": "Cómo recopilamos y utilizamos su información personal",
      "uk": "Як ми збираємо та використовуємо вашу особисту інформацію"
    },
    "createdAt": "2025-12-05T09:21:43.709Z",
    "updatedAt": "2025-12-05T09:21:43.709Z"
  },
  {
    "id": "mrNB8kOVw7adT84MQiBH",
    "key": "how_we_disclose_personal_information",
    "source": "How we disclose personal information",
    "translations": {
      "en": "How we disclose personal information",
      "fr": "Comment nous divulguons les informations personnelles",
      "de": "Wie wir personenbezogene Daten offenlegen",
      "es": "Cómo divulgamos información personal",
      "uk": "Як ми розкриваємо персональну інформацію"
    },
    "createdAt": "2025-12-05T09:38:40.666Z",
    "updatedAt": "2025-12-05T09:38:40.666Z"
  },
  {
    "id": "bMXCdzziFY5ZrkqRM7Q5",
    "key": "how_we_use_your_personal_information",
    "source": "How we use your personal information",
    "translations": {
      "en": "How we use your personal information",
      "fr": "Comment nous utilisons vos informations personnelles",
      "de": "Wie wir Ihre persönlichen Daten verwenden",
      "es": "Cómo utilizamos su información personal",
      "uk": "Як ми використовуємо вашу особисту інформацію"
    },
    "createdAt": "2025-12-05T09:33:18.556Z",
    "updatedAt": "2025-12-05T09:33:18.556Z"
  },
  {
    "id": "9eMjlMeBs6M6el09D604",
    "key": "i_answer_every_message_personally_and_make_sure_you_feel_guided_from_the_first_s",
    "source": "I answer every message personally and make sure you feel guided from the first sketch to the day your artwork arrives.",
    "translations": {
      "en": "I answer every message personally and make sure you feel guided from the first sketch to the day your artwork arrives.",
      "fr": "Je réponds personnellement à chaque message et m'assure que vous vous sentiez guidé depuis le premier croquis jusqu'au jour où votre œuvre arrive.",
      "de": "Ich beantworte jede Nachricht persönlich und sorge dafür, dass Sie sich von der ersten Skizze bis zum Tag, an dem Ihr Kunstwerk eintrifft, begleitet fühlen.",
      "es": "Respondo cada mensaje personalmente y me aseguro de que te sientas guiado desde el primer boceto hasta el día en que llega tu obra de arte.",
      "uk": "Я особисто відповідаю на кожне повідомлення та дбаю про те, щоб ви відчували себе в безпеці від першого ескізу до дня, коли ваша робота надходить."
    },
    "createdAt": "2025-11-29T13:42:12.744Z",
    "updatedAt": "2025-11-29T13:42:12.744Z"
  },
  {
    "id": "8Y9LR30u32SVit8C2bNX",
    "key": "i_d_love_to_create_an_oil_painting_of_your_pet_from_your_favorite_photo_perfect_",
    "source": "I’d love to create an oil painting of your pet from your favorite photo—perfect for a gift or a pet memorial portrait. Visit the Commission page to get started.",
    "translations": {
      "en": "I’d love to create an oil painting of your pet from your favorite photo—perfect for a gift or a pet memorial portrait. Visit the Commission page to get started.",
      "fr": "J'aimerais créer une peinture à l'huile de votre animal de compagnie à partir de votre photo préférée, parfaite pour un cadeau ou un portrait commémoratif d'un animal de compagnie. Visitez la page Commission pour commencer.",
      "de": "Gerne erstelle ich anhand Ihres Lieblingsfotos ein Ölgemälde Ihres Haustiers – perfekt als Geschenk oder als Erinnerungsporträt für Ihr Haustier. Besuchen Sie die Kommissionsseite, um loszulegen.",
      "es": "Me encantaría crear una pintura al óleo de tu mascota a partir de tu foto favorita, perfecta para un regalo o un retrato conmemorativo de tu mascota. Visite la página de la Comisión para comenzar.",
      "uk": "Я з задоволенням напишу олійну картину вашого домашнього улюбленця з вашої улюбленої фотографії — ідеально підходить для подарунка або пам’ятного портрета домашнього улюбленця. Відвідайте сторінку замовлення щоб почати."
    },
    "createdAt": "2025-11-27T11:49:48.068Z",
    "updatedAt": "2025-11-27T11:49:48.068Z"
  },
  {
    "id": "pRSICuqJHFCEXEy6pxwt",
    "key": "i_m_here_for_you",
    "source": "I’m here for you",
    "translations": {
      "en": "I’m here for you",
      "fr": "je suis là pour toi",
      "de": "Ich bin für dich da",
      "es": "Estoy aquí para ti",
      "uk": "Я тут для вас"
    },
    "createdAt": "2025-11-29T14:15:14.925Z",
    "updatedAt": "2025-11-29T14:15:14.925Z"
  },
  {
    "id": "grWFCcJadVmblhaKy9C4",
    "key": "i_painted_this_piece_after_an_early_summer_walk_through_an_untamed_field_tall_gr",
    "source": "I painted this piece after an early-summer walk through an untamed field. Tall grasses brushed my knees, skylarks sang overhead, and hundreds of wild blooms mingled in a soft breeze. I wanted to bottle that fleeting, carefree moment—the hum of bees, the pale morning sky, the joyful chaos of color. With thick impasto and lively palette-knife strokes, each flower petal rises from the canvas, inviting you to reach out and touch a summer that never ends.",
    "translations": {
      "en": "I painted this piece after an early-summer walk through an untamed field. Tall grasses brushed my knees, skylarks sang overhead, and hundreds of wild blooms mingled in a soft breeze. I wanted to bottle that fleeting, carefree moment—the hum of bees, the pale morning sky, the joyful chaos of color. With thick impasto and lively palette-knife strokes, each flower petal rises from the canvas, inviting you to reach out and touch a summer that never ends.",
      "fr": "J'ai peint cette pièce après une promenade au début de l'été dans un champ sauvage. Des herbes hautes effleuraient mes genoux, des alouettes chantaient au-dessus de moi et des centaines de fleurs sauvages se mêlaient dans une douce brise. Je voulais mettre en bouteille ce moment éphémère et insouciant : le bourdonnement des abeilles, le ciel pâle du matin, le joyeux chaos de couleurs. Avec des empâtements épais et des coups de couteau vifs, chaque pétale de fleur s'élève de la toile, vous invitant à tendre la main et à toucher un été qui ne finit jamais.",
      "de": "Ich habe dieses Stück nach einem Frühsommerspaziergang durch ein ungezähmtes Feld gemalt. Hohe Gräser berührten meine Knie, Feldlerchen sangen über mir und Hunderte wilder Blüten vermischten sich in einer sanften Brise. Ich wollte diesen flüchtigen, unbeschwerten Moment festhalten – das Summen der Bienen, den blassen Morgenhimmel, das fröhliche Chaos der Farben. Mit dickem Impasto und lebhaften Spachtelstrichen erhebt sich jedes Blütenblatt von der Leinwand und lädt Sie ein, die Hand auszustrecken und einen Sommer zu berühren, der niemals endet.",
      "es": "Pinté esta pieza después de un paseo a principios de verano por un campo salvaje. La hierba alta rozaba mis rodillas, las alondras cantaban en lo alto y cientos de flores silvestres se mezclaban con una suave brisa. Quería embotellar ese momento fugaz y despreocupado: el zumbido de las abejas, el cielo pálido de la mañana, el alegre caos de colores. Con gruesos empastes y vivaces pinceladas de espátula, cada pétalo de flor se eleva del lienzo, invitándote a extender la mano y tocar un verano que nunca termina.",
      "uk": "Я намалював цей твір після прогулянки на початку літа через невикоренене поле. Високі трави торкалися мені колін, жайворонки співали над головою, а сотні диких квітів змішувалися з м’яким вітерцем. Мені хотілося вгамувати ту швидкоплинну, безтурботну мить — дзижчання бджіл, бліде ранкове небо, радісний хаос кольорів. Густим імпастою та жвавими штрихами мастихіна кожна пелюстка квітки піднімається з полотна, запрошуючи вас простягнути руку та торкнутися літа, яке ніколи не закінчується."
    },
    "createdAt": "2026-01-23T16:56:06.468Z",
    "updatedAt": "2026-01-23T16:56:06.468Z"
  },
  {
    "id": "FkAvgLnt1UDazKTq3urU",
    "key": "i_respond_within_24_hours_to_commission_inquiries",
    "source": "I respond within 24 hours to commission inquiries.",
    "translations": {
      "en": "I respond within 24 hours to commission inquiries.",
      "fr": "Je réponds dans les 24 heures aux demandes de commission.",
      "de": "Ich antworte innerhalb von 24 Stunden auf Provisionsanfragen.",
      "es": "Respondo dentro de las 24 horas a las consultas sobre comisiones.",
      "uk": "Я відповідаю протягом 24 годин на запити."
    },
    "createdAt": "2025-11-27T13:34:11.078Z",
    "updatedAt": "2025-11-27T13:34:11.078Z"
  },
  {
    "id": "oGNgEjZyazRFCT7sW7wk",
    "key": "i_ship_worldwide_delivery_times_and_costs_vary_depending_on_your_location",
    "source": "I ship worldwide! Delivery times and costs vary depending on your location:",
    "translations": {
      "en": "I ship worldwide! Delivery times and costs vary depending on your location:",
      "fr": "J'expédie dans le monde entier ! Les délais et frais de livraison varient en fonction de votre localisation :",
      "de": "Ich versende weltweit! Lieferzeiten und Kosten variieren je nach Standort:",
      "es": "¡Hago envíos a todo el mundo! Los tiempos y costos de entrega varían dependiendo de su ubicación:",
      "uk": "Відправляю по всьому світу! Час і вартість доставки залежать від вашого місцезнаходження:"
    },
    "createdAt": "2025-11-27T14:41:25.573Z",
    "updatedAt": "2025-11-27T14:41:25.573Z"
  },
  {
    "id": "RN5CMMlzq1iUAeag7G6h",
    "key": "i_snapped_this_scene_on_a_chilly_april_morning_in_norway_s_lofoten_islands_snow_",
    "source": "I snapped this scene on a chilly April morning in Norway’s Lofoten Islands—snow-tipped peaks rising straight from emerald fjords, sunlight twinkling off the still water. Back in the studio I recreated that breath-catching moment with quick palette-knife strokes of cool blues and crisp whites. The thick paint catches light just like the spring waves did, carrying a hint of arctic calm wherever you hang it.",
    "translations": {
      "en": "I snapped this scene on a chilly April morning in Norway’s Lofoten Islands—snow-tipped peaks rising straight from emerald fjords, sunlight twinkling off the still water. Back in the studio I recreated that breath-catching moment with quick palette-knife strokes of cool blues and crisp whites. The thick paint catches light just like the spring waves did, carrying a hint of arctic calm wherever you hang it.",
      "fr": "J'ai photographié cette scène par un froid matin d'avril dans les îles Lofoten en Norvège : des sommets enneigés s'élevant directement des fjords émeraude, la lumière du soleil scintillant sur l'eau calme. De retour en studio, j'ai recréé ce moment à couper le souffle avec des coups rapides de couteau à palette de bleus froids et de blancs éclatants. La peinture épaisse capte la lumière tout comme les vagues printanières, apportant une touche de calme arctique partout où vous l'accrochez.",
      "de": "Ich habe diese Szene an einem kühlen Aprilmorgen auf den norwegischen Lofoten aufgenommen – schneebedeckte Gipfel, die direkt aus smaragdgrünen Fjorden aufragen, Sonnenlicht, das auf dem stillen Wasser funkelt. Zurück im Studio habe ich diesen atemberaubenden Moment mit schnellen Spachtelstrichen in kühlen Blau- und klaren Weißtönen nachgebildet. Die dicke Farbe fängt das Licht ein, genau wie die Frühlingswellen, und trägt überall, wo Sie sie aufhängen, einen Hauch arktischer Ruhe mit sich.",
      "es": "Tomé esta escena en una fría mañana de abril en las islas Lofoten de Noruega: picos nevados que se elevan directamente desde fiordos color esmeralda, la luz del sol brillando en el agua tranquila. De vuelta en el estudio, recreé ese momento impresionante con rápidos trazos de espátula de azules fríos y blancos nítidos. La pintura espesa capta la luz tal como lo hacían las olas primaverales, llevando un toque de calma ártica dondequiera que la cuelgues.",
      "uk": "Я зняв цю сцену прохолодним квітневим ранком на норвезьких Лофотенських островах — засніжені вершини височіють прямо зі смарагдових фіордів, сонячне світло мерехтить від тихої води. Повернувшись у студію, я відтворив цей захоплюючий момент швидкими штрихами мастихіном прохолодного синього та чіткого білого. Густа фарба вловлює світло, як це робили весняні хвилі, несучи натяк арктичного спокою, де б ви її не повісили."
    },
    "createdAt": "2026-01-23T17:03:19.387Z",
    "updatedAt": "2026-01-23T17:03:19.387Z"
  },
  {
    "id": "tEms8cxKn9tVq0ymMO67",
    "key": "i_will_arrange_replacements_refund_and_exchange_steps_are_detailed_in_the",
    "source": "I will arrange replacements. Refund and exchange steps are detailed in the",
    "translations": {
      "en": "I will arrange replacements. Refund and exchange steps are detailed in the",
      "fr": "J'organiserai les remplacements. Les étapes de remboursement et d'échange sont détaillées dans la",
      "de": "Ich werde für Ersatz sorgen. Die Schritte zur Rückerstattung und zum Umtausch finden Sie im Detail",
      "es": "Arreglaré reemplazos. Los pasos de reembolso y cambio se detallan en el",
      "uk": "Організую заміни. Етапи повернення та обміну детально описано в"
    },
    "createdAt": "2025-11-29T14:12:26.170Z",
    "updatedAt": "2025-11-29T14:12:26.170Z"
  },
  {
    "id": "2gAAS999btquHL81NrRm",
    "key": "i_work_in_museum_quality_oil_paints_on_canvas_ensuring_your_portrait_will_last_f",
    "source": "I work in museum-quality oil paints on canvas, ensuring your portrait will last for generations. Each artwork comes varnished and ready to display, whether you request a dog portrait painting, a cat portrait painting, or another piece of custom animal artwork.",
    "translations": {
      "en": "I work in museum-quality oil paints on canvas, ensuring your portrait will last for generations. Each artwork comes varnished and ready to display, whether you request a dog portrait painting, a cat portrait painting, or another piece of custom animal artwork.",
      "fr": "Je travaille avec des peintures à l'huile sur toile de qualité musée, garantissant que votre portrait durera des générations. Chaque œuvre d'art est vernie et prête à être exposée, que vous demandiez un portrait de chien, un portrait de chat ou une autre œuvre d'art animalière personnalisée.",
      "de": "Ich arbeite mit Ölfarben in Museumsqualität auf Leinwand, um sicherzustellen, dass Ihr Porträt über Generationen hinweg erhalten bleibt. Jedes Kunstwerk wird lackiert und kann sofort ausgestellt werden, unabhängig davon, ob Sie ein Hundeporträt, ein Katzenporträt oder ein anderes individuelles Tierkunstwerk wünschen.",
      "es": "Trabajo con pinturas al óleo sobre lienzo con calidad de museo, asegurándome de que su retrato dure generaciones. Cada obra de arte viene barnizada y lista para exhibir, ya sea que solicite un retrato de perro, un retrato de gato u otra obra de arte de animal personalizada.",
      "uk": "Я працюю з олійними фарбами музейної якості на полотні, гарантуючи, що ваш портрет залишиться для багатьох поколінь. Кожен витвір мистецтва покривається лаком і готовий до демонстрації, незалежно від того, чи замовляєте ви портрет собаки, портрет кота чи інший твір мистецтва на замовлення."
    },
    "createdAt": "2025-11-29T14:19:44.773Z",
    "updatedAt": "2025-11-29T14:19:44.773Z"
  },
  {
    "id": "kIwiVE3YHnVI8C9KPkkP",
    "key": "i_would_be_happy_to_create_an_oil_painting_of_your_pet_using_your_favorite_photo",
    "source": "I would be happy to create an oil painting of your pet using your favorite photo — a beautiful gift or a meaningful memorial portrait.",
    "translations": {
      "en": "I would be happy to create an oil painting of your pet using your favorite photo — a beautiful gift or a meaningful memorial portrait.",
      "fr": "Je serais heureux de créer une peinture à l’huile de votre animal de compagnie en utilisant votre photo préférée – un beau cadeau ou un portrait commémoratif significatif.",
      "de": "Gerne erstelle ich mit Ihrem Lieblingsfoto ein Ölgemälde Ihres Haustieres – ein schönes Geschenk oder ein bedeutungsvolles Erinnerungsporträt.",
      "es": "Estaría encantado de crear una pintura al óleo de su mascota usando su foto favorita: un hermoso regalo o un retrato conmemorativo significativo.",
      "uk": "Із задоволенням створю портрет вашого улюбленця олійними фарбами за улюбленою фотографією — завжди гарний подарунок або значущий пам'ятний портрет."
    },
    "createdAt": "2025-11-27T12:48:59.879Z",
    "updatedAt": "2025-11-27T12:48:59.879Z"
  },
  {
    "id": "xUDO9n6dDUGktoCEwVZw",
    "key": "if_the_carrier_confirms_a_lost_shipment_we_will_issue_a_refund_or_send_a_replace",
    "source": "If the carrier confirms a lost shipment, we will issue a refund or send a replacement at no additional cost.",
    "translations": {
      "en": "If the carrier confirms a lost shipment, we will issue a refund or send a replacement at no additional cost.",
      "fr": "Si le transporteur confirme un envoi perdu, nous effectuerons un remboursement ou enverrons un remplacement sans frais supplémentaires.",
      "de": "Wenn der Spediteur bestätigt, dass die Sendung verloren gegangen ist, erstatten wir den Betrag oder senden einen Ersatz ohne zusätzliche Kosten.",
      "es": "Si el transportista confirma la pérdida del envío, emitiremos un reembolso o enviaremos un reemplazo sin costo adicional.",
      "uk": "Якщо перевізник підтвердить втрату відправлення, ми повернемо кошти або надішлемо заміну без додаткової оплати."
    },
    "createdAt": "2025-12-04T13:15:30.819Z",
    "updatedAt": "2025-12-04T13:15:30.819Z"
  },
  {
    "id": "1ztVtCK1MSA7qqHudVK7",
    "key": "if_there_are_any_unexpected_delays_ill_notify_you_via_email",
    "createdAt": "2025-11-27T14:49:40.112Z",
    "source": ". If there are any unexpected delays, I'll notify you via email.",
    "translations": {
      "en": ". If there are any unexpected delays, I'll notify you via email.",
      "fr": ". S'il y a des retards inattendus, je vous en informerai par e-mail.",
      "de": ". Sollte es zu unerwarteten Verzögerungen kommen, benachrichtige ich Sie per E-Mail.",
      "es": ". Si hay algún retraso inesperado, te lo notificaré por correo electrónico.",
      "uk": ". Якщо виникнуть будь-які несподівані затримки, я повідомлю вас електронною поштою."
    },
    "updatedAt": "2025-11-27T14:55:20.316Z"
  },
  {
    "id": "dasnCJ2LXCLpYddECeJF",
    "key": "if_you_have_any_questions_feel_free_to_contact_me_thank_you_for_your_support",
    "source": "If you have any questions, feel free to contact me! Thank you for your support 🧡",
    "translations": {
      "en": "If you have any questions, feel free to contact me! Thank you for your support 🧡",
      "fr": "Si vous avez des questions, n'hésitez pas à me contacter ! Merci pour votre soutien 🧡",
      "de": "Wenn Sie Fragen haben, können Sie mich gerne kontaktieren! Vielen Dank für eure Unterstützung 🧡",
      "es": "Si tienes alguna pregunta, ¡no dudes en ponerte en contacto conmigo! Gracias por su apoyo 🧡",
      "uk": "Якщо у вас виникли запитання, не соромтеся звертатися до мене! Дякуємо за вашу підтримку 🧡"
    },
    "createdAt": "2025-11-27T15:03:54.575Z",
    "updatedAt": "2025-11-27T15:03:54.575Z"
  },
  {
    "id": "ecZE3OaDPXgz8WyVuefm",
    "key": "if_you_have_complaints_about_how_we_process_your_information_contact_us_if_unsat",
    "source": "If you have complaints about how we process your information, contact us. If unsatisfied, you may have the right to appeal or lodge a complaint with your local data protection authority, where applicable.",
    "translations": {
      "en": "If you have complaints about how we process your information, contact us. If unsatisfied, you may have the right to appeal or lodge a complaint with your local data protection authority, where applicable.",
      "fr": "Si vous avez des plaintes concernant la façon dont nous traitons vos informations, contactez-nous. Si vous n'êtes pas satisfait, vous pouvez avoir le droit de faire appel ou de déposer une plainte auprès de votre autorité locale de protection des données, le cas échéant.",
      "de": "Wenn Sie Beschwerden darüber haben, wie wir Ihre Daten verarbeiten, kontaktieren Sie uns. Wenn Sie nicht zufrieden sind, haben Sie gegebenenfalls das Recht, bei Ihrer örtlichen Datenschutzbehörde Berufung einzulegen oder eine Beschwerde einzureichen.",
      "es": "Si tiene quejas sobre cómo procesamos su información, contáctenos. Si no está satisfecho, puede tener derecho a apelar o presentar una queja ante la autoridad local de protección de datos, cuando corresponda.",
      "uk": "Якщо у вас є скарги щодо того, як ми обробляємо вашу інформацію, зв’яжіться з нами. Якщо ви не задоволені, ви можете мати право оскаржити або подати скаргу до місцевого органу із захисту даних, де це можливо."
    },
    "createdAt": "2025-12-05T09:51:37.634Z",
    "updatedAt": "2025-12-05T09:51:37.634Z"
  },
  {
    "id": "0evywccWpdL4DHi9o0IW",
    "key": "if_you_send_creative_ideas_proposals_or_other_materials_you_agree_that_we_may_ed",
    "source": "If you send creative ideas, proposals, or other materials, you agree that we may edit, copy, publish, distribute, and use them without restriction. You are responsible for ensuring your submissions do not violate any third-party rights or contain unlawful material.",
    "translations": {
      "en": "If you send creative ideas, proposals, or other materials, you agree that we may edit, copy, publish, distribute, and use them without restriction. You are responsible for ensuring your submissions do not violate any third-party rights or contain unlawful material.",
      "fr": "Si vous envoyez des idées créatives, des propositions ou d'autres documents, vous acceptez que nous puissions les éditer, copier, publier, distribuer et utiliser sans restriction. Vous êtes responsable de vous assurer que vos soumissions ne violent aucun droit de tiers ou ne contiennent pas de matériel illégal.",
      "de": "Wenn Sie kreative Ideen, Vorschläge oder andere Materialien senden, erklären Sie sich damit einverstanden, dass wir diese ohne Einschränkung bearbeiten, kopieren, veröffentlichen, verteilen und nutzen dürfen. Sie sind dafür verantwortlich, dass Ihre Einsendungen keine Rechte Dritter verletzen oder rechtswidriges Material enthalten.",
      "es": "Si envía ideas creativas, propuestas u otros materiales, acepta que podemos editarlos, copiarlos, publicarlos, distribuirlos y usarlos sin restricciones. Usted es responsable de garantizar que sus envíos no violen ningún derecho de terceros ni contengan material ilegal.",
      "uk": "Якщо ви надсилаєте нам творчі ідеї, пропозиції чи інші матеріали, ви погоджуєтесь, що ми можемо редагувати, копіювати, публікувати, поширювати та використовувати їх без обмежень. Ви несете відповідальність за те, щоб ваші матеріали не порушували права третіх сторін і не містили незаконного контенту."
    },
    "createdAt": "2025-12-04T14:53:27.071Z",
    "updatedAt": "2025-12-04T14:53:27.071Z"
  },
  {
    "id": "4kqC8I2n7XlETxBkTNRW",
    "key": "if_your_artwork_arrives_with_a_surprise_damage_customs_hold_color_question_pleas",
    "source": "If your artwork arrives with a surprise (damage, customs hold, color question) please photograph the package and piece within -",
    "createdAt": "2025-11-29T14:08:12.082Z",
    "translations": {
      "en": "If your artwork arrives with a surprise (damage, customs hold, color question) please photograph the package and piece within -",
      "fr": "Si votre œuvre arrive avec une surprise (dommage, retenue en douane, question de couleur), veuillez photographier l'emballage et la pièce à l'intérieur -",
      "de": "Wenn Ihr Kunstwerk mit einer Überraschung ankommt (Beschädigung, Zollsperre, Farbfrage), fotografieren Sie bitte das Paket und das Stück innerhalb von -",
      "es": "Si su obra de arte llega con una sorpresa (daños, retención aduanera, pregunta sobre el color), fotografíe el paquete y la pieza dentro.",
      "uk": "Якщо ваше замовлення прибуло із дефектом (пошкодження, митний контроль, питання щодо кольору), будь ласка, сфотографуйте пакунок і деталі що саме пошкоджено протягом -"
    },
    "updatedAt": "2025-11-29T14:09:45.362Z"
  },
  {
    "id": "Ufv7EZqWdDAfSLLQBk2B",
    "key": "if_your_order_arrives_damaged",
    "source": "If your order arrives damaged:",
    "translations": {
      "en": "If your order arrives damaged:",
      "fr": "Si votre commande arrive endommagée :",
      "de": "Wenn Ihre Bestellung beschädigt ankommt:",
      "es": "Si tu pedido llega dañado:",
      "uk": "Якщо замовлення прибуло пошкодженим:"
    },
    "createdAt": "2025-12-04T13:01:35.475Z",
    "updatedAt": "2025-12-04T13:01:35.475Z"
  },
  {
    "id": "DxPHydRY6FuZlG003xMS",
    "key": "if_your_order_arrives_damaged_please_contact_me_within",
    "source": "If your order arrives damaged, please contact me within",
    "translations": {
      "en": "If your order arrives damaged, please contact me within",
      "fr": "Si votre commande arrive endommagée, veuillez me contacter dans les",
      "de": "Sollte Ihre Bestellung beschädigt bei Ihnen eintreffen, kontaktieren Sie mich bitte innerhalb von 24 Stunden",
      "es": "Si su pedido llega dañado, comuníquese conmigo dentro de",
      "uk": "Якщо ваше замовлення надійде пошкодженим, зв’яжіться зі мною протягом"
    },
    "createdAt": "2025-11-27T15:06:43.670Z",
    "updatedAt": "2025-11-27T15:06:43.670Z"
  },
  {
    "id": "wh4yVQsbBn9J4dtJJqHq",
    "key": "if_your_order_is_significantly_delayed_or_lost_please_reach_out_to_me_at",
    "source": "If your order is significantly delayed or lost, please reach out to me at",
    "translations": {
      "en": "If your order is significantly delayed or lost, please reach out to me at",
      "fr": "Si votre commande est considérablement retardée ou perdue, veuillez me contacter au",
      "de": "Sollte sich Ihre Bestellung erheblich verzögern oder verloren gehen, kontaktieren Sie mich bitte unter",
      "es": "Si su pedido se retrasa significativamente o se pierde, comuníquese conmigo al",
      "uk": "Якщо ваше замовлення значно затримано або втрачено, зв’яжіться зі мною за адресою"
    },
    "createdAt": "2025-11-27T15:09:37.163Z",
    "updatedAt": "2025-11-27T15:09:37.163Z"
  },
  {
    "id": "597SbNhwPOah3PlCpRRf",
    "key": "in_the_middle_of_a_hard_winter_in_ukraine_love_learns_to_be_quiet_but_it_doesn_t",
    "source": "In the middle of a hard winter in Ukraine, love learns to be quiet — but it doesn’t disappear. It becomes a warmth you can hold. Our fluffy companions don’t ask for explanations, they simply stay close, reminding us to live, to keep going, offering a kind of support that feels like home even when home is far from peaceful. This piece is about that cozy kind of love: gentle, stubborn, and real — a Valentine’s reminder that tenderness isn’t weakness, it’s how we survive, and how we stay human.",
    "translations": {
      "en": "In the middle of a hard winter in Ukraine, love learns to be quiet — but it doesn’t disappear. It becomes a warmth you can hold. Our fluffy companions don’t ask for explanations, they simply stay close, reminding us to live, to keep going, offering a kind of support that feels like home even when home is far from peaceful. This piece is about that cozy kind of love: gentle, stubborn, and real — a Valentine’s reminder that tenderness isn’t weakness, it’s how we survive, and how we stay human.",
      "fr": "Au milieu d’un hiver rigoureux en Ukraine, l’amour apprend à se taire – mais il ne disparaît pas. Cela devient une chaleur que vous pouvez retenir. Nos compagnons pelucheux ne demandent pas d’explications, ils restent simplement proches, nous rappelant de vivre, de continuer, offrant une sorte de soutien qui nous fait sentir comme à la maison même lorsque la maison est loin d’être paisible. Cette pièce parle de ce genre d’amour douillet : doux, têtu et réel – un rappel pour la Saint-Valentin que la tendresse n’est pas une faiblesse, c’est la façon dont nous survivons et comment nous restons humains.",
      "de": "Mitten in einem harten Winter in der Ukraine lernt die Liebe, still zu sein – aber sie verschwindet nicht. Es entsteht eine Wärme, die man halten kann. Unsere flauschigen Begleiter verlangen keine Erklärungen, sie bleiben einfach in unserer Nähe, erinnern uns daran, zu leben, weiterzumachen und bieten eine Art Unterstützung, die uns wie ein Zuhause anfühlt, auch wenn es zu Hause alles andere als friedlich ist. In diesem Stück geht es um diese gemütliche Art der Liebe: sanft, hartnäckig und echt – eine Erinnerung zum Valentinstag daran, dass Zärtlichkeit keine Schwäche ist, sondern die Art und Weise, wie wir überleben und menschlich bleiben.",
      "es": "En medio de un duro invierno en Ucrania, el amor aprende a estar tranquilo, pero no desaparece. Se convierte en una calidez que puedes retener. Nuestros peludos compañeros no piden explicaciones, simplemente permanecen cerca, recordándonos que vivamos, que sigamos adelante, ofreciendo una especie de apoyo que nos hace sentir como en casa, incluso cuando el hogar está lejos de ser pacífico. Esta pieza trata sobre ese tipo de amor acogedor: gentil, obstinado y real: un recordatorio de San Valentín de que la ternura no es debilidad, es la forma en que sobrevivimos y nos mantenemos humanos.",
      "uk": "Посеред суворої зими в Україні кохання вчиться бути тихим, але воно не зникає. Воно стає теплом, яке можна обійняти. Наші пухнасті компаньйони не просять пояснень, вони просто залишаються поруч, нагадуючи нам жити, рухатися вперед, пропонуючи таку підтримку, яка відчувається як дім, навіть коли вдома далеко не спокійно. Цей твір про таке затишне кохання: ніжне, вперте та справжнє — нагадування до Дня святого Валентина, що ніжність — це не слабкість, це те, як ми виживаємо і як ми залишаємося людьми."
    },
    "createdAt": "2026-01-28T10:51:12.060Z",
    "updatedAt": "2026-01-28T10:51:12.060Z"
  },
  {
    "id": "S2BIno31dK9D7UYPWqcG",
    "key": "information_we_collect_about_your_usage",
    "source": "Information we collect about your usage",
    "translations": {
      "en": "Information we collect about your usage",
      "fr": "Informations que nous collectons sur votre utilisation",
      "de": "Informationen, die wir über Ihre Nutzung sammeln",
      "es": "Información que recopilamos sobre su uso",
      "uk": "Інформація, яку ми збираємо про ваше використання сайту"
    },
    "createdAt": "2025-12-05T09:28:35.976Z",
    "updatedAt": "2025-12-05T09:28:35.976Z"
  },
  {
    "id": "7ZEO5kiXMbjIKayKl4IQ",
    "key": "information_we_collect_directly_from_you",
    "source": "Information we collect directly from you",
    "translations": {
      "en": "Information we collect directly from you",
      "fr": "Informations que nous collectons directement auprès de vous",
      "de": "Informationen, die wir direkt von Ihnen sammeln",
      "es": "Información que recopilamos directamente de usted",
      "uk": "Інформація, яку ми збираємо безпосередньо від вас"
    },
    "createdAt": "2025-12-05T09:28:01.820Z",
    "updatedAt": "2025-12-05T09:28:01.820Z"
  },
  {
    "id": "z6Rm5o3Qfhbp8ls03cx4",
    "key": "information_we_obtain_from_third_parties",
    "source": "Information we obtain from third parties",
    "translations": {
      "en": "Information we obtain from third parties",
      "fr": "Informations que nous obtenons de tiers",
      "de": "Informationen, die wir von Dritten erhalten",
      "es": "Información que obtenemos de terceros",
      "uk": "Інформація, яку ми отримуємо від третіх сторін"
    },
    "createdAt": "2025-12-05T09:31:45.421Z",
    "updatedAt": "2025-12-05T09:31:45.421Z"
  },
  {
    "id": "nplgaQowmr4m1TVjbbPY",
    "key": "ink",
    "source": "Ink",
    "translations": {
      "en": "Ink",
      "fr": "Encre",
      "de": "Tinte",
      "es": "Tinta",
      "uk": "Чорнило"
    },
    "createdAt": "2025-11-27T10:50:09.091Z",
    "updatedAt": "2025-11-27T10:50:09.091Z"
  },
  {
    "id": "47NsNQTxBXYc20qnlkyG",
    "key": "international_users",
    "source": "International users",
    "translations": {
      "en": "International users",
      "fr": "Utilisateurs internationaux",
      "de": "Internationale Benutzer",
      "es": "Usuarios internacionales",
      "uk": "Міжнародні користувачі"
    },
    "createdAt": "2025-12-05T09:49:58.602Z",
    "updatedAt": "2025-12-05T09:49:58.602Z"
  },
  {
    "id": "ZzaLUApqmgsPDUsMFXTV",
    "key": "irises",
    "source": "Irises",
    "translations": {
      "en": "Irises",
      "fr": "Iris",
      "de": "Iris",
      "es": "lirios",
      "uk": "Іриси"
    },
    "createdAt": "2025-11-27T11:18:38.464Z",
    "updatedAt": "2025-11-27T11:18:38.464Z"
  },
  {
    "id": "HbdoECmXaIGCVYK8YHRt",
    "key": "is_in_its_original_condition",
    "source": "is in its original condition,",
    "translations": {
      "en": "is in its original condition,",
      "fr": "est dans son état d'origine,",
      "de": "ist im Originalzustand,",
      "es": "está en su estado original,",
      "uk": "не має пошкоджень,"
    },
    "createdAt": "2025-12-04T12:56:54.083Z",
    "updatedAt": "2025-12-04T12:56:54.083Z"
  },
  {
    "id": "9ji1ieDn1qjhBdaHoxyc",
    "key": "is_returned_in_secure_protective_packaging",
    "source": "is returned in secure protective packaging.",
    "translations": {
      "en": "is returned in secure protective packaging.",
      "fr": "est retourné dans un emballage de protection sécurisé.",
      "de": "wird in einer sicheren Schutzverpackung zurückgesandt.",
      "es": "se devuelve en un embalaje protector seguro.",
      "uk": "повернена у надійному пакуванні."
    },
    "createdAt": "2025-12-04T12:58:02.377Z",
    "updatedAt": "2025-12-04T12:58:02.377Z"
  },
  {
    "id": "ZhQRfP4ezeromYGJU1kB",
    "key": "item",
    "source": "item",
    "translations": {
      "en": "item",
      "fr": "article",
      "de": "Artikel",
      "es": "artículo",
      "uk": "пункт"
    },
    "createdAt": "2025-11-27T14:08:23.329Z",
    "updatedAt": "2025-11-27T14:08:23.329Z"
  },
  {
    "id": "dUnSjibooohFkj08Igyt",
    "key": "journal",
    "source": "Journal",
    "translations": {
      "en": "Journal",
      "fr": "Journal",
      "de": "Zeitschrift",
      "es": "Diario",
      "uk": "Журнал"
    },
    "createdAt": "2025-12-05T20:02:44.485Z",
    "updatedAt": "2025-12-05T20:02:44.485Z"
  },
  {
    "id": "6Knf7sDgZtaNb5idP5nT",
    "key": "karina",
    "source": "Karina",
    "translations": {
      "en": "Karina",
      "fr": "Karine",
      "de": "Karina",
      "es": "Karina",
      "uk": "Карина"
    },
    "createdAt": "2025-12-05T10:28:21.225Z",
    "updatedAt": "2025-12-05T10:28:21.225Z"
  },
  {
    "id": "KNEoJ5Y9phSqysR5sGdQ",
    "key": "krakow_poland",
    "source": "Krakow, Poland",
    "translations": {
      "en": "Krakow, Poland",
      "fr": "Cracovie, Pologne",
      "de": "Krakau, Polen",
      "es": "Cracovia, Polonia",
      "uk": "Краків, Польща"
    },
    "createdAt": "2025-12-05T15:06:18.123Z",
    "updatedAt": "2025-12-05T15:06:18.123Z"
  },
  {
    "id": "hvn5hpKRb184XeSE0Cct",
    "key": "legal_notice",
    "source": "Legal Notice",
    "translations": {
      "en": "Legal Notice",
      "fr": "Mentions légales",
      "de": "Rechtlicher Hinweis",
      "es": "Aviso Legal",
      "uk": "Юридична інформація"
    },
    "createdAt": "2025-11-27T11:27:18.236Z",
    "updatedAt": "2025-11-27T11:27:18.236Z"
  },
  {
    "id": "FIFODCqXtnWjdomQlu8X",
    "key": "legal_notice_terms_of_service",
    "source": "Legal notice / Terms of Service",
    "translations": {
      "en": "Legal notice / Terms of Service",
      "fr": "Mentions légales / Conditions d'utilisation",
      "de": "Rechtlicher Hinweis / Nutzungsbedingungen",
      "es": "Aviso legal / Términos de servicio",
      "uk": "Юридична інформація / Умови надання послуг"
    },
    "createdAt": "2025-12-04T13:35:03.493Z",
    "updatedAt": "2025-12-04T13:35:03.493Z"
  },
  {
    "id": "3g40V5A85m6Pm29fsfqc",
    "key": "lets_connect",
    "source": "Let's connect",
    "translations": {
      "en": "Let's connect",
      "fr": "Connectons-nous",
      "de": "Lassen Sie uns verbinden",
      "es": "conectemos",
      "uk": "Будемо на зв'язку"
    },
    "createdAt": "2025-11-27T13:27:29.509Z",
    "updatedAt": "2025-11-27T13:27:29.509Z"
  },
  {
    "id": "mqdIbavunxA2Jbp9sTRy",
    "key": "lily",
    "source": "Lily",
    "translations": {
      "en": "Lily",
      "fr": "Lis",
      "de": "Lilie",
      "es": "Lirio",
      "uk": "Лілу"
    },
    "createdAt": "2025-12-05T10:02:55.838Z",
    "updatedAt": "2025-12-05T10:02:55.838Z"
  },
  {
    "id": "vcwciyxduKMdcYAJZVWV",
    "key": "lost_or_delayed_packages",
    "source": "Lost or Delayed Packages",
    "createdAt": "2025-11-27T14:43:47.842Z",
    "translations": {
      "en": "Lost or Delayed Packages",
      "fr": "Colis perdus ou retardés",
      "de": "Verlorene oder verspätete Pakete",
      "es": "Paquetes perdidos o retrasados",
      "uk": "Втрачені або затримані посилки"
    },
    "updatedAt": "2025-11-27T15:12:33.516Z"
  },
  {
    "id": "3odrI5M2WXPcMahIK2Ig",
    "key": "love_often_lives_in_the_smallest_things_this_painting_is_about_being_close_about",
    "source": "Love often lives in the smallest things. This painting is about being close, about choosing to share, and about the warmth that appears when the right one is by your side. Soft tones and expressive brushstrokes capture a feeling of intimacy, trust, and togetherness. An ideal gift for someone you love — a unique piece for those who truly appreciate art. Touch the paint, feel the texture, and take a moment to simply enjoy the beauty.",
    "translations": {
      "en": "Love often lives in the smallest things. This painting is about being close, about choosing to share, and about the warmth that appears when the right one is by your side. Soft tones and expressive brushstrokes capture a feeling of intimacy, trust, and togetherness. An ideal gift for someone you love — a unique piece for those who truly appreciate art. Touch the paint, feel the texture, and take a moment to simply enjoy the beauty.",
      "fr": "L'amour vit souvent dans les plus petites choses. Cette peinture parle d'être proche, de choisir de partager et de la chaleur qui apparaît lorsque la bonne personne est à vos côtés. Les tons doux et les coups de pinceau expressifs capturent un sentiment d’intimité, de confiance et de convivialité. Un cadeau idéal pour quelqu'un que vous aimez — une pièce unique pour ceux qui apprécient vraiment l'art. Touchez la peinture, ressentez la texture et prenez un moment pour simplement profiter de la beauté.",
      "de": "Liebe lebt oft in den kleinsten Dingen. In diesem Gemälde geht es um Nähe, um die Entscheidung zum Teilen und um die Wärme, die entsteht, wenn der Richtige an Ihrer Seite ist. Sanfte Töne und ausdrucksstarke Pinselstriche vermitteln ein Gefühl von Intimität, Vertrauen und Zusammengehörigkeit. Ein ideales Geschenk für jemanden, den Sie lieben – ein einzigartiges Stück für diejenigen, die Kunst wirklich schätzen. Berühren Sie die Farbe, spüren Sie die Textur und nehmen Sie sich einen Moment Zeit, um einfach die Schönheit zu genießen.",
      "es": "El amor muchas veces vive en las cosas más pequeñas. Este cuadro trata de estar cerca, de elegir compartir y de la calidez que aparece cuando la persona adecuada está a tu lado. Los tonos suaves y las pinceladas expresivas capturan un sentimiento de intimidad, confianza y unión. Un regalo ideal para alguien a quien amas: una pieza única para quienes realmente aprecian el arte. Toca la pintura, siente la textura y tómate un momento para simplemente disfrutar de la belleza.",
      "uk": "Любов часто живе в найменших речах. Ця картина про близькість, про вибір поділитися та про тепло, яке з’являється, коли поруч з тобою правильна людина. М’які тони та виразні мазки передають відчуття близькості, довіри та єдності. Ідеальний подарунок для коханої людини — унікальний твір для тих, хто справді цінує мистецтво. Доторкніться до фарби, відчуйте її текстуру та просто насолодіться красою."
    },
    "createdAt": "2026-01-23T16:45:06.951Z",
    "updatedAt": "2026-01-23T16:45:06.951Z"
  },
  {
    "id": "3us9yVwx3kwzm1hVFrT6",
    "key": "loved_by_pet_parents_everywhere",
    "source": "Loved by Pet Parents Everywhere",
    "createdAt": "2025-12-05T10:41:15.952Z",
    "translations": {
      "en": "Loved by Pet Parents Everywhere",
      "fr": "Aimé par les parents d'animaux de compagnie du monde entier",
      "de": "Von Tierhaltern auf der ganzen Welt geliebt",
      "es": "Amado por los padres de mascotas en todas partes",
      "uk": "Відгуки від власників домашніх улюбленців з усього світу"
    },
    "updatedAt": "2025-12-05T15:19:13.254Z"
  },
  {
    "id": "dQZiFdHZ56CDKh4ayq44",
    "key": "luna",
    "source": "Luna",
    "translations": {
      "en": "Luna",
      "fr": "Lune",
      "de": "Luna",
      "es": "luna",
      "uk": "Луна"
    },
    "createdAt": "2025-12-05T10:20:08.041Z",
    "updatedAt": "2025-12-05T10:20:08.041Z"
  },
  {
    "id": "kRM5GOlQ5dgdOsLWkSqq",
    "key": "made_my_day_thank_you_for_your_art",
    "createdAt": "2025-12-05T10:46:05.156Z",
    "translations": {
      "en": "Made my day, thank you for your art!",
      "fr": "J'ai fait ma journée, merci pour votre art!",
      "de": "Hat meinen Tag gemacht, danke für deine Kunst!",
      "es": "Me alegró el día, ¡gracias por tu arte!",
      "uk": "Малюнок підняв настрій, дякую за ваше мистецтво!"
    },
    "source": "Made my day, thank you for your art!",
    "updatedAt": "2025-12-05T15:11:57.588Z"
  },
  {
    "id": "vsb65pEz5mwYO224nezL",
    "key": "magic_peacock",
    "source": "Magic peacock",
    "translations": {
      "en": "Magic peacock",
      "fr": "Paon magique",
      "de": "Magischer Pfau",
      "es": "pavo real magico",
      "uk": "Чарівний павич"
    },
    "createdAt": "2025-12-05T10:02:06.797Z",
    "updatedAt": "2025-12-05T10:02:06.797Z"
  },
  {
    "id": "fOEyxMJYwj02D6uLQFHb",
    "key": "mandys_owner_berlin_germany",
    "source": "Mandy's owner · Berlin, Germany",
    "translations": {
      "en": "Mandy's owner · Berlin, Germany",
      "fr": "Propriétaire de Mandy · Berlin, Allemagne",
      "de": "Mandys Besitzer · Berlin, Deutschland",
      "es": "Dueño de Mandy · Berlín, Alemania",
      "uk": "Власниця Менді · Берлін, Німеччина"
    },
    "createdAt": "2025-12-05T10:27:51.460Z",
    "updatedAt": "2025-12-05T10:27:51.460Z"
  },
  {
    "id": "L6yBOa1lP9W0zj3RyE6o",
    "key": "many_thanks_delivery_was_smooth_in_real_life_portrait_looks_even_better",
    "createdAt": "2025-12-05T10:45:20.486Z",
    "translations": {
      "en": "Many thanks, delivery was smooth, in real life portrait looks even better!",
      "fr": "Merci beaucoup, la livraison s'est bien déroulée, le portrait en vrai est encore meilleur !",
      "de": "Vielen Dank, die Lieferung verlief reibungslos, im echten Leben sieht das Porträt noch besser aus!",
      "es": "Muchas gracias, la entrega fue fluida, ¡en la vida real el retrato se ve aún mejor!",
      "uk": "Дуже дякую, доставка пройшла без проблем, у реальному житті портрет виглядає ще краще!"
    },
    "source": "Many thanks, delivery was smooth, in real life portrait looks even better!",
    "updatedAt": "2025-12-05T15:24:06.420Z"
  },
  {
    "id": "jCUzipny9NR209Va8xkR",
    "key": "mariia",
    "source": "Mariia",
    "translations": {
      "en": "Mariia",
      "fr": "Marie",
      "de": "Mariia",
      "es": "maria",
      "uk": "Марія"
    },
    "createdAt": "2025-12-05T15:14:19.137Z",
    "updatedAt": "2025-12-05T15:14:19.137Z"
  },
  {
    "id": "XPSGSZotmBXBC8ziAL0z",
    "key": "marketing_and_advertising_sending_promotional_communications_and_tailoring_ads_w",
    "source": "Marketing and advertising: sending promotional communications and tailoring ads (where permitted). EEA legal basis: legitimate interest in selling products (Art. 6(1)(f) GDPR).",
    "translations": {
      "en": "Marketing and advertising: sending promotional communications and tailoring ads (where permitted). EEA legal basis: legitimate interest in selling products (Art. 6(1)(f) GDPR).",
      "fr": "Marketing et publicité : envoi de communications promotionnelles et personnalisation d'annonces (lorsque cela est autorisé). Base juridique de l'EEE : intérêt légitime à vendre des produits (article 6, paragraphe 1, point f) du RGPD).",
      "de": "Marketing und Werbung: Versenden von Werbemitteilungen und maßgeschneiderte Anzeigen (sofern zulässig). EWR-Rechtsgrundlage: berechtigtes Interesse am Verkauf von Produkten (Art. 6 Abs. 1 lit. f DSGVO).",
      "es": "Marketing y publicidad: envío de comunicaciones promocionales y personalización de anuncios (cuando esté permitido). Base jurídica del EEE: interés legítimo en vender productos (Art. 6(1)(f) GDPR).",
      "uk": "Маркетинг і реклама: розсилка рекламних повідомлень і адаптація оголошень (де це дозволено). Правова основа ЄЕЗ: законний інтерес до продажу продукції (ст. 6(1)(f) GDPR)."
    },
    "createdAt": "2025-12-05T09:34:43.870Z",
    "updatedAt": "2025-12-05T09:34:43.870Z"
  },
  {
    "id": "11DgO32sXvB5v7A2AqEI",
    "key": "mars",
    "source": "Mars",
    "translations": {
      "en": "Mars",
      "fr": "Mars",
      "de": "Mars",
      "es": "Marte",
      "uk": "Марс"
    },
    "createdAt": "2025-12-04T11:46:54.616Z",
    "updatedAt": "2025-12-04T11:46:54.616Z"
  },
  {
    "id": "qYadFZ4ZBn4FIEq7Pf5V",
    "key": "medium",
    "source": "Medium",
    "translations": {
      "en": "Material",
      "fr": "Moyen",
      "de": "Material",
      "es": "Medio",
      "uk": "Матеріал"
    },
    "createdAt": "2025-11-27T15:18:14.181Z",
    "updatedAt": "2025-11-27T15:18:14.181Z"
  },
  {
    "id": "pkxJdy3NY0QJYMHaPxXI",
    "key": "message",
    "createdAt": "2025-11-27T13:32:39.756Z",
    "translations": {
      "en": "Message",
      "fr": "Message *",
      "de": "Nachricht",
      "es": "Mensaje *",
      "uk": "Повідомлення"
    },
    "source": "Message",
    "updatedAt": "2025-11-27T13:39:23.771Z"
  },
  {
    "id": "JWqRQ0ALa13cWolr3Yfp",
    "key": "midday_dream",
    "source": "Midday Dream",
    "translations": {
      "en": "Midday Dream",
      "fr": "Rêve de midi",
      "de": "Mittagstraum",
      "es": "Sueño de Mediodía",
      "uk": "Полуденний сон"
    },
    "createdAt": "2025-11-27T11:44:16.461Z",
    "updatedAt": "2025-11-27T11:44:16.461Z"
  },
  {
    "id": "0CvByFULuwZTFrIoZIu3",
    "key": "mountain_gaze",
    "source": "Mountain Gaze",
    "translations": {
      "en": "Mountain Gaze",
      "fr": "Regard sur la montagne",
      "de": "Bergblick",
      "es": "Mirada de montaña",
      "uk": "Гірський погляд"
    },
    "createdAt": "2025-11-27T11:26:24.582Z",
    "updatedAt": "2025-11-27T11:26:24.582Z"
  },
  {
    "id": "SpSmIm9H6uPjkK5oa6id",
    "key": "munich_germany",
    "source": "Munich, Germany",
    "translations": {
      "en": "Munich, Germany",
      "fr": "Munich, Allemagne",
      "de": "München, Deutschland",
      "es": "Múnich, Alemania",
      "uk": "Мюнхен, Німеччина"
    },
    "createdAt": "2025-12-05T15:07:25.917Z",
    "updatedAt": "2025-12-05T15:07:25.917Z"
  },
  {
    "id": "kB1u1PXwXL90QCSjlcCW",
    "key": "name",
    "source": "Name",
    "translations": {
      "en": "Name",
      "fr": "Nom",
      "de": "Name",
      "es": "Nombre",
      "uk": "Ім'я"
    },
    "createdAt": "2025-11-27T13:31:30.586Z",
    "updatedAt": "2025-11-27T13:31:30.586Z"
  },
  {
    "id": "Bnyme1q7at6WbxceRNh3",
    "key": "natasha",
    "source": "Natasha",
    "translations": {
      "en": "Natasha",
      "fr": "Natacha",
      "de": "Natascha",
      "es": "natasha",
      "uk": "Наташа"
    },
    "createdAt": "2025-12-05T15:14:08.257Z",
    "updatedAt": "2025-12-05T15:14:08.257Z"
  },
  {
    "id": "k3dofzs9q0PlKOFU37xd",
    "key": "nature",
    "source": "Nature",
    "translations": {
      "en": "Nature",
      "fr": "Nature",
      "de": "Natur",
      "es": "Naturaleza",
      "uk": "Природа"
    },
    "createdAt": "2025-11-27T11:12:58.625Z",
    "updatedAt": "2025-11-27T11:12:58.625Z"
  },
  {
    "id": "PZdCAsCEvHuwMk31WpoZ",
    "key": "need_to_adjust_an_address_upgrade_delivery_or_check_on_tracking_send_me_your_ord",
    "source": "Need to adjust an address, upgrade delivery, or check on tracking? Send me your order number, the name on the parcel, and any relevant dates so I can assist immediately. I monitor carriers daily and coordinate directly if anything is delayed. For detailed timelines please review the",
    "translations": {
      "en": "Need to adjust an address, upgrade delivery, or check on tracking? Send me your order number, the name on the parcel, and any relevant dates so I can assist immediately. I monitor carriers daily and coordinate directly if anything is delayed. For detailed timelines please review the",
      "fr": "Besoin de modifier une adresse, de mettre à niveau la livraison ou de vérifier le suivi ? Envoyez-moi votre numéro de commande, le nom sur le colis et toutes les dates pertinentes afin que je puisse vous aider immédiatement. Je surveille quotidiennement les transporteurs et coordonne directement en cas de retard. Pour des délais détaillés, veuillez consulter le",
      "de": "Müssen Sie eine Adresse anpassen, die Lieferung aktualisieren oder die Sendungsverfolgung überprüfen? Senden Sie mir Ihre Bestellnummer, den Namen auf dem Paket und alle relevanten Daten, damit ich sofort helfen kann. Ich überwache die Spediteure täglich und koordiniere sie direkt, wenn es zu Verzögerungen kommt. Detaillierte Zeitpläne finden Sie in der",
      "es": "¿Necesita ajustar una dirección, actualizar la entrega o verificar el seguimiento? Envíeme su número de pedido, el nombre del paquete y las fechas relevantes para que pueda ayudarle de inmediato. Superviso a los transportistas diariamente y coordino directamente si algo se retrasa. Para cronogramas detallados, revise el",
      "uk": "Потрібно змінити адресу, оновити доставку чи перевірити відстеження? Надішліть мені номер свого замовлення, назву посилки та відповідні дати, щоб я могла негайно допомогти. Я щоденно стежу за перевізниками та безпосередньо координую, якщо щось затримується. Щоб отримати докладні терміни, перегляньте"
    },
    "createdAt": "2025-11-29T14:01:52.743Z",
    "updatedAt": "2025-11-29T14:01:52.743Z"
  },
  {
    "id": "abwjTuCsEpMbpbyMoBYh",
    "key": "newest",
    "source": "Newest",
    "translations": {
      "en": "Newest",
      "fr": "Le plus récent",
      "de": "Neueste",
      "es": "El más nuevo",
      "uk": "Найновіший"
    },
    "createdAt": "2025-12-05T15:43:25.020Z",
    "updatedAt": "2025-12-05T15:43:25.020Z"
  },
  {
    "id": "h2MD19kDYbWcPNgKPOHT",
    "key": "non_returnable_and_non_refundable",
    "source": "non-returnable and non-refundable.",
    "translations": {
      "en": "non-returnable and non-refundable.",
      "fr": "non retournable et non remboursable.",
      "de": "Vom Umtausch ausgeschlossen und nicht erstattungsfähig.",
      "es": "No retornables y no reembolsables.",
      "uk": "не підлягають поверненню та відшкодуванню."
    },
    "createdAt": "2025-12-04T12:51:40.675Z",
    "updatedAt": "2025-12-04T12:51:40.675Z"
  },
  {
    "id": "lIQooyc61u0gMzUrBV9V",
    "key": "not_printed_not_filtered_through_ai_every_custom_pet_portrait_from_chizhart_is_p",
    "source": "Not printed. Not filtered through AI. Every custom pet portrait from ChizhArt is painted by hand — one brushstroke at a time — from the photo you share. Your dog’s eyes, your cat’s fur pattern, the exact tilt of their head: it all makes it onto the canvas, because someone who loves painting animals spent hours making sure it did.",
    "createdAt": "2026-05-20T11:22:53.213Z",
    "translations": {
      "en": "Not printed. Not filtered through AI. Every custom pet portrait from ChizhArt is painted by hand — one brushstroke at a time — from the photo you share. Your dog’s eyes, your cat’s fur pattern, the exact tilt of their head: it all makes it onto the canvas, because someone who loves painting animals spent hours making sure it did.",
      "fr": "Pas d'impression. Pas d'intelligence artificielle. Chaque portrait personnalisé de ChizhArt est peint à la main — coup de pinceau après coup de pinceau — à partir de la photo que vous nous confiez. Le regard de votre chien, le pelage de votre chat, l'inclinaison exacte de sa tête : tout est là, sur la toile, parce qu'une artiste qui aime les animaux y a consacré des heures avec soin et passion.",
      "de": "Nicht gedruckt. Nicht von KI erzeugt. Jedes individuelle Haustierporträt von ChizhArt entsteht von Hand – Pinselstrich für Pinselstrich – nach dem Foto, das Sie einsenden. Die Augen Ihres Hundes, das Fellmuster Ihrer Katze, die ganz eigene Haltung des Kopfes: All das findet seinen Weg auf die Leinwand, weil jemand, der Tiere mit echter Leidenschaft malt, stundenlang dafür gearbeitet hat.",
      "es": "Sin impresión. Sin inteligencia artificial. Cada retrato de mascota personalizado de ChizhArt se pinta a mano, pincelada a pincelada, a partir de la foto que compartes. Los ojos de tu perro, el pelaje de tu gato, la inclinación exacta de su cabeza: todo queda plasmado en el lienzo, porque alguien que ama pintar animales dedicó horas a que así fuera.",
      "uk": "Не роздруківка — живопис. Не нейромережа — людська рука. Кожен портрет від ChizhArt написаний пензлем, мазок за мазком, з вашого фото. Погляд вашого пса, малюнок шерсті кота, та сама знайома поза — художник переносить це на полотно годинами, бо справжня любов до тварин не поспішає."
    },
    "updatedAt": "2026-05-20T12:04:17.644Z"
  },
  {
    "id": "r9LxNqvMV2ImetJorpB6",
    "key": "obtain_portability_withdraw_consent_or_appeal_decisions",
    "source": "Obtain portability, withdraw consent, or appeal decisions.",
    "translations": {
      "en": "Obtain portability, withdraw consent, or appeal decisions.",
      "fr": "Obtenez la portabilité, retirez votre consentement ou faites appel des décisions.",
      "de": "Erhalten Sie Portabilität, widerrufen Sie die Einwilligung oder legen Sie gegen Entscheidungen Berufung ein.",
      "es": "Obtener portabilidad, retirar el consentimiento o apelar decisiones.",
      "uk": "Отримати перенесення данних, відкликати згоду або оскаржити рішення."
    },
    "createdAt": "2025-12-05T09:48:00.684Z",
    "updatedAt": "2025-12-05T09:48:00.684Z"
  },
  {
    "id": "E9xNxdem2wbizn7rp4j9",
    "key": "odessa_chickens",
    "source": "Odessa Chickens",
    "translations": {
      "en": "Odessa Chickens",
      "fr": "Poulets d'Odessa",
      "de": "Odessa-Hühner",
      "es": "Pollos de Odesa",
      "uk": "Одеські Кури"
    },
    "createdAt": "2025-11-27T11:43:57.139Z",
    "updatedAt": "2025-11-27T11:43:57.139Z"
  },
  {
    "id": "vxkCG92InEevMfqFevhv",
    "key": "of_delivery_with_photos_and_ill_work_on_a_solution",
    "source": "of delivery with photos, and I'll work on a solution.",
    "translations": {
      "en": "- of delivery with photos, and I'll work on a solution.",
      "fr": "- de livraison avec photos, et je travaillerai sur une solution.",
      "de": "- Lieferung mit Fotos, und ich werde an einer Lösung arbeiten.",
      "es": "- de entrega con fotos, y trabajaré en una solución.",
      "uk": "- доставки з фото, і я буду працювати над рішенням."
    },
    "createdAt": "2025-11-27T15:08:16.020Z",
    "updatedAt": "2025-11-27T15:08:16.020Z"
  },
  {
    "id": "2sFZ0INjuqnM6W6jRVwT",
    "key": "oil",
    "source": "Oil",
    "createdAt": "2025-11-27T10:39:24.810Z",
    "translations": {
      "en": "Oil",
      "fr": "Huile",
      "de": "Öl",
      "es": "Aceite",
      "uk": "Олійні фарби"
    },
    "updatedAt": "2025-11-27T11:34:30.025Z"
  },
  {
    "id": "wPeIQNroY1mTEJ8oYezD",
    "key": "oil_and_ink_both_museum_quality",
    "source": "Oil and Ink, Both Museum-Quality",
    "createdAt": "2026-05-20T11:24:11.408Z",
    "translations": {
      "en": "Oil and Ink, Both Museum-Quality",
      "fr": "Huile ou encre — deux techniques de qualité muséale",
      "de": "Öl und Tusche – beide in Museumsqualität",
      "es": "Óleo y tinta, ambos con calidad museística",
      "uk": "Олія та туш — обидва музейної якості"
    },
    "updatedAt": "2026-05-20T11:49:48.734Z"
  },
  {
    "id": "4AUrjjMSZV1ynGnWnyQ9",
    "key": "oil_on_canvas_board",
    "source": "Oil on canvas board",
    "translations": {
      "en": "Oil on canvas board",
      "fr": "Huile sur carton toilé",
      "de": "Öl auf Leinwand",
      "es": "Óleo sobre lienzo",
      "uk": "Полотно, олія"
    },
    "createdAt": "2025-11-27T15:18:27.894Z",
    "updatedAt": "2025-11-27T15:18:27.894Z"
  },
  {
    "id": "TourtVLuFQhLcv7KnAXm",
    "key": "oil_on_panel",
    "source": "Oil on panel",
    "translations": {
      "en": "Oil on panel",
      "fr": "Huile sur panneau",
      "de": "Öl auf Holz",
      "es": "Óleo sobre tabla",
      "uk": "Олія на панелі"
    },
    "createdAt": "2025-11-27T15:20:16.944Z",
    "updatedAt": "2025-11-27T15:20:16.944Z"
  },
  {
    "id": "wa4afURZ2hBp2BerYUN5",
    "key": "olga",
    "source": "Olga",
    "translations": {
      "en": "Olga",
      "fr": "Olga",
      "de": "Olga",
      "es": "Olga",
      "uk": "Ольга"
    },
    "createdAt": "2025-12-05T15:09:43.795Z",
    "updatedAt": "2025-12-05T15:09:43.795Z"
  },
  {
    "id": "3afvxNaca8w6ti5wHILu",
    "key": "one_treat_two_hearts",
    "source": "One Treat, Two Hearts",
    "translations": {
      "en": "One Treat, Two Hearts",
      "fr": "Un régal, deux cœurs",
      "de": "Ein Leckerbissen, zwei Herzen",
      "es": "Un regalo, dos corazones",
      "uk": "Одні ласощі, два серця"
    },
    "createdAt": "2026-01-23T16:44:12.381Z",
    "updatedAt": "2026-01-23T16:44:12.381Z"
  },
  {
    "id": "4Fzgy4ciGmcPD8J0LnWC",
    "key": "online_store_terms",
    "source": "Online Store Terms",
    "translations": {
      "en": "Online Store Terms",
      "fr": "Conditions de la boutique en ligne",
      "de": "Online-Shop-Bedingungen",
      "es": "Términos de la tienda en línea",
      "uk": "Умови Інтернет-магазину"
    },
    "createdAt": "2025-12-04T14:40:03.384Z",
    "updatedAt": "2025-12-04T14:40:03.384Z"
  },
  {
    "id": "Bm9cjLYnzhP6bWe9WSN7",
    "key": "opt_out_of_sale_sharing_targeted_advertising_and_manage_communication_preference",
    "source": "Opt out of sale/sharing/targeted advertising and manage communication preferences.",
    "translations": {
      "en": "Opt out of sale/sharing/targeted advertising and manage communication preferences.",
      "fr": "Désactivez la vente/partage/publicité ciblée et gérez vos préférences de communication.",
      "de": "Deaktivieren Sie den Verkauf/das Teilen/gezielte Werbung und verwalten Sie die Kommunikationspräferenzen.",
      "es": "Optar por no vender/compartir/publicidad dirigida y gestionar las preferencias de comunicación.",
      "uk": "Відмову від продажу/поширення/цільової реклами та зміну налаштувань комунікації."
    },
    "createdAt": "2025-12-05T09:49:11.659Z",
    "updatedAt": "2025-12-05T09:49:11.659Z"
  },
  {
    "id": "yDbJulOxm2amlKR1vMcy",
    "key": "or_a_refund",
    "source": "or a refund.",
    "translations": {
      "en": "or a refund.",
      "fr": "ou un remboursement.",
      "de": "oder eine Rückerstattung.",
      "es": "o un reembolso.",
      "uk": "або повернення коштів."
    },
    "createdAt": "2025-12-04T13:12:48.227Z",
    "updatedAt": "2025-12-04T13:12:48.227Z"
  },
  {
    "id": "0pVnNzhdXP7MuWMU2mcp",
    "key": "or_drag_drop",
    "source": "or drag & drop",
    "translations": {
      "en": "or drag & drop",
      "fr": "ou glisser-déposer",
      "de": "oder per Drag & Drop",
      "es": "o arrastrar y soltar",
      "uk": "або перетягнути"
    },
    "createdAt": "2025-11-27T15:25:14.367Z",
    "updatedAt": "2025-11-27T15:25:14.367Z"
  },
  {
    "id": "Yj71fqOzf4tJGcG2d346",
    "key": "order_information_billing_shipping_address_payment_confirmation_email_phone",
    "source": "Order information: billing/shipping address, payment confirmation, email, phone.",
    "translations": {
      "en": "Order information: billing/shipping address, payment confirmation, email, phone.",
      "fr": "Informations sur la commande : adresse de facturation/expédition, confirmation de paiement, email, téléphone.",
      "de": "Bestellinformationen: Rechnungs-/Lieferadresse, Zahlungsbestätigung, E-Mail, Telefon.",
      "es": "Información del pedido: dirección de facturación/envío, confirmación de pago, correo electrónico, teléfono.",
      "uk": "Інформація про замовлення: адреса виставлення рахунку/доставки, підтвердження платежу, електронна адреса, телефон."
    },
    "createdAt": "2025-12-05T09:29:40.311Z",
    "updatedAt": "2025-12-05T09:29:40.311Z"
  },
  {
    "id": "LbHVRDLdqauzodAFAnkK",
    "key": "order_or_commission_number_if_available",
    "source": "Order or commission number (if available).",
    "translations": {
      "en": "Order or commission number (if available).",
      "fr": "Numéro de commande ou de commission (si disponible).",
      "de": "Auftrags- oder Kommissionsnummer (falls vorhanden).",
      "es": "Número de pedido o comisión (si está disponible).",
      "uk": "Номер замовлення або комісії (за наявності)."
    },
    "createdAt": "2025-11-29T14:13:17.706Z",
    "updatedAt": "2025-11-29T14:13:17.706Z"
  },
  {
    "id": "0TjPNXHRAYE5fdZStK9f",
    "key": "order_shipping_help",
    "source": "Order & shipping help",
    "translations": {
      "en": "Order & shipping help",
      "fr": "Aide à la commande et à l'expédition",
      "de": "Bestell- und Versandhilfe",
      "es": "Ayuda para pedidos y envíos",
      "uk": "Допомога із замовленням і доставкою"
    },
    "createdAt": "2025-11-29T14:01:08.850Z",
    "updatedAt": "2025-11-29T14:01:08.850Z"
  },
  {
    "id": "7pz1UIAbCSjZMn7Z3ZUR",
    "key": "original_artworks",
    "source": "Original Artworks",
    "translations": {
      "en": "Original Artworks",
      "fr": "Oeuvres originales",
      "de": "Originalkunstwerke",
      "es": "Obras de arte originales",
      "uk": "Авторські роботи"
    },
    "createdAt": "2025-11-27T10:58:24.550Z",
    "updatedAt": "2025-11-27T10:58:24.550Z"
  },
  {
    "id": "qk2sJ8Uu4RhFWy3hqz5r",
    "key": "original_oil_painting_hand_painted_on_a_round_canvas_20_cm_in_diameter_this_one_",
    "source": "Original oil painting . Hand-painted on a round canvas, 20 cm in diameter. This one-of-a-kind artwork adds warmth and softness to any interior and works beautifully as a small accent piece or meaningful gift. Available as an original painting. Perfect for cozy interiors, children’s rooms, or as a thoughtful gift.",
    "translations": {
      "en": "Original oil painting . Hand-painted on a round canvas, 20 cm in diameter. This one-of-a-kind artwork adds warmth and softness to any interior and works beautifully as a small accent piece or meaningful gift. Available as an original painting. Perfect for cozy interiors, children’s rooms, or as a thoughtful gift.",
      "fr": "Peinture à l'huile originale. Peint à la main sur une toile ronde de 20 cm de diamètre. Cette œuvre d'art unique en son genre ajoute de la chaleur et de la douceur à n'importe quel intérieur et fonctionne à merveille comme petite pièce décorative ou comme cadeau significatif. Disponible sous forme de peinture originale. Parfait pour les intérieurs confortables, les chambres d’enfants ou comme cadeau attentionné.",
      "de": "Originales Ölgemälde. Handgemalt auf einer runden Leinwand mit 20 cm Durchmesser. Dieses einzigartige Kunstwerk verleiht jedem Interieur Wärme und Weichheit und eignet sich wunderbar als kleines Akzentstück oder bedeutungsvolles Geschenk. Als Originalgemälde erhältlich. Perfekt für gemütliche Innenräume, Kinderzimmer oder als aufmerksames Geschenk.",
      "es": "Pintura al óleo original. Pintado a mano sobre lienzo redondo de 20 cm de diámetro. Esta obra de arte única agrega calidez y suavidad a cualquier interior y funciona maravillosamente como una pequeña pieza decorativa o un regalo significativo. Disponible como pintura original. Perfecto para interiores acogedores, habitaciones infantiles o como regalo.",
      "uk": "Оригінальна картина маслом. Ручний розпис на круглому полотні діаметром 20 см. Цей унікальний витвір мистецтва додає тепла та м’якості будь-якому інтер’єру та чудово працює як невеликий акцент або значимий подарунок. Доступна як оригінальна картина. Ідеально підходить для затишного інтер’єру, дитячої кімнати або як продуманий подарунок."
    },
    "createdAt": "2026-02-03T15:24:21.698Z",
    "updatedAt": "2026-02-03T15:24:21.698Z"
  },
  {
    "id": "9YoApw4HKhgpB27tgAI7",
    "key": "original_oil_painting_on_canvas_18_24_cm_7_9_in_this_one_of_a_kind_artwork_bring",
    "source": "Original oil painting on canvas, 18 × 24 cm (7 × 9 in). This one-of-a-kind artwork brings a sense of warmth, quiet presence, and natural balance to an interior. Soft color transitions and expressive brushwork create a calm, intimate atmosphere, making it a subtle yet meaningful accent for living spaces, bedrooms, or cozy corners. Available as an original artwork. Free worldwide shipping.",
    "translations": {
      "en": "Original oil painting on canvas, 18 × 24 cm (7 × 9 in). This one-of-a-kind artwork brings a sense of warmth, quiet presence, and natural balance to an interior. Soft color transitions and expressive brushwork create a calm, intimate atmosphere, making it a subtle yet meaningful accent for living spaces, bedrooms, or cozy corners. Available as an original artwork. Free worldwide shipping.",
      "fr": "Peinture à l'huile originale sur toile, 18 × 24 cm (7 × 9 po). Cette œuvre d’art unique en son genre apporte une sensation de chaleur, de présence silencieuse et d’équilibre naturel à un intérieur. Des transitions de couleurs douces et un travail de pinceau expressif créent une atmosphère calme et intime, ce qui en fait un accent subtil mais significatif pour les espaces de vie, les chambres ou les coins confortables. Disponible sous forme d’œuvre d’art originale. Livraison gratuite dans le monde entier.",
      "de": "Originales Ölgemälde auf Leinwand, 18 × 24 cm (7 × 9 Zoll). Dieses einzigartige Kunstwerk verleiht einem Innenraum ein Gefühl von Wärme, ruhiger Präsenz und natürlicher Ausgeglichenheit. Sanfte Farbübergänge und ausdrucksstarke Pinselführung schaffen eine ruhige, intime Atmosphäre und machen es zu einem subtilen, aber bedeutungsvollen Akzent für Wohnräume, Schlafzimmer oder gemütliche Ecken. Erhältlich als Originalkunstwerk. Kostenloser weltweiter Versand.",
      "es": "Pintura al óleo original sobre lienzo, 18 × 24 cm (7 × 9 pulgadas). Esta obra de arte única aporta una sensación de calidez, presencia tranquila y equilibrio natural a un interior. Las suaves transiciones de color y las pinceladas expresivas crean una atmósfera tranquila e íntima, lo que la convierte en un acento sutil pero significativo para espacios habitables, dormitorios o rincones acogedores. Disponible como obra de arte original. Envío gratuito a todo el mundo.",
      "uk": "Оригінальна картина маслом на полотні, 18 × 24 см (7 × 9 дюймів). Цей єдиний у своєму роді витвір мистецтва привносить в інтер’єр відчуття тепла, спокою та природного балансу. М’які переходи кольорів і виразний мазок створюють спокійну, інтимну атмосферу, роблячи його тонким, але значущим акцентом для житлових приміщень, спалень або затишних куточків. Доступний як оригінальний твір мистецтва. Безкоштовна доставка по всьому світу."
    },
    "createdAt": "2026-02-03T15:21:56.276Z",
    "updatedAt": "2026-02-03T15:21:56.276Z"
  },
  {
    "id": "3VjcsU5adovP857LkasK",
    "key": "original_oil_painting_on_canvas_20_20_cm_this_one_of_a_kind_artwork_brings_a_sen",
    "source": "Original oil painting on canvas, 20 × 20 cm. This one-of-a-kind artwork brings a sense of warmth, intimacy, and quiet balance to an interior. A small yet expressive piece that works beautifully as an accent in living spaces, bedrooms, or cozy corners. Available as an original artwork. Free worldwide shipping.",
    "translations": {
      "en": "Original oil painting on canvas, 20 × 20 cm. This one-of-a-kind artwork brings a sense of warmth, intimacy, and quiet balance to an interior. A small yet expressive piece that works beautifully as an accent in living spaces, bedrooms, or cozy corners. Available as an original artwork. Free worldwide shipping.",
      "fr": "Peinture originale à l'huile sur toile, 20 × 20 cm. Cette œuvre d’art unique en son genre apporte une sensation de chaleur, d’intimité et d’équilibre tranquille à un intérieur. Une pièce petite mais expressive qui fonctionne à merveille comme accent dans les espaces de vie, les chambres ou les coins confortables. Disponible sous forme d’œuvre d’art originale. Livraison gratuite dans le monde entier.",
      "de": "Original Ölgemälde auf Leinwand, 20 × 20 cm. Dieses einzigartige Kunstwerk verleiht einem Innenraum ein Gefühl von Wärme, Intimität und ruhiger Ausgeglichenheit. Ein kleines, aber ausdrucksstarkes Stück, das wunderbar als Akzent in Wohnräumen, Schlafzimmern oder gemütlichen Ecken wirkt. Erhältlich als Originalkunstwerk. Kostenloser weltweiter Versand.",
      "es": "Pintura original al óleo sobre lienzo, 20×20 cm. Esta obra de arte única aporta una sensación de calidez, intimidad y equilibrio tranquilo a un interior. Una pieza pequeña pero expresiva que funciona maravillosamente como acento en espacios habitables, dormitorios o rincones acogedores. Disponible como obra de arte original. Envío gratuito a todo el mundo.",
      "uk": "Оригінальна картина маслом на полотні 20 × 20 см. Цей унікальний витвір мистецтва привносить в інтер’єр відчуття тепла, інтимності та спокійної рівноваги. Невеликий, але виразний предмет, який чудово працює як акцент у житлових приміщеннях, спальнях або затишних куточках. Доступний як оригінальний твір мистецтва. Безкоштовна доставка по всьому світу."
    },
    "createdAt": "2026-02-03T15:23:33.069Z",
    "updatedAt": "2026-02-03T15:23:33.069Z"
  },
  {
    "id": "F7yjLw60rAKbKUEF3Vww",
    "key": "oslo_norwegian",
    "source": "Oslo, Norwegian",
    "translations": {
      "en": "Oslo, Norwegian",
      "fr": "Oslo, norvégien",
      "de": "Oslo, Norwegisch",
      "es": "Oslo, noruego",
      "uk": "Осло, Норвегія"
    },
    "createdAt": "2025-12-05T15:07:00.412Z",
    "updatedAt": "2025-12-05T15:07:00.412Z"
  },
  {
    "id": "AITAhJ8QbRfVk08gOIEA",
    "key": "our_site_may_link_to_third_party_platforms_we_do_not_control_review_their_privac",
    "source": "Our Site may link to third-party platforms we do not control. Review their privacy and security policies before engaging. Information you share on third-party platforms may be viewable by others; inclusion of links does not imply endorsement.",
    "translations": {
      "en": "Our Site may link to third-party platforms we do not control. Review their privacy and security policies before engaging. Information you share on third-party platforms may be viewable by others; inclusion of links does not imply endorsement.",
      "fr": "Notre Site peut créer des liens vers des plateformes tierces que nous ne contrôlons pas. Passez en revue leurs politiques de confidentialité et de sécurité avant de vous engager. Les informations que vous partagez sur des plateformes tierces peuvent être visibles par d'autres ; l’inclusion de liens n’implique pas l’approbation.",
      "de": "Unsere Website kann Links zu Plattformen Dritter enthalten, auf die wir keinen Einfluss haben. Überprüfen Sie deren Datenschutz- und Sicherheitsrichtlinien, bevor Sie sich engagieren. Informationen, die Sie auf Plattformen Dritter teilen, können für andere einsehbar sein; Die Aufnahme von Links stellt keine Billigung dar.",
      "es": "Nuestro Sitio puede vincularse a plataformas de terceros que no controlamos. Revise sus políticas de privacidad y seguridad antes de participar. La información que usted comparte en plataformas de terceros puede ser visible para otras personas; La inclusión de enlaces no implica aprobación.",
      "uk": "Наш Сайт може містити посилання на сторонні платформи. Ми не контролюємо їх і не несемо відповідальності за їхню політику конфіденційності чи контент.\nБудь-яка інформація, яку ви надаєте третім сторонам, може бути загальнодоступною."
    },
    "createdAt": "2025-12-05T09:43:46.506Z",
    "updatedAt": "2025-12-05T09:43:46.506Z"
  },
  {
    "id": "fMqHE4Wv0Vf44kspQx8u",
    "key": "overview",
    "source": "Overview",
    "translations": {
      "en": "Overview",
      "fr": "Aperçu",
      "de": "Überblick",
      "es": "Descripción general",
      "uk": "Огляд"
    },
    "createdAt": "2025-12-04T14:37:14.674Z",
    "updatedAt": "2025-12-04T14:37:14.674Z"
  },
  {
    "id": "y3TwZigOBHyEJE55I2jD",
    "key": "painted_from_your_photo_not_a_generic_template",
    "source": "Painted From Your Photo, Not a Generic Template",
    "createdAt": "2026-05-20T11:23:16.249Z",
    "translations": {
      "en": "Painted From Your Photo, Not a Generic Template",
      "fr": "Peint d'après votre photo, pas d'après un patron tout fait",
      "de": "Gemalt nach Ihrem Foto – ganz individuell, nicht von der Stange",
      "es": "Pintado a partir de tu foto, no de una plantilla genérica",
      "uk": "За вашим фото — не за шаблоном"
    },
    "updatedAt": "2026-05-20T11:49:48.205Z"
  },
  {
    "id": "n4hjQbxf4FuGbUXPk2V7",
    "key": "pay_with_monobank",
    "source": "Pay with Monobank",
    "translations": {
      "en": "Pay with Monobank",
      "fr": "Payer avec Monobank",
      "de": "Bezahlen Sie mit der Monobank",
      "es": "Paga con Monobanco",
      "uk": "Оплатіть через Monobank"
    },
    "createdAt": "2025-11-27T14:17:05.788Z",
    "updatedAt": "2025-11-27T14:17:05.788Z"
  },
  {
    "id": "d7GLrwvpjPJj46OdvxRM",
    "key": "payment",
    "source": "Payment",
    "translations": {
      "en": "Payment",
      "fr": "Paiement",
      "de": "Zahlung",
      "es": "Pago",
      "uk": "Оплата"
    },
    "createdAt": "2025-11-27T14:16:33.302Z",
    "updatedAt": "2025-11-27T14:16:33.302Z"
  },
  {
    "id": "vfjl2CRWI9JpO6preOVb",
    "key": "payment_methods",
    "source": "Payment methods:",
    "translations": {
      "en": "Payment methods:",
      "fr": "Modes de paiement :",
      "de": "Zahlungsarten:",
      "es": "Métodos de pago:",
      "uk": "Способи оплати:"
    },
    "createdAt": "2025-11-27T11:28:16.240Z",
    "updatedAt": "2025-11-27T11:28:16.240Z"
  },
  {
    "id": "fAhMjwCwatavWGDrb4JD",
    "key": "personal",
    "source": "Personal",
    "translations": {
      "en": "Personal",
      "fr": "Personnel",
      "de": "Persönlich",
      "es": "Personal",
      "uk": "Особисті"
    },
    "createdAt": "2025-11-27T11:21:37.773Z",
    "updatedAt": "2025-11-27T11:21:37.773Z"
  },
  {
    "id": "uYF3AlYuo6BmoKG4qQgp",
    "key": "personal_information_is_information_that_identifies_relates_to_describes_or_can_",
    "source": "“Personal information” is information that identifies, relates to, describes, or can be associated with you. What we collect depends on how you interact with the Site.",
    "translations": {
      "en": "“Personal information” is information that identifies, relates to, describes, or can be associated with you. What we collect depends on how you interact with the Site.",
      "fr": "Les « informations personnelles » sont des informations qui vous identifient, vous concernent, vous décrivent ou peuvent être associées à vous. Ce que nous collectons dépend de la manière dont vous interagissez avec le Site.",
      "de": "„Personenbezogene Daten“ sind Informationen, die Sie identifizieren, sich auf Sie beziehen, Sie beschreiben oder mit Ihnen in Verbindung gebracht werden können. Was wir sammeln, hängt davon ab, wie Sie mit der Website interagieren.",
      "es": "La “información personal” es información que lo identifica, se relaciona, describe o puede asociarse con usted. Lo que recopilamos depende de cómo interactúa con el Sitio.",
      "uk": "«Особиста інформація» – це інформація, яка ідентифікує вас, стосується вас, описує або може бути пов’язана з вами. Те, що ми збираємо, залежить від того, як ви взаємодієте з Сайтом."
    },
    "createdAt": "2025-12-05T09:23:49.671Z",
    "updatedAt": "2025-12-05T09:23:49.671Z"
  },
  {
    "id": "Rx92Zq1IGFQnKoij4kSN",
    "key": "pet_portraits",
    "source": "Pet portraits",
    "createdAt": "2025-12-04T11:45:22.450Z",
    "translations": {
      "en": "Pet portraits",
      "fr": "Portraits d'animaux",
      "de": "Haustierporträts",
      "es": "Retratos de mascotas",
      "uk": "Портрети домашніх улюбленців"
    },
    "updatedAt": "2025-12-05T15:40:01.321Z"
  },
  {
    "id": "Kfli1ujCfuSiOgi8reYO",
    "key": "phone_380958373364",
    "source": "Phone: +380958373364",
    "translations": {
      "en": "Phone: +380958373364",
      "fr": "Téléphone : +380958373364",
      "de": "Telefon: +380958373364",
      "es": "Teléfono: +380958373364",
      "uk": "Телефон: +380958373364"
    },
    "createdAt": "2025-12-04T15:00:29.668Z",
    "updatedAt": "2025-12-04T15:00:29.668Z"
  },
  {
    "id": "qzqh8geoyCGSBtM1wNfJ",
    "key": "phone_optional",
    "source": "Phone (optional)",
    "translations": {
      "en": "Phone (optional)",
      "fr": "Téléphone (facultatif)",
      "de": "Telefon (optional)",
      "es": "Teléfono (opcional)",
      "uk": "Телефон (необов'язково)"
    },
    "createdAt": "2025-11-27T13:32:08.861Z",
    "updatedAt": "2025-11-27T13:32:08.861Z"
  },
  {
    "id": "aVlPJCINVbL6GAmrkoQw",
    "key": "photos",
    "source": "photos",
    "translations": {
      "en": "photos",
      "fr": "des photos",
      "de": "Fotos",
      "es": "fotos",
      "uk": "фотографії"
    },
    "createdAt": "2025-11-27T14:13:41.713Z",
    "updatedAt": "2025-11-27T14:13:41.713Z"
  },
  {
    "id": "z23H9yygk9Vqz7Cb1Qwe",
    "key": "photos_or_reference_sketches_when_discussing_artwork_changes",
    "source": "Photos or reference sketches when discussing artwork changes.",
    "createdAt": "2025-11-29T14:13:54.613Z",
    "translations": {
      "en": "Photos or reference sketches when discussing artwork changes.",
      "fr": "Photos ou croquis de référence lorsque vous discutez de modifications artistiques.",
      "de": "Fotos oder Referenzskizzen bei der Besprechung von Grafikänderungen.",
      "es": "Fotos o bocetos de referencia cuando se habla de cambios en el arte.",
      "uk": "Фотографії або ескізи під час обговорення змін у замовленні."
    },
    "updatedAt": "2025-11-29T14:14:24.801Z"
  },
  {
    "id": "m5DGltSNWq19w2MLEUkg",
    "key": "planning_a_gift_deadline_tell_me_the_date_recipient_city_and_preferred_size_so_i",
    "source": "Planning a gift deadline? Tell me the date, recipient city, and preferred size so I can reserve a production slot and shipping window for you.",
    "translations": {
      "en": "Planning a gift deadline? Tell me the date, recipient city, and preferred size so I can reserve a production slot and shipping window for you.",
      "fr": "Vous prévoyez une date limite pour un cadeau ? Dites-moi la date, la ville du destinataire et la taille souhaitée afin que je puisse vous réserver un créneau de production et une fenêtre d'expédition.",
      "de": "Planen Sie einen Geschenktermin? Teilen Sie mir das Datum, die Empfängerstadt und die gewünschte Größe mit, damit ich einen Produktionsplatz und ein Versandfenster für Sie reservieren kann.",
      "es": "¿Está planeando una fecha límite para la donación? Dígame la fecha, la ciudad del destinatario y el tamaño preferido para que pueda reservarle un espacio de producción y una ventana de envío.",
      "uk": "Плануєте термін отримання подарунка? Повідомте мені дату, місто одержувача та бажаний розмір, щоб я міг зарезервувати для вас робоче місце та вікно доставки."
    },
    "createdAt": "2025-11-29T14:06:21.950Z",
    "updatedAt": "2025-11-29T14:06:21.950Z"
  },
  {
    "id": "UZtRC0LzkhonwZiVe6VM",
    "key": "please_read_these_terms_carefully_if_you_do_not_agree_to_them_you_may_not_access",
    "source": "Please read these Terms carefully. If you do not agree to them, you may not access the website or use our services. We may update these Terms from time to time; continued use of the site constitutes acceptance of any changes.",
    "translations": {
      "en": "Please read these Terms carefully. If you do not agree to them, you may not access the website or use our services. We may update these Terms from time to time; continued use of the site constitutes acceptance of any changes.",
      "fr": "Veuillez lire attentivement ces conditions. Si vous ne les acceptez pas, vous ne pourrez pas accéder au site Web ni utiliser nos services. Nous pouvons mettre à jour ces Conditions de temps à autre ; l'utilisation continue du site constitue l'acceptation de toute modification.",
      "de": "Bitte lesen Sie diese Bedingungen sorgfältig durch. Wenn Sie damit nicht einverstanden sind, dürfen Sie nicht auf die Website zugreifen oder unsere Dienste nutzen. Wir können diese Bedingungen von Zeit zu Zeit aktualisieren; Durch die fortgesetzte Nutzung der Website akzeptieren Sie etwaige Änderungen.",
      "es": "Lea atentamente estos Términos. Si no está de acuerdo con ellas, no podrá acceder al sitio web ni utilizar nuestros servicios. Podemos actualizar estos Términos de vez en cuando; El uso continuado del sitio constituye la aceptación de cualquier cambio.",
      "uk": "Будь ласка, уважно прочитайте ці Умови. Якщо ви не погоджуєтесь з ними, ви не можете отримувати доступ до сайту або користуватися нашими послугами. Ми можемо час від часу оновлювати ці Умови; подальше використання сайту означає вашу згоду з оновленнями."
    },
    "createdAt": "2025-12-04T14:39:27.356Z",
    "updatedAt": "2025-12-04T14:39:27.356Z"
  },
  {
    "id": "ru4NMnLHo8Xfikl6Qd0S",
    "key": "please_upload_at_least_one_reference_photo_before_paying",
    "source": "Please upload at least one reference photo before paying.",
    "translations": {
      "en": "Please upload at least one reference photo before paying.",
      "fr": "Veuillez télécharger au moins une photo de référence avant de payer.",
      "de": "Bitte laden Sie vor der Zahlung mindestens ein Referenzfoto hoch.",
      "es": "Sube al menos una foto de referencia antes de pagar.",
      "uk": "Перш ніж платити, завантажте принаймні одну референтну фотографію."
    },
    "createdAt": "2025-11-27T14:17:31.106Z",
    "updatedAt": "2025-11-27T14:17:31.106Z"
  },
  {
    "id": "wfTUDU6QC3qpSi01SthQ",
    "key": "png_or_jpg_max_20mb_each",
    "source": "PNG or JPG • max. 20MB each",
    "createdAt": "2025-11-27T14:14:26.656Z",
    "translations": {
      "en": "PNG, JPG or HEIC  • max. 20MB each",
      "fr": "PNG, JPG ou HEIC • max. 20 Mo chacun",
      "de": "PNG, JPG oder HEIC • max. Jeweils 20 MB",
      "es": "PNG, JPG o HEIC • máx. 20 MB cada uno",
      "uk": "PNG, JPG або HEIC • Макс. 20 МБ кожен"
    },
    "updatedAt": "2025-11-28T14:22:30.085Z"
  },
  {
    "id": "p8A0yeEe1aUNrGI6TRh9",
    "key": "preparing_for_christmass",
    "source": "Preparing for Christmass...",
    "translations": {
      "en": "Preparing for Christmass...",
      "fr": "Préparer Noël...",
      "de": "Vorbereitungen für Weihnachten...",
      "es": "Preparándonos para las Navidades...",
      "uk": "Підготовка до Різдва..."
    },
    "createdAt": "2025-11-27T10:51:09.379Z",
    "updatedAt": "2025-11-27T10:51:09.379Z"
  },
  {
    "id": "Y6e5mmqmfzYSc8g2YcVP",
    "key": "price_high_to_low",
    "source": "Price: High to Low",
    "translations": {
      "en": "Price: High to Low",
      "fr": "Prix : haut à bas",
      "de": "Preis: Hoch bis niedrig",
      "es": "Precio: de mayor a menor",
      "uk": "Ціна: від високої до низької"
    },
    "createdAt": "2025-12-05T15:44:36.170Z",
    "updatedAt": "2025-12-05T15:44:36.170Z"
  },
  {
    "id": "7YCCAbPpQHTdRXJKe4RE",
    "key": "price_low_to_High",
    "source": "Price: Low to High",
    "translations": {
      "en": "Price: Low to High",
      "fr": "Prix : faible à élevé",
      "de": "Preis: Niedrig bis hoch",
      "es": "Precio: de menor a mayor",
      "uk": "Ціна: від низької до високої"
    },
    "createdAt": "2025-12-05T15:43:59.389Z",
    "updatedAt": "2025-12-05T15:43:59.389Z"
  },
  {
    "id": "ZsXYnbgIEGplwHhsOIei",
    "key": "prices_for_our_products_are_subject_to_change_without_notice_we_may_modify_or_di",
    "source": "Prices for our products are subject to change without notice. We may modify or discontinue the Service (or any part/content) without notice at any time. We are not liable to you or any third party for modifications, price changes, suspension, or discontinuation of the Service.",
    "translations": {
      "en": "Prices for our products are subject to change without notice. We may modify or discontinue the Service (or any part/content) without notice at any time. We are not liable to you or any third party for modifications, price changes, suspension, or discontinuation of the Service.",
      "fr": "Les prix de nos produits sont sujets à changement sans préavis. Nous pouvons modifier ou interrompre le Service (ou toute partie/contenu) sans préavis à tout moment. Nous ne sommes pas responsables envers vous ou tout tiers des modifications, changements de prix, suspension ou interruption du Service.",
      "de": "Die Preise für unsere Produkte können ohne vorherige Ankündigung geändert werden. Wir können den Dienst (oder Teile/Inhalte) jederzeit und ohne Vorankündigung ändern oder einstellen. Wir haften Ihnen oder Dritten gegenüber nicht für Änderungen, Preisänderungen, Aussetzung oder Einstellung des Dienstes.",
      "es": "Los precios de nuestros productos están sujetos a cambios sin previo aviso. Podemos modificar o discontinuar el Servicio (o cualquier parte/contenido) sin previo aviso en cualquier momento. No somos responsables ante usted ni ante terceros por modificaciones, cambios de precios, suspensión o interrupción del Servicio.",
      "uk": "Ціни на наші товари можуть змінюватися без попередження. Ми можемо змінювати або припиняти роботу Сервісу (або будь-якої його частини/контенту) без попередження в будь-який момент. Ми не несемо відповідальності перед вами або будь-якою третьою стороною за модифікації, зміну цін, призупинення або припинення роботи Сервісу."
    },
    "createdAt": "2025-12-04T14:47:59.223Z",
    "updatedAt": "2025-12-04T14:47:59.223Z"
  },
  {
    "id": "nytatUYF59uEXZV2Mc8k",
    "key": "princess",
    "source": "Princess",
    "translations": {
      "en": "Princess",
      "fr": "Princesse",
      "de": "Prinzessin",
      "es": "Princesa",
      "uk": "Принцеса"
    },
    "createdAt": "2025-12-05T10:03:16.364Z",
    "updatedAt": "2025-12-05T10:03:16.364Z"
  },
  {
    "id": "jqC9vMgjCxCL9G6A5mCy",
    "key": "privacy",
    "source": "Privacy",
    "translations": {
      "en": "Privacy",
      "fr": "Confidentialité",
      "de": "Privatsphäre",
      "es": "Privacidad",
      "uk": "Конфіденційність"
    },
    "createdAt": "2025-12-04T14:53:42.719Z",
    "updatedAt": "2025-12-04T14:53:42.719Z"
  },
  {
    "id": "8WubLHybx49qj1xz9xfV",
    "key": "privacy_policy",
    "source": "Privacy Policy",
    "translations": {
      "en": "Privacy Policy",
      "fr": "politique de confidentialité",
      "de": "Datenschutzrichtlinie",
      "es": "política de privacidad",
      "uk": "Політика конфіденційності"
    },
    "createdAt": "2025-11-27T11:27:42.681Z",
    "updatedAt": "2025-11-27T11:27:42.681Z"
  },
  {
    "id": "S60MbZZ93PmeD1k95UFb",
    "key": "processing_time",
    "source": "Processing Time",
    "translations": {
      "en": "Processing Time",
      "fr": "Temps de traitement",
      "de": "Bearbeitungszeit",
      "es": "Tiempo de procesamiento",
      "uk": "Час обробки"
    },
    "createdAt": "2025-11-27T14:40:16.194Z",
    "updatedAt": "2025-11-27T14:40:16.194Z"
  },
  {
    "id": "CD7P1I1L8FDkWRcVnc6S",
    "key": "products_pricing_and_changes",
    "source": "Products, Pricing, and Changes",
    "translations": {
      "en": "Products, Pricing, and Changes",
      "fr": "Produits, prix et modifications",
      "de": "Produkte, Preise und Änderungen",
      "es": "Productos, precios y cambios",
      "uk": "Товари, ціни та зміни"
    },
    "createdAt": "2025-12-04T14:46:24.987Z",
    "updatedAt": "2025-12-04T14:46:24.987Z"
  },
  {
    "id": "XkYoqPm4UuFy3bAJ5XEi",
    "key": "prohibited_uses",
    "source": "Prohibited Uses",
    "translations": {
      "en": "Prohibited Uses",
      "fr": "Utilisations interdites",
      "de": "Verbotene Verwendungen",
      "es": "Usos prohibidos",
      "uk": "Заборонені види використання"
    },
    "createdAt": "2025-12-04T14:54:46.860Z",
    "updatedAt": "2025-12-04T14:54:46.860Z"
  },
  {
    "id": "bwjfbMJsL4ch9R1Gj4bq",
    "key": "provide_photos_of_the_artwork_and_packaging",
    "source": "Provide photos of the artwork and packaging.",
    "translations": {
      "en": "Provide photos of the artwork and packaging.",
      "fr": "Fournissez des photos de l’œuvre d’art et de l’emballage.",
      "de": "Stellen Sie Fotos des Kunstwerks und der Verpackung bereit.",
      "es": "Proporcione fotografías de la obra de arte y el embalaje.",
      "uk": "Надішліть фото картини та пакування."
    },
    "createdAt": "2025-12-04T13:03:33.776Z",
    "updatedAt": "2025-12-04T13:03:33.776Z"
  },
  {
    "id": "pyRn2X6ABbebhQO5zL9u",
    "key": "provide_the_address_for_certificates_and_shipping_all_fields_are_required",
    "source": "Provide the address for certificates and shipping. All fields are required.",
    "translations": {
      "en": "Provide the address for certificates and shipping. All fields are required.",
      "fr": "Fournissez l’adresse pour les certificats et l’expédition. Tous les champs sont obligatoires.",
      "de": "Geben Sie die Adresse für Zertifikate und Versand an. Alle Felder sind Pflichtfelder.",
      "es": "Proporcione la dirección para certificados y envío. Todos los campos son obligatorios.",
      "uk": "Вкажіть адресу для доставки. Усі поля є обов’язковими для заповнення."
    },
    "createdAt": "2025-11-27T14:16:05.274Z",
    "updatedAt": "2025-11-27T14:16:05.274Z"
  },
  {
    "id": "JJuHQXXJv0Y0oJngbeGV",
    "key": "providing_products_and_services_processing_payments_fulfilling_and_shipping_orde",
    "source": "Providing products and services: processing payments, fulfilling and shipping orders, returns/exchanges, account notifications and management.",
    "translations": {
      "en": "Providing products and services: processing payments, fulfilling and shipping orders, returns/exchanges, account notifications and management.",
      "fr": "Fournir des produits et services : traitement des paiements, exécution et expédition des commandes, retours/échanges, notifications et gestion des comptes.",
      "de": "Bereitstellung von Produkten und Dienstleistungen: Zahlungsabwicklung, Ausführung und Versand von Bestellungen, Rückgaben/Umtausch, Kontobenachrichtigungen und -verwaltung.",
      "es": "Proporcionar productos y servicios: procesar pagos, cumplir y enviar pedidos, devoluciones/cambios, notificaciones de cuentas y gestión.",
      "uk": "Надання товарів і послуг: обробка платежів, виконання замовлень, доставка, повернення, повідомлення, управління акаунтом."
    },
    "createdAt": "2025-12-05T09:33:48.540Z",
    "updatedAt": "2025-12-05T09:33:48.540Z"
  },
  {
    "id": "uO5zyHdrmIpBTDahNRYY",
    "key": "quick_check_ins_or_sharing_progress_snaps",
    "source": "— quick check-ins or sharing progress snaps.",
    "translations": {
      "en": "— quick check-ins or sharing progress snaps.",
      "fr": "- des enregistrements rapides ou le partage d'instantanés de progression.",
      "de": "– schnelles Einchecken oder Teilen von Fortschrittsfotos.",
      "es": "– registros rápidos o compartir instantáneas del progreso.",
      "uk": "— швидкі реєстрації або обмін знімками прогресу."
    },
    "createdAt": "2025-11-29T14:00:55.544Z",
    "updatedAt": "2025-11-29T14:00:55.544Z"
  },
  {
    "id": "B6ZgJtlo5LXn1ZItV9BJ",
    "key": "quiet_sunset",
    "source": "Quiet sunset",
    "translations": {
      "en": "Quiet sunset",
      "fr": "Coucher de soleil tranquille",
      "de": "Ruhiger Sonnenuntergang",
      "es": "Puesta de sol tranquila",
      "uk": "Тихий захід сонця"
    },
    "createdAt": "2025-11-27T11:44:31.810Z",
    "updatedAt": "2025-11-27T11:44:31.810Z"
  },
  {
    "id": "kQva0DmSuB3Wtqs4wRAE",
    "key": "ready_made_pieces_can_be_cancelled_before_the_order_has_shipped",
    "source": "Ready-made pieces can be cancelled before the order has shipped.",
    "translations": {
      "en": "Ready-made pieces can be cancelled before the order has shipped.",
      "fr": "Les pièces prêtes à l'emploi peuvent être annulées avant l'expédition de la commande.",
      "de": "Fertige Stücke können vor dem Versand der Bestellung storniert werden.",
      "es": "Las piezas confeccionadas se pueden cancelar antes de que se envíe el pedido.",
      "uk": "Готові картини можна скасувати до того, як замовлення буде відправлено."
    },
    "createdAt": "2025-12-04T13:18:51.252Z",
    "updatedAt": "2025-12-04T13:18:51.252Z"
  },
  {
    "id": "s7W1BoRFoNzJXTEmpV8x",
    "key": "ready_to_create_your_own_portrait",
    "source": "Ready to Create Your Own Portrait?",
    "translations": {
      "en": "Ready to Create Your Own Portrait?",
      "fr": "Prêt à créer votre propre portrait ?",
      "de": "Sind Sie bereit, Ihr eigenes Porträt zu erstellen?",
      "es": "¿Listo para crear tu propio retrato?",
      "uk": "Готові створити власний портрет улюбленця?"
    },
    "createdAt": "2025-12-05T10:46:59.002Z",
    "updatedAt": "2025-12-05T10:46:59.002Z"
  },
  {
    "id": "EoZvPrHon10Jid3EsJs6",
    "key": "ready_to_order_your_own_custom_pet_portrait",
    "source": "Ready to order your own custom pet portrait?",
    "translations": {
      "en": "Ready to order your own custom pet portrait?",
      "fr": "Prêt à commander votre propre portrait d'animal personnalisé ?",
      "de": "Sind Sie bereit, Ihr eigenes, individuelles Haustierporträt zu bestellen?",
      "es": "¿Listo para pedir tu propio retrato de mascota personalizado?",
      "uk": "Готові замовити портрет для вашого улюбленця?"
    },
    "createdAt": "2025-11-27T12:28:50.880Z",
    "updatedAt": "2025-11-27T12:28:50.880Z"
  },
  {
    "id": "2TavwBnlYW5EHnk3LhYD",
    "key": "ready_to_turn_your_pets_photo_into_a_painting_browse_the_portrait_options_above_",
    "source": "Ready to turn your pet's photo into a painting? Browse the portrait options above, or reach out with your photo and I'll tell you exactly what's possible.",
    "createdAt": "2026-05-20T11:27:11.162Z",
    "translations": {
      "en": "Ready to turn your pet's photo into a painting? Browse the portrait options above, or reach out with your photo and I'll tell you exactly what's possible.",
      "fr": "Prêt à transformer la photo de votre animal en tableau ? Découvrez les options de portrait ci-dessus, ou contactez-moi avec votre photo et je vous dirai ce que nous pouvons créer ensemble.",
      "de": "Möchten Sie das Foto Ihres Haustieres in ein Gemälde verwandeln? Schauen Sie sich die Porträtoptionen oben an oder schicken Sie mir einfach Ihr Foto – ich sage Ihnen genau, was möglich ist.",
      "es": "¿Lista para convertir la foto de tu mascota en una pintura? Explora las opciones de retratos más arriba, o escríbeme con tu foto y te cuento exactamente qué podemos hacer.",
      "uk": "Готові перетворити фото свого улюбленця на картину? Перегляньте варіанти портретів вище або надішліть мені своє фото — і я розкажу, що можна зробити саме для вас."
    },
    "updatedAt": "2026-05-20T11:49:51.817Z"
  },
  {
    "id": "8qE8qPSdWFNoF9fkBEgf",
    "key": "rectangle",
    "source": "Rectangle",
    "createdAt": "2025-11-27T10:45:07.175Z",
    "translations": {
      "en": "Rectangle",
      "fr": "Rectangle",
      "de": "Rechteck",
      "es": "Rectángulo",
      "uk": "Квадрат"
    },
    "updatedAt": "2025-11-27T13:20:30.656Z"
  },
  {
    "id": "IqaikgARrMeTnh3f7kb8",
    "key": "refund_policy",
    "source": "Refund Policy",
    "translations": {
      "en": "Refund Policy",
      "fr": "Politique de remboursement",
      "de": "Rückerstattungsrichtlinie",
      "es": "Política de reembolso",
      "uk": "Політика відшкодування"
    },
    "createdAt": "2025-11-27T11:27:01.668Z",
    "updatedAt": "2025-11-27T11:27:01.668Z"
  },
  {
    "id": "xTKIeZUoFrwnICYo4e2j",
    "key": "refunds_are_processed_within_7_14_business_days_after_we_receive_the_returned_it",
    "source": "Refunds are processed within 7-14 business days after we receive the returned item.",
    "translations": {
      "en": "Refunds are processed within 7-14 business days after we receive the returned item.",
      "fr": "Les remboursements sont traités dans les 7 à 14 jours ouvrables après réception de l'article retourné.",
      "de": "Rückerstattungen werden innerhalb von 7–14 Werktagen nach Erhalt des zurückgegebenen Artikels bearbeitet.",
      "es": "Los reembolsos se procesan dentro de 7 a 14 días hábiles después de recibir el artículo devuelto.",
      "uk": "Після отримання товару кошти повертаються протягом 7–14 робочих днів."
    },
    "createdAt": "2025-12-04T12:59:43.128Z",
    "updatedAt": "2025-12-04T12:59:43.128Z"
  },
  {
    "id": "268UqnfhUaEviu2lBQUt",
    "key": "required",
    "source": "Required",
    "translations": {
      "en": "Required",
      "fr": "Requis",
      "de": "Erforderlich",
      "es": "Requerido",
      "uk": "Обов'язково"
    },
    "createdAt": "2025-11-27T14:12:02.419Z",
    "updatedAt": "2025-11-27T14:12:02.419Z"
  },
  {
    "id": "m6PoNqUFLMAzUni24Dbv",
    "key": "return_refund_policy",
    "source": "Return & Refund Policy",
    "translations": {
      "en": "Return & Refund Policy",
      "fr": "Politique de retour et de remboursement",
      "de": "Rückgabe- und Rückerstattungsrichtlinie",
      "es": "Política de devolución y reembolso",
      "uk": "Політика повернення та відшкодування"
    },
    "createdAt": "2025-12-04T12:43:25.280Z",
    "updatedAt": "2025-12-04T12:43:25.280Z"
  },
  {
    "id": "sgpRZC3Yi7cadDk1QSzr",
    "key": "return_shipping_costs_are_the_responsibility_of_the_customer",
    "source": "Return shipping costs are the responsibility of the customer.",
    "translations": {
      "en": "Return shipping costs are the responsibility of the customer.",
      "fr": "Les frais de retour sont à la charge du client.",
      "de": "Die Kosten für die Rücksendung liegen in der Verantwortung des Kunden.",
      "es": "Los gastos de envío de devolución son responsabilidad del cliente.",
      "uk": "Витрати на зворотну доставку здійснює покупець."
    },
    "createdAt": "2025-12-04T12:58:40.289Z",
    "updatedAt": "2025-12-04T12:58:40.289Z"
  },
  {
    "id": "he7PS9rI8izQUW1KWATm",
    "key": "returns_are_accepted_within_14_days_of_delivery_if_the_artwork",
    "source": "Returns are accepted within 14 days of delivery if the artwork:",
    "translations": {
      "en": "Returns are accepted within 14 days of delivery if the artwork:",
      "fr": "Les retours sont acceptés dans les 14 jours suivant la livraison si l’œuvre :",
      "de": "Rücksendungen werden innerhalb von 14 Tagen nach Lieferung akzeptiert, wenn das Kunstwerk:",
      "es": "Se aceptan devoluciones dentro de los 14 días posteriores a la entrega si la obra de arte:",
      "uk": "Повернення можливе протягом 14 днів після отримання, якщо картина:"
    },
    "createdAt": "2025-12-04T12:56:02.657Z",
    "updatedAt": "2025-12-04T12:56:02.657Z"
  },
  {
    "id": "RsZwaPdndY4IhXmH1F7t",
    "key": "returns_are_only_accepted_if_the_item_arrives_damaged",
    "source": "Returns are only accepted if the item arrives damaged.",
    "translations": {
      "en": "Returns are only accepted if the item arrives damaged.",
      "fr": "Les retours ne sont acceptés que si l'article arrive endommagé.",
      "de": "Rücksendungen werden nur akzeptiert, wenn der Artikel beschädigt ankommt.",
      "es": "Sólo se aceptan devoluciones si el artículo llega dañado.",
      "uk": "Повернення можливе лише у разі пошкодження під час доставки."
    },
    "createdAt": "2025-12-04T12:52:40.588Z",
    "updatedAt": "2025-12-04T12:52:40.588Z"
  },
  {
    "id": "z7YjDiYMbaQrNmEyOOIz",
    "key": "returns_exchanges",
    "source": "Returns & Exchanges",
    "translations": {
      "en": "Returns & Exchanges",
      "fr": "Retours et échanges",
      "de": "Rückgaben und Umtausch",
      "es": "Devoluciones y cambios",
      "uk": "Повернення та обмін"
    },
    "createdAt": "2025-11-27T15:05:55.408Z",
    "updatedAt": "2025-11-27T15:05:55.408Z"
  },
  {
    "id": "WTlptkvcrPjBaJyucSth",
    "key": "reviews",
    "source": "Reviews",
    "translations": {
      "en": "Reviews",
      "fr": "Avis",
      "de": "Rezensionen",
      "es": "Reseñas",
      "uk": "Відгуки"
    },
    "createdAt": "2025-11-27T10:35:30.776Z",
    "updatedAt": "2025-11-27T10:35:30.776Z"
  },
  {
    "id": "ScbUy1KZH7aEw4U4n9Vt",
    "key": "saved_in_your_cart_open_the_cart_anytime_from_the_header_to_review_or_checkout",
    "source": "saved in your cart. Open the cart anytime from the header to review or checkout.",
    "translations": {
      "en": "saved in your cart. Open the cart anytime from the header to review or checkout.",
      "fr": "enregistré dans votre panier. Ouvrez le panier à tout moment depuis l'en-tête pour le consulter ou le payer.",
      "de": "in Ihrem Warenkorb gespeichert. Öffnen Sie den Warenkorb jederzeit über die Kopfzeile, um ihn zu überprüfen oder zur Kasse zu gehen.",
      "es": "guardado en tu carrito. Abra el carrito en cualquier momento desde el encabezado para revisarlo o pagar.",
      "uk": "збережено у вашому кошику. Відкрийте кошик у будь-який час із заголовка, щоб переглянути або оплатити замовлення."
    },
    "createdAt": "2025-11-27T10:47:55.939Z",
    "updatedAt": "2025-11-27T10:47:55.939Z"
  },
  {
    "id": "ydy6ZO5szWiCTXYRYQf9",
    "key": "secure_payment_via_monobank_you_ll_be_redirected_to_confirm_the_transfer_and_bro",
    "source": "Secure payment via Monobank. You’ll be redirected to confirm the transfer and brought back once it’s complete.",
    "translations": {
      "en": "Secure payment via Monobank. You’ll be redirected to confirm the transfer and brought back once it’s complete.",
      "fr": "Paiement sécurisé via Monobank. Vous serez redirigé pour confirmer le transfert et ramené une fois celui-ci terminé.",
      "de": "Sichere Zahlung über Monobank. Sie werden zur Bestätigung der Übertragung weitergeleitet und nach Abschluss der Übertragung zurückgebracht.",
      "es": "Pago seguro vía Monobank. Serás redirigido para confirmar la transferencia y regresarás una vez que se complete.",
      "uk": "Безпечна оплата через Monobank. Ви будете перенаправлені для підтвердження передачі та повернені назад, коли вона буде завершена."
    },
    "createdAt": "2025-11-27T14:17:18.185Z",
    "updatedAt": "2025-11-27T14:17:18.185Z"
  },
  {
    "id": "1DUOJ4fIWaLXoGGzhi42",
    "key": "security_and_fraud_prevention_detecting_investigating_and_acting_on_fraudulent_i",
    "source": "Security and fraud prevention: detecting, investigating, and acting on fraudulent, illegal, or malicious activity (Art. 6(1)(f) GDPR).",
    "translations": {
      "en": "Security and fraud prevention: detecting, investigating, and acting on fraudulent, illegal, or malicious activity (Art. 6(1)(f) GDPR).",
      "fr": "Sécurité et prévention de la fraude : détecter, enquêter et réagir aux activités frauduleuses, illégales ou malveillantes (article 6, paragraphe 1, point f) du RGPD).",
      "de": "Sicherheit und Betrugsprävention: Erkennung, Untersuchung und Bekämpfung betrügerischer, illegaler oder böswilliger Aktivitäten (Art. 6 Abs. 1 lit. f DSGVO).",
      "es": "Seguridad y prevención del fraude: detectar, investigar y actuar ante actividades fraudulentas, ilegales o maliciosas (Art. 6(1)(f) RGPD).",
      "uk": "Безпека та запобігання шахрайству: виявлення, розслідування та реагування на шахрайську, незаконну чи зловмисну ​​діяльність (ст. 6(1)(f) GDPR)."
    },
    "createdAt": "2025-12-05T09:35:06.953Z",
    "updatedAt": "2025-12-05T09:35:06.953Z"
  },
  {
    "id": "kmwDTieYAxTXAYP2QB58",
    "key": "security_and_retention",
    "source": "Security and retention",
    "translations": {
      "en": "Security and retention",
      "fr": "Sécurité et rétention",
      "de": "Sicherheit und Aufbewahrung",
      "es": "Seguridad y retención",
      "uk": "Безпека та зберігання даних"
    },
    "createdAt": "2025-12-05T09:45:03.888Z",
    "updatedAt": "2025-12-05T09:45:03.888Z"
  },
  {
    "id": "kQpg5IfIKASHqYaThBAc",
    "key": "see_my_others_artworks",
    "source": "See my others artworks",
    "createdAt": "2025-11-27T12:37:42.748Z",
    "translations": {
      "en": "See my others artworks",
      "fr": "Voir mes autres oeuvres",
      "de": "Sehen Sie sich meine anderen Kunstwerke an",
      "es": "Ver mis otras obras de arte",
      "uk": "Подивіться мої інші роботи"
    },
    "updatedAt": "2025-11-27T12:43:18.931Z"
  },
  {
    "id": "FPK3Pzg47lmss6xWnaJk",
    "key": "see_pet_owners_reviews",
    "source": "See Pet Owners Reviews",
    "translations": {
      "en": "See Pet Owners Reviews",
      "fr": "Voir les avis des propriétaires d’animaux",
      "de": "Siehe Bewertungen von Tierbesitzern",
      "es": "Ver reseñas de dueños de mascotas",
      "uk": "Перегляньте відгуки"
    },
    "createdAt": "2025-11-27T10:44:01.125Z",
    "updatedAt": "2025-11-27T10:44:01.125Z"
  },
  {
    "id": "lEQn2RYo0BgyOBiZHqJO",
    "key": "send_message",
    "source": "Send message",
    "translations": {
      "en": "Send message",
      "fr": "Envoyer un message",
      "de": "Nachricht senden",
      "es": "enviar mensaje",
      "uk": "Надіслати повідомлення"
    },
    "createdAt": "2025-11-27T13:33:04.094Z",
    "updatedAt": "2025-11-27T13:33:04.094Z"
  },
  {
    "id": "qnXDApQ54j8o66QcZVfV",
    "key": "services_are_provided_as_is_and_as_available_without_warranties_of_any_kind_we_a",
    "source": "Services are provided \"as is\" and \"as available\" without warranties of any kind. We are not liable for any direct, indirect, incidental, punitive, or consequential damages arising from your use of the Service, except where prohibited by law.",
    "translations": {
      "en": "Services are provided \"as is\" and \"as available\" without warranties of any kind. We are not liable for any direct, indirect, incidental, punitive, or consequential damages arising from your use of the Service, except where prohibited by law.",
      "fr": "Les services sont fournis « tels quels » et « selon disponibilité » sans garantie d'aucune sorte. Nous ne sommes pas responsables des dommages directs, indirects, accessoires, punitifs ou consécutifs découlant de votre utilisation du Service, sauf là où la loi l'interdit.",
      "de": "Die Dienste werden „wie besehen“ und „wie verfügbar“ ohne Gewährleistungen jeglicher Art bereitgestellt. Wir haften nicht für direkte, indirekte, zufällige, Straf- oder Folgeschäden, die sich aus Ihrer Nutzung des Dienstes ergeben, sofern dies nicht gesetzlich verboten ist.",
      "es": "Los servicios se brindan \"tal cual\" y \"según disponibilidad\" sin garantías de ningún tipo. No somos responsables de ningún daño directo, indirecto, incidental, punitivo o consecuente que surja de su uso del Servicio, excepto donde lo prohíba la ley.",
      "uk": "Послуги надаються «як є» та «як доступно» без будь-яких гарантій. Ми не несемо відповідальності за будь-які прямі, непрямі, випадкові, штрафні чи побічні збитки, що виникають внаслідок використання вами Сервісу, за винятком випадків, коли це заборонено законом."
    },
    "createdAt": "2025-12-04T14:56:31.981Z",
    "updatedAt": "2025-12-04T14:56:31.981Z"
  },
  {
    "id": "Wgu0WZSbWoq0ImDxaz4E",
    "key": "shape",
    "source": "Shape",
    "translations": {
      "en": "Shape",
      "fr": "Forme",
      "de": "Form",
      "es": "Forma",
      "uk": "Форма"
    },
    "createdAt": "2025-11-27T10:44:42.033Z",
    "updatedAt": "2025-11-27T10:44:42.033Z"
  },
  {
    "id": "6pDLZNN45b8JppIxDz78",
    "key": "share_ideas_requests_or_details_that_matter_to_you",
    "source": "Share ideas, requests, or details that matter to you.",
    "translations": {
      "en": "Share ideas, requests, or details that matter to you.",
      "fr": "Partagez des idées, des demandes ou des détails qui vous intéressent.",
      "de": "Teilen Sie Ideen, Wünsche oder Details mit, die Ihnen wichtig sind.",
      "es": "Comparta ideas, solicitudes o detalles que le interesen.",
      "uk": "Діліться ідеями, проханнями чи подробицями, які вас цікавлять."
    },
    "createdAt": "2025-11-27T14:15:05.845Z",
    "updatedAt": "2025-11-27T14:15:05.845Z"
  },
  {
    "id": "k2NX4uoWwbSfPVi8hNqV",
    "key": "share_your_idea_and_i_ll_send_next_steps_and_a_custom_quote",
    "source": "Share your idea, and I’ll send next steps and a custom quote.",
    "translations": {
      "en": "Share your idea, and I’ll send next steps and a custom quote.",
      "fr": "Partagez votre idée et je vous enverrai les prochaines étapes et un devis personnalisé.",
      "de": "Teilen Sie Ihre Idee mit und ich sende Ihnen die nächsten Schritte und ein individuelles Angebot.",
      "es": "Comparta su idea y le enviaré los siguientes pasos y una cotización personalizada.",
      "uk": "Поділіться своєю ідеєю, і я надішлю наступні кроки та індивідуальну цінову пропозицію."
    },
    "createdAt": "2025-11-27T13:31:13.102Z",
    "updatedAt": "2025-11-27T13:31:13.102Z"
  },
  {
    "id": "uqOMZLeZSSNDGJawryVT",
    "key": "shipping",
    "source": "Shipping",
    "translations": {
      "en": "Shipping",
      "fr": "Expédition",
      "de": "Versand",
      "es": "Envío",
      "uk": "Доставка"
    },
    "createdAt": "2025-11-27T14:10:00.472Z",
    "updatedAt": "2025-11-27T14:10:00.472Z"
  },
  {
    "id": "RVhXQkVJjoF93CkanHb3",
    "key": "shipping_policy",
    "source": "Shipping Policy",
    "translations": {
      "en": "Shipping Policy",
      "fr": "Politique d'expédition",
      "de": "Versandbedingungen",
      "es": "Política de envío",
      "uk": "Політика доставки"
    },
    "createdAt": "2025-11-27T11:26:43.728Z",
    "updatedAt": "2025-11-27T11:26:43.728Z"
  },
  {
    "id": "A9K17KoFy8FC7ClnNsnk",
    "key": "shipping_time_cost",
    "source": "Shipping Time & Cost",
    "translations": {
      "en": "Shipping Time & Cost",
      "fr": "Délai et coût d'expédition",
      "de": "Lieferzeit und -kosten",
      "es": "Tiempo y costo de envío",
      "uk": "Час і вартість доставки"
    },
    "createdAt": "2025-11-27T14:41:03.531Z",
    "updatedAt": "2025-11-27T14:41:03.531Z"
  },
  {
    "id": "0vklTMvhy8cxena1PAfG",
    "key": "ships_within_3_5_business_days",
    "source": "Ships within 3-5 business days",
    "translations": {
      "en": "Ships within 3-5 business days",
      "fr": "Expédié sous 3 à 5 jours ouvrables",
      "de": "Wird innerhalb von 3–5 Werktagen versendet",
      "es": "Se envía dentro de 3-5 días hábiles",
      "uk": "Доставка протягом 3-5 робочих днів"
    },
    "createdAt": "2025-11-27T15:17:11.108Z",
    "updatedAt": "2025-11-27T15:17:11.108Z"
  },
  {
    "id": "d8yfJehyRxNxeZj2X1ID",
    "key": "ships_worldwide_safely_packed",
    "source": "Ships Worldwide, Safely Packed",
    "createdAt": "2026-05-20T11:25:37.800Z",
    "translations": {
      "en": "Ships Worldwide, Safely Packed",
      "fr": "Livraison dans le monde entier, emballage soigné et sécurisé",
      "de": "Weltweiter Versand – sicher und geschützt verpackt",
      "es": "Envío internacional con embalaje protector",
      "uk": "Доставка по всьому світу у надійній упаковці"
    },
    "updatedAt": "2026-05-20T11:49:49.971Z"
  },
  {
    "id": "8uVyhQcWZiLLqzXSdebZ",
    "key": "shows_no_signs_of_damage_or_use",
    "source": "shows no signs of damage or use,",
    "translations": {
      "en": "shows no signs of damage or use,",
      "fr": "ne montre aucun signe de dommage ou d’utilisation,",
      "de": "weist keine Anzeichen von Beschädigung oder Gebrauch auf,",
      "es": "no muestra signos de daño o uso,",
      "uk": "не має слідів використання,"
    },
    "createdAt": "2025-12-04T12:57:32.347Z",
    "updatedAt": "2025-12-04T12:57:32.347Z"
  },
  {
    "id": "xKSucswvRmiig6xFERJJ",
    "key": "siesta",
    "source": "“Siesta”",
    "translations": {
      "en": "“Siesta”",
      "fr": "\"Sieste\"",
      "de": "\"Siesta\"",
      "es": "\"Siesta\"",
      "uk": "«Сієста»"
    },
    "createdAt": "2025-11-27T11:16:45.957Z",
    "updatedAt": "2025-11-27T11:16:45.957Z"
  },
  {
    "id": "dX1S3RPBlVTJNGc24d0j",
    "key": "silent_alone",
    "source": "Silent Alone",
    "translations": {
      "en": "Silent Alone",
      "fr": "Silencieux seul",
      "de": "Schweigend allein",
      "es": "solo en silencio",
      "uk": "Один в тиші"
    },
    "createdAt": "2026-02-03T15:22:37.461Z",
    "updatedAt": "2026-02-03T15:22:37.461Z"
  },
  {
    "id": "nYScEyWP2OPqwhlebnHs",
    "key": "size",
    "source": "Size",
    "translations": {
      "en": "Size",
      "fr": "Taille",
      "de": "Größe",
      "es": "Tamaño",
      "uk": "Розмір"
    },
    "createdAt": "2025-11-27T10:46:05.103Z",
    "updatedAt": "2025-11-27T10:46:05.103Z"
  },
  {
    "id": "Kkz3s0vtmNXc4nIqLd69",
    "key": "sold_out",
    "source": "Sold Out",
    "translations": {
      "en": "Sold Out",
      "fr": "Épuisé",
      "de": "Ausverkauft",
      "es": "Agotado",
      "uk": "Розпродано"
    },
    "createdAt": "2025-11-27T11:43:08.791Z",
    "updatedAt": "2025-11-27T11:43:08.791Z"
  },
  {
    "id": "gpykX9CM8BIeLjTmKW4b",
    "key": "sort_by",
    "source": "Sort by:",
    "translations": {
      "en": "Sort by:",
      "fr": "Trier par:",
      "de": "Sortieren nach:",
      "es": "Ordenar por:",
      "uk": "Сортувати за:"
    },
    "createdAt": "2025-11-27T11:43:20.215Z",
    "updatedAt": "2025-11-27T11:43:20.215Z"
  },
  {
    "id": "cZ2LBUE56j24o6ujiKCN",
    "key": "spring",
    "source": "Spring",
    "translations": {
      "en": "Spring",
      "fr": "Printemps",
      "de": "Frühling",
      "es": "Primavera",
      "uk": "Весна"
    },
    "createdAt": "2025-11-27T11:23:10.958Z",
    "updatedAt": "2025-11-27T11:23:10.958Z"
  },
  {
    "id": "eaTLlrP1kOtNRya0ItuP",
    "key": "status",
    "source": "Status",
    "translations": {
      "en": "Status",
      "fr": "Statut",
      "de": "Status",
      "es": "Estado",
      "uk": "Статус"
    },
    "createdAt": "2025-11-27T15:18:37.396Z",
    "updatedAt": "2025-11-27T15:18:37.396Z"
  },
  {
    "id": "5hJ8aLouzK8au9tGv13T",
    "key": "stefan",
    "source": "Stefan",
    "translations": {
      "en": "Stefan",
      "fr": "Stéphane",
      "de": "Stefan",
      "es": "Esteban",
      "uk": "Стефан"
    },
    "createdAt": "2025-12-05T15:13:58.642Z",
    "updatedAt": "2025-12-05T15:13:58.642Z"
  },
  {
    "id": "jtTSkbTkDmvGZCJWLXvC",
    "key": "stories_from_the_studio",
    "source": "Stories from the studio",
    "translations": {
      "en": "Stories from the studio",
      "fr": "Histoires du studio",
      "de": "Geschichten aus dem Studio",
      "es": "Historias del estudio",
      "uk": "Розповіді зі студії"
    },
    "createdAt": "2025-12-05T20:03:07.606Z",
    "updatedAt": "2025-12-05T20:03:07.606Z"
  },
  {
    "id": "Lyvl856pTq6ulV4S7Krn",
    "key": "subtotal",
    "source": "Subtotal",
    "translations": {
      "en": "Subtotal",
      "fr": "Total",
      "de": "Zwischensumme",
      "es": "Total parcial",
      "uk": "Сумма"
    },
    "createdAt": "2025-11-27T14:08:48.249Z",
    "updatedAt": "2025-11-27T14:08:48.249Z"
  },
  {
    "id": "APetZ6T1jTQxKz85b8ew",
    "key": "sweden_helsingborg",
    "source": "Sweden, Helsingborg",
    "translations": {
      "en": "Sweden, Helsingborg",
      "fr": "Suède, Helsingborg",
      "de": "Schweden, Helsingborg",
      "es": "Suecia, Helsingborg",
      "uk": "Швеція, Гельсінборг"
    },
    "createdAt": "2025-12-05T15:07:15.222Z",
    "updatedAt": "2025-12-05T15:07:15.222Z"
  },
  {
    "id": "xzMIqeEAAJ0WDUuEz689",
    "key": "switzerland_sulgen",
    "source": "Switzerland, Sulgen",
    "translations": {
      "en": "Switzerland, Sulgen",
      "fr": "Suisse, Sulgen",
      "de": "Schweiz, Sulgen",
      "es": "Suiza, Sulgen",
      "uk": "Швейцарія, Зульген"
    },
    "createdAt": "2025-12-05T15:07:39.719Z",
    "updatedAt": "2025-12-05T15:07:39.719Z"
  },
  {
    "id": "xr5Tk3nQetixN3urveW8",
    "key": "testimonial.owner_of",
    "createdAt": "2025-12-05T15:29:38.766Z",
    "translations": {
      "en": "{{petName}}'s owner",
      "fr": "Propriétaire de {{petName}}",
      "de": "{{petName}}s Besitzer",
      "es": "Dueño de {{petName}}",
      "uk": "Власник {{petName}}"
    },
    "source": "{{petName}}'s owner",
    "updatedAt": "2025-12-05T15:36:24.777Z"
  },
  {
    "id": "iqXxafhA3kx2wsd26zBi",
    "key": "thank_you_very_much_surprise_went_well",
    "createdAt": "2025-12-05T10:44:18.991Z",
    "translations": {
      "en": "Thank you very much, surprise went well!",
      "fr": "Merci beaucoup, la surprise s'est bien passée !",
      "de": "Vielen Dank, die Überraschung ist gut gelaufen!",
      "es": "¡Muchas gracias, la sorpresa salió bien!",
      "uk": "Дуже дякую, сюрприз вийшов просто чудовий!"
    },
    "source": "Thank you very much, surprise went well!",
    "updatedAt": "2025-12-05T15:02:02.629Z"
  },
  {
    "id": "BKDuv8beoRDRKww0wXF4",
    "key": "the_bond_between_mother_and_child_is_one_of_life_s_deepest_mysteries_formed_befo",
    "source": "The bond between mother and child is one of life’s deepest mysteries — formed before the first breath, it exists beyond time, distance, or words. It is a connection of instincts and unspoken understanding, where the mother becomes both the guardian of life and the keeper of the child’s first dreams. This bond is not bound by miles or years; it is an invisible thread, felt in the heart, carried in the soul. Through layered textures and living strokes, I sought to give form to that eternal truth — that in the eyes of a mother, a child will always find home.",
    "translations": {
      "en": "The bond between mother and child is one of life’s deepest mysteries — formed before the first breath, it exists beyond time, distance, or words. It is a connection of instincts and unspoken understanding, where the mother becomes both the guardian of life and the keeper of the child’s first dreams. This bond is not bound by miles or years; it is an invisible thread, felt in the heart, carried in the soul. Through layered textures and living strokes, I sought to give form to that eternal truth — that in the eyes of a mother, a child will always find home.",
      "fr": "Le lien entre la mère et l’enfant est l’un des mystères les plus profonds de la vie : formé avant le premier souffle, il existe au-delà du temps, de la distance ou des mots. C’est une connexion d’instincts et de compréhensions tacites, où la mère devient à la fois la gardienne de la vie et la gardienne des premiers rêves de l’enfant. Ce lien n'est pas lié par des kilomètres ou des années ; c'est un fil invisible, ressenti dans le cœur, porté dans l'âme. À travers des textures superposées et des traits vivants, j’ai cherché à donner forme à cette vérité éternelle : aux yeux d’une mère, un enfant trouvera toujours un foyer.",
      "de": "Die Bindung zwischen Mutter und Kind ist eines der tiefsten Geheimnisse des Lebens – sie entstand bereits vor dem ersten Atemzug und existiert jenseits von Zeit, Entfernung oder Worten. Es ist eine Verbindung von Instinkten und unausgesprochenem Verständnis, bei der die Mutter sowohl zur Hüterin des Lebens als auch zur Hüterin der ersten Träume des Kindes wird. Diese Bindung ist nicht an Meilen oder Jahre gebunden; Es ist ein unsichtbarer Faden, der im Herzen gefühlt und in der Seele getragen wird. Durch geschichtete Texturen und lebendige Striche versuchte ich, dieser ewigen Wahrheit eine Form zu geben – dass ein Kind in den Augen einer Mutter immer ein Zuhause finden wird.",
      "es": "El vínculo entre madre e hijo es uno de los misterios más profundos de la vida: se forma antes del primer aliento y existe más allá del tiempo, la distancia o las palabras. Es una conexión de instintos y comprensión tácita, donde la madre se convierte a la vez en guardiana de la vida y guardiana de los primeros sueños del niño. Este bono no está sujeto a millas ni a años; es un hilo invisible, sentido en el corazón, llevado en el alma. A través de texturas en capas y trazos vivos, busqué darle forma a esa verdad eterna: que, a los ojos de una madre, un niño siempre encontrará un hogar.",
      "uk": "Зв’язок між матір’ю та дитиною є однією з найглибших таємниць життя — утворившись до першого подиху, він існує поза часом, відстанню чи словами. Це зв’язок інстинктів і невисловленого розуміння, де мама стає і берегинею життя, і берегинею перших мрій дитини. Цей зв’язок не пов’язаний ні кілометрами, ні роками; це невидима нитка, відчувається серцем, несеться в душі. За допомогою багатошарових текстур і живих мазків я прагнув надати форми тій вічній істині — що в очах матері дитина завжди знайде дім."
    },
    "createdAt": "2026-01-23T16:58:30.088Z",
    "updatedAt": "2026-01-23T16:58:30.088Z"
  },
  {
    "id": "70K0YvqISS0rUv5u5Qb4",
    "key": "the_name_and_email_used_at_checkout",
    "source": "The name and email used at checkout.",
    "translations": {
      "en": "The name and email used at checkout.",
      "fr": "Le nom et l'e-mail utilisés lors du paiement.",
      "de": "Der beim Bezahlvorgang verwendete Name und die E-Mail-Adresse.",
      "es": "El nombre y el correo electrónico utilizados al realizar el pago.",
      "uk": "Ім’я та адреса електронної пошти, використані під час оформлення замовлення."
    },
    "createdAt": "2025-11-29T14:13:42.697Z",
    "updatedAt": "2025-11-29T14:13:42.697Z"
  },
  {
    "id": "zcXoVe1AwCWZlx66kECW",
    "key": "the_services_are_not_intended_for_children_and_we_do_not_knowingly_collect_perso",
    "source": "The Services are not intended for children, and we do not knowingly collect personal information from children. If a child has provided information, contact us to request deletion.",
    "translations": {
      "en": "The Services are not intended for children, and we do not knowingly collect personal information from children. If a child has provided information, contact us to request deletion.",
      "fr": "Les Services ne sont pas destinés aux enfants et nous ne collectons pas sciemment d'informations personnelles auprès des enfants. Si un enfant a fourni des informations, contactez-nous pour demander la suppression.",
      "de": "Die Dienste sind nicht für Kinder bestimmt und wir erfassen wissentlich keine personenbezogenen Daten von Kindern. Wenn ein Kind Informationen bereitgestellt hat, kontaktieren Sie uns, um die Löschung zu beantragen.",
      "es": "Los Servicios no están destinados a niños y no recopilamos intencionalmente información personal de niños. Si un niño ha proporcionado información, contáctenos para solicitar la eliminación.",
      "uk": "Послуги не призначені для дітей, і ми свідомо не збираємо персональні дані дітей. Якщо ви вважаєте, що дитина надала нам дані — зв’яжіться з нами, і ми їх видалимо."
    },
    "createdAt": "2025-12-05T09:44:41.279Z",
    "updatedAt": "2025-12-05T09:44:41.279Z"
  },
  {
    "id": "Q0WE8tDaEB662DF2RXgE",
    "key": "the_tiny_blue_tit_in_this_painting_symbolizes_the_spirit_of_the_ukrainian_people",
    "source": "The tiny blue tit in this painting symbolizes the spirit of the Ukrainian people—resilient, courageous and unbreakable in the fight for freedom. This piece is deeply personal to me. I poured into it my emotions, my worries for my homeland, and my unwavering hope. Within the softness of the bird and the glowing berries lies strength, unity, and the quiet bravery that lives in every Ukrainian. May this artwork bring resilience, light, and unshakable strength into your home.",
    "translations": {
      "en": "The tiny blue tit in this painting symbolizes the spirit of the Ukrainian people—resilient, courageous and unbreakable in the fight for freedom. This piece is deeply personal to me. I poured into it my emotions, my worries for my homeland, and my unwavering hope. Within the softness of the bird and the glowing berries lies strength, unity, and the quiet bravery that lives in every Ukrainian. May this artwork bring resilience, light, and unshakable strength into your home.",
      "fr": "La petite mésange bleue sur ce tableau symbolise l’esprit du peuple ukrainien : résilient, courageux et inébranlable dans la lutte pour la liberté. Cette pièce m’est profondément personnelle. J'y ai mis mes émotions, mes inquiétudes pour ma patrie et mon espoir inébranlable. Dans la douceur de l’oiseau et des baies rougeoyantes se cachent la force, l’unité et la bravoure tranquille qui habite chaque Ukrainien. Que cette œuvre d’art apporte résilience, lumière et force inébranlable à votre maison.",
      "de": "Die winzige Blaumeise auf diesem Gemälde symbolisiert den Geist des ukrainischen Volkes – widerstandsfähig, mutig und unzerbrechlich im Kampf für die Freiheit. Dieses Stück ist für mich zutiefst persönlich. Ich habe darin meine Gefühle, meine Sorgen um mein Heimatland und meine unerschütterliche Hoffnung hineingesteckt. In der Sanftheit des Vogels und den leuchtenden Beeren liegen Stärke, Einheit und der stille Mut, der in jedem Ukrainer steckt. Möge dieses Kunstwerk Widerstandskraft, Licht und unerschütterliche Stärke in Ihr Zuhause bringen.",
      "es": "El pequeño herrerillo azul de esta pintura simboliza el espíritu del pueblo ucraniano: resiliente, valiente e inquebrantable en la lucha por la libertad. Esta pieza es profundamente personal para mí. Vertí en él mis emociones, mis preocupaciones por mi patria y mi esperanza inquebrantable. Dentro de la suavidad del pájaro y las brillantes bayas se encuentra la fuerza, la unidad y la silenciosa valentía que vive en cada ucraniano. Que esta obra de arte traiga resiliencia, luz y fuerza inquebrantable a su hogar.",
      "uk": "Маленька блакитна синиця на цій картині символізує дух українського народу — стійкого, мужнього та незламного у боротьбі за волю. Цей твір глибоко особистий для мене. Я вклала у нього свої емоції, свої хвилювання за батьківщину і свою непохитну надію. У м’якості пташки та сяючих ягід – сила, єдність і тиха хоробрість, яка живе в кожному українці. Нехай цей витвір принесе у ваш дім стійкість, світло та непохитну силу."
    },
    "createdAt": "2025-12-05T16:58:51.448Z",
    "updatedAt": "2025-12-05T16:58:51.448Z"
  },
  {
    "id": "MhTXefJwHKK4Qor9xa92",
    "key": "these_terms_are_governed_by_the_laws_of_ukraine_any_disputes_shall_be_resolved_u",
    "source": "These Terms are governed by the laws of Ukraine. Any disputes shall be resolved under Ukrainian law.",
    "translations": {
      "en": "These Terms are governed by the laws of Ukraine. Any disputes shall be resolved under Ukrainian law.",
      "fr": "Ces conditions sont régies par les lois de l'Ukraine. Tout litige sera résolu conformément à la loi ukrainienne.",
      "de": "Diese Bedingungen unterliegen den Gesetzen der Ukraine. Alle Streitigkeiten werden nach ukrainischem Recht gelöst.",
      "es": "Estos Términos se rigen por las leyes de Ucrania. Cualquier disputa se resolverá según la ley ucraniana.",
      "uk": "Ці Умови регулюються законодавством України. Будь-які спори вирішуються відповідно до законодавства України."
    },
    "createdAt": "2025-12-04T14:58:52.138Z",
    "updatedAt": "2025-12-04T14:58:52.138Z"
  },
  {
    "id": "PYJ62lEkVBeheu9sLf79",
    "key": "third_party_tools_and_links",
    "source": "Third-Party Tools and Links",
    "translations": {
      "en": "Third-Party Tools and Links",
      "fr": "Outils et liens tiers",
      "de": "Tools und Links von Drittanbietern",
      "es": "Herramientas y enlaces de terceros",
      "uk": "Сторонні інструменти та посилання"
    },
    "createdAt": "2025-12-04T14:51:21.382Z",
    "updatedAt": "2025-12-04T14:51:21.382Z"
  },
  {
    "id": "c04xDoojOv34BqkcimtC",
    "key": "third_party_websites_and_links",
    "source": "Third-party websites and links",
    "translations": {
      "en": "Third-party websites and links",
      "fr": "Sites Web et liens tiers",
      "de": "Websites und Links Dritter",
      "es": "Sitios web y enlaces de terceros",
      "uk": "Сторонні веб-сайти та посилання"
    },
    "createdAt": "2025-12-05T09:42:31.475Z",
    "updatedAt": "2025-12-05T09:42:31.475Z"
  },
  {
    "id": "pYcZCL7sRrDjqhNmvEgk",
    "key": "this_is_an_original_artwork_each_piece_is_unique_and_ships_with_a_signed_certifi",
    "source": "This is an original artwork. Each piece is unique and ships with a signed certificate of authenticity.",
    "translations": {
      "en": "This is an original artwork. Each piece is unique and ships with a signed certificate of authenticity.",
      "fr": "Il s’agit d’une œuvre d’art originale. Chaque pièce est unique et livrée avec un certificat d'authenticité signé.",
      "de": "Dies ist ein Originalkunstwerk. Jedes Stück ist ein Unikat und wird mit einem signierten Echtheitszertifikat geliefert.",
      "es": "Esta es una obra de arte original. Cada pieza es única y se envía con un certificado de autenticidad firmado.",
      "uk": "Це оригінальний твір мистецтва. Кожен виріб є унікальним і поставляється з підписаним сертифікатом автентичності."
    },
    "createdAt": "2025-11-27T15:19:10.668Z",
    "updatedAt": "2025-11-27T15:19:10.668Z"
  },
  {
    "id": "vJtJFVxbghrBZPt9ZKs2",
    "key": "this_is_my_favorite_holiday_workflow_sketching_snug_pups_celebrating_frenchie_co",
    "source": "This is my favorite holiday workflow—sketching snug pups, celebrating frenchie companions, and wrapping each commission with gift-ready touches so you can surprise pet lovers with meaningful New Year pet gifts, personalized Christmas gifts for pet parents, and keepsake holiday pet portrait gifts that last well beyond the season.",
    "createdAt": "2025-11-27T10:56:26.097Z",
    "updatedAt": "2025-11-27T10:56:26.097Z",
    "translations": {
      "en": "This is my favorite holiday workflow—sketching snug pups, celebrating frenchie companions, and wrapping each commission with gift-ready touches so you can surprise pet lovers with meaningful New Year pet gifts, personalized Christmas gifts for pet parents, and keepsake holiday pet portrait gifts that last well beyond the season.",
      "fr": "C'est mon flux de travail de vacances préféré : dessiner des chiots bien douillets, célébrer les compagnons français et emballer chaque commande avec des touches prêtes à offrir afin que vous puissiez surprendre les amoureux des animaux de compagnie avec des cadeaux d'animaux de compagnie significatifs pour le Nouvel An, des cadeaux de Noël personnalisés pour les parents d'animaux de compagnie et des cadeaux souvenirs de portraits d'animaux de compagnie qui durent bien au-delà de la saison.",
      "de": "Das ist mein Lieblingsworkflow für die Feiertage: Ich skizziere kuschelige Welpen, feiere Frenchie-Begleiter und verpacke jeden Auftrag mit geschenkfertigen Details, damit du Tierliebhaber mit bedeutungsvollen Haustiergeschenken zum Neujahr, personalisierten Weihnachtsgeschenken für Haustiereltern und Erinnerungsgeschenken für Feiertagstierporträts überraschen kannst, die weit über die Saison hinaus Bestand haben.",
      "es": "Este es mi flujo de trabajo favorito para las fiestas: dibujar cachorros acogedores, celebrar a los compañeros franceses y envolver cada encargo con toques listos para regalar para que puedas sorprender a los amantes de las mascotas con significativos obsequios para mascotas de Año Nuevo, obsequios de Navidad personalizados para los dueños de mascotas y obsequios con retratos de mascotas de recuerdo que duran mucho más allá de la temporada.",
      "uk": "Мій улюблений святковий вайб: затишні портрети песиків, трішки магії в деталях і подарункове пакування кожного замовлення ✨\nІдеально, щоб здивувати пет-батьків теплим персоналізованим подарунком на Новий рік чи Різдво — портретом, який збережеться надовго."
    }
  },
  {
    "id": "6focJznIhZl7mFSjjCLw",
    "key": "this_painting_is_all_about_freedom_and_the_energy_of_life_the_dragonfly_s_wings_",
    "source": "This painting is all about freedom and the energy of life. The dragonfly’s wings seem to move right off the canvas, while bold, sweeping strokes splash bright across a dark background. It feels fearless—like catching a glimpse of pure motion and joy. Hang it anywhere you need a spark of courage and a reminder to keep moving forward.",
    "translations": {
      "en": "This painting is all about freedom and the energy of life. The dragonfly’s wings seem to move right off the canvas, while bold, sweeping strokes splash bright across a dark background. It feels fearless—like catching a glimpse of pure motion and joy. Hang it anywhere you need a spark of courage and a reminder to keep moving forward.",
      "fr": "Cette peinture parle de liberté et d’énergie de vie. Les ailes de la libellule semblent bouger directement de la toile, tandis que des traits audacieux et larges éclaboussent un fond sombre. C’est une sensation d’intrépidité, comme si j’avais un aperçu du mouvement et de la joie pure. Accrochez-le partout où vous avez besoin d'une étincelle de courage et d'un rappel pour continuer à avancer.",
      "de": "In diesem Gemälde dreht sich alles um Freiheit und die Energie des Lebens. Die Flügel der Libelle scheinen sich direkt von der Leinwand zu bewegen, während kräftige, schwungvolle Striche hell auf einen dunklen Hintergrund fallen. Es fühlt sich furchtlos an – als würde man einen flüchtigen Blick auf pure Bewegung und Freude erhaschen. Hängen Sie es überall dort auf, wo Sie einen Funken Mut und eine Erinnerung brauchen, um weiter voranzukommen.",
      "es": "Esta pintura tiene que ver con la libertad y la energía de la vida. Las alas de la libélula parecen moverse directamente del lienzo, mientras que trazos audaces y amplios salpican de brillo sobre un fondo oscuro. Se siente sin miedo, como vislumbrar puro movimiento y alegría. Cuélgalo en cualquier lugar donde necesites una chispa de coraje y un recordatorio para seguir avanzando.",
      "uk": "Ця картина про свободу та енергію життя. Здається, що крила бабки рухаються прямо з полотна, а сміливі розмашисті штрихи яскраво розливаються по темному тлу. Відчуваєш себе безстрашним — наче мигцем споглядаєш чистий рух і радість. Повісьте його будь-де, де вам потрібна іскра сміливості та нагадування продовжувати рухатися вперед."
    },
    "createdAt": "2026-01-23T17:00:11.170Z",
    "updatedAt": "2026-01-23T17:00:11.170Z"
  },
  {
    "id": "RuKQD7O1IVHQp9kkElFV",
    "key": "this_painting_was_inspired_by_a_quiet_almost_magical_moment_high_in_the_swiss_mo",
    "source": "This painting was inspired by a quiet, almost magical moment high in the Swiss mountains. I was hiking through rolling green meadows, surrounded by the crisp scent of alpine air and the distant chime of cowbells echoing off the cliffs. Suddenly, I came face to face with this gentle, curious cow — standing calmly, watching me with the kind of stillness only animals seem to master. There was something so honest and grounded in that gaze, something that stayed with me long after the moment passed. I returned to the studio with that memory fresh in my heart and recreated it in this oil painting using expressive, textured strokes with a palette knife. The thick layers of oil paint capture the rugged textures of nature — the soft fur, the rough earth, the depth of the landscape behind her. Every mark is intentional, aiming to hold onto that fleeting connection I felt in the mountains.",
    "translations": {
      "en": "This painting was inspired by a quiet, almost magical moment high in the Swiss mountains. I was hiking through rolling green meadows, surrounded by the crisp scent of alpine air and the distant chime of cowbells echoing off the cliffs. Suddenly, I came face to face with this gentle, curious cow — standing calmly, watching me with the kind of stillness only animals seem to master. There was something so honest and grounded in that gaze, something that stayed with me long after the moment passed. I returned to the studio with that memory fresh in my heart and recreated it in this oil painting using expressive, textured strokes with a palette knife. The thick layers of oil paint capture the rugged textures of nature — the soft fur, the rough earth, the depth of the landscape behind her. Every mark is intentional, aiming to hold onto that fleeting connection I felt in the mountains.",
      "fr": "Cette peinture a été inspirée par un moment calme, presque magique, dans les montagnes suisses. Je faisais une randonnée à travers des prairies verdoyantes, entourée par le parfum vif de l'air alpin et le carillon lointain des cloches qui résonnaient sur les falaises. Soudain, je me suis retrouvé face à face avec cette vache douce et curieuse, debout calmement, m'observant avec le genre d'immobilité que seuls les animaux semblent maîtriser. Il y avait quelque chose de si honnête et si ancré dans ce regard, quelque chose qui est resté en moi longtemps après le moment passé. Je suis retourné au studio avec ce souvenir frais dans mon cœur et je l'ai recréé dans cette peinture à l'huile en utilisant des traits expressifs et texturés avec un couteau à palette. Les épaisses couches de peinture à l’huile capturent les textures accidentées de la nature : la douce fourrure, la terre rugueuse, la profondeur du paysage derrière elle. Chaque marque est intentionnelle, visant à conserver cette connexion éphémère que j'ai ressentie dans les montagnes.",
      "de": "Dieses Gemälde wurde von einem ruhigen, fast magischen Moment hoch in den Schweizer Bergen inspiriert. Ich wanderte durch sanfte grüne Wiesen, umgeben vom frischen Duft der Alpenluft und dem fernen Glockengeläut, das von den Klippen widerhallte. Plötzlich stand ich dieser sanften, neugierigen Kuh gegenüber – sie stand ruhig da und beobachtete mich mit einer Stille, die nur Tiere zu beherrschen scheinen. In diesem Blick lag etwas so Ehrliches und Bodenständiges, etwas, das noch lange nach diesem Moment bei mir blieb. Mit dieser Erinnerung im Herzen kehrte ich ins Atelier zurück und habe sie in diesem Ölgemälde mit ausdrucksstarken, strukturierten Strichen mit einem Spachtel nachgebildet. Die dicken Ölfarbenschichten fangen die rauen Texturen der Natur ein – das weiche Fell, die raue Erde, die Tiefe der Landschaft dahinter. Jede Markierung ist beabsichtigt und soll die flüchtige Verbindung festhalten, die ich in den Bergen gespürt habe.",
      "es": "Esta pintura se inspiró en un momento tranquilo, casi mágico, en lo alto de las montañas suizas. Estaba caminando por praderas verdes y onduladas, rodeado por el fresco aroma del aire alpino y el lejano repique de los cencerros que resonaban en los acantilados. De repente, me encontré cara a cara con esta vaca gentil y curiosa, parada tranquilamente, mirándome con el tipo de quietud que sólo los animales parecen dominar. Había algo tan honesto y arraigado en esa mirada, algo que permaneció conmigo mucho después de que pasó el momento. Regresé al estudio con ese recuerdo fresco en mi corazón y lo recreé en esta pintura al óleo usando trazos expresivos y texturizados con una espátula. Las gruesas capas de pintura al óleo capturan las texturas rugosas de la naturaleza: el pelaje suave, la tierra áspera, la profundidad del paisaje detrás de ella. Cada marca es intencional, con el objetivo de aferrarse a esa conexión fugaz que sentí en la montaña.",
      "uk": "Ця картина була створена під натхненням тихого, майже чарівного моменту високо в швейцарських горах. Я мандрував зеленими лугами, оточений свіжим ароматом альпійського повітря та далеким дзвоном коров’ячих дзвіночків, що відлунювали від скель. Раптом я зіткнувся віч-на-віч з цією лагідною, цікавою коровою — вона спокійно стояла і спостерігала за мною з такою нерухомістю, як, здається, здатні лише тварини. У цьому погляді було щось таке чесне й обґрунтоване, щось таке, що залишалося зі мною ще довго після того, як минув момент. Я повернувся до студії зі свіжим спогадом у своєму серці та відтворив його на цій олійній картині, використовуючи виразні текстуровані штрихи мастихіном. Товсті шари олійної фарби захоплюють грубі текстури природи — м’яке хутро, шорстку землю, глибину пейзажу за нею. Кожна позначка зроблена навмисно з метою зберегти той швидкоплинний зв’язок, який я відчув у горах."
    },
    "createdAt": "2026-01-23T16:55:32.793Z",
    "updatedAt": "2026-01-23T16:55:32.793Z"
  },
  {
    "id": "iEhEEiIN8c9bfOodG95i",
    "key": "this_privacy_policy_describes_how_daria_chizh_art_site_we_us_or_our_collects_use",
    "source": "This Privacy Policy describes how Daria Chizh Art (“Site”, “we”, “us”, or “our”) collects, uses, and discloses your personal information when you visit, use our services, or make a purchase from this Site or otherwise communicate with us (“Services”).",
    "translations": {
      "en": "This Privacy Policy describes how Daria Chizh Art (“Site”, “we”, “us”, or “our”) collects, uses, and discloses your personal information when you visit, use our services, or make a purchase from this Site or otherwise communicate with us (“Services”).",
      "fr": "Cette politique de confidentialité décrit comment Daria Chizh Art (« Site », « nous », « notre » ou « notre ») collecte, utilise et divulgue vos informations personnelles lorsque vous visitez, utilisez nos services ou effectuez un achat sur ce site ou communiquez de toute autre manière avec nous (« Services »).",
      "de": "Diese Datenschutzrichtlinie beschreibt, wie Daria Chizh Art („Website“, „wir“, „uns“ oder „unser“) Ihre persönlichen Daten erhebt, verwendet und offenlegt, wenn Sie diese Website besuchen, unsere Dienste nutzen, einen Kauf auf dieser Website tätigen oder anderweitig mit uns kommunizieren („Dienste“).",
      "es": "Esta Política de Privacidad describe cómo Daria Chizh Art (\"Sitio\", \"nosotros\", \"nos\" o \"nuestro\") recopila, utiliza y divulga su información personal cuando visita, utiliza nuestros servicios o realiza una compra en este Sitio o se comunica de otro modo con nosotros (\"Servicios\").",
      "uk": "Ця Політика конфіденційності описує, як Daria Chizh Art (“Сайт”, “ми”, “нас”, “наш”) збирає, використовує та розкриває вашу персональну інформацію, коли ви відвідуєте сайт, користуєтеся нашими послугами або здійснюєте покупку, а також коли іншим чином взаємодієте з нами (“Послуги”)."
    },
    "createdAt": "2025-12-05T09:20:09.586Z",
    "updatedAt": "2025-12-05T09:20:09.586Z"
  },
  {
    "id": "504egcAgdBx8ClqAm3cs",
    "key": "this_website_is_operated_by_daria_chizh_art_studio_by_visiting_our_site_and_or_p",
    "source": "This website is operated by Daria Chizh Art Studio. By visiting our site and/or purchasing something from us, you agree to be bound by these Terms of Service, including any additional terms and policies referenced here or available by hyperlink. These Terms apply to all users of the site.",
    "translations": {
      "en": "This website is operated by Daria Chizh Art Studio. By visiting our site and/or purchasing something from us, you agree to be bound by these Terms of Service, including any additional terms and policies referenced here or available by hyperlink. These Terms apply to all users of the site.",
      "fr": "Ce site Web est exploité par Daria Chizh Art Studio. En visitant notre site et/ou en achetant quelque chose chez nous, vous acceptez d'être lié par les présentes conditions d'utilisation, y compris les conditions et politiques supplémentaires référencées ici ou disponibles par lien hypertexte. Ces Conditions s'appliquent à tous les utilisateurs du site.",
      "de": "Diese Website wird von Daria Chizh Art Studio betrieben. Indem Sie unsere Website besuchen und/oder etwas von uns kaufen, erklären Sie sich mit diesen Nutzungsbedingungen einverstanden, einschließlich aller zusätzlichen Bedingungen und Richtlinien, auf die hier verwiesen wird oder die über einen Hyperlink verfügbar sind. Diese Bedingungen gelten für alle Benutzer der Website.",
      "es": "Este sitio web es operado por Daria Chizh Art Studio. Al visitar nuestro sitio y/o comprarnos algo, usted acepta estar sujeto a estos Términos de servicio, incluidos los términos y políticas adicionales a los que se hace referencia aquí o que están disponibles mediante hipervínculo. Estos Términos se aplican a todos los usuarios del sitio.",
      "uk": "Цей вебсайт управляється Daria Chizh Art Studio.\nВідвідуючи наш сайт та/або здійснюючи покупку, ви погоджуєтесь дотримуватися цих Умов надання послуг, включно з будь-якими додатковими умовами та політиками, на які тут є посилання або які доступні за гіперпосиланнями. Ці Умови застосовуються до всіх користувачів сайту."
    },
    "createdAt": "2025-12-04T14:38:42.152Z",
    "updatedAt": "2025-12-04T14:38:42.152Z"
  },
  {
    "id": "djZZwP8z9YcaTb1UUzoQ",
    "key": "to_commission_a_portrait_simply_choose_a_canvas_size_and_upload_photos_i_ll_guid",
    "source": "To commission a portrait, simply choose a canvas size and upload photos. I’ll guide you through the process, provide progress updates, and ship worldwide so your pet portrait from photo arrives safely.",
    "translations": {
      "en": "To commission a portrait, simply choose a canvas size and upload photos. I’ll guide you through the process, provide progress updates, and ship worldwide so your pet portrait from photo arrives safely.",
      "fr": "Pour commander un portrait, choisissez simplement une taille de toile et téléchargez des photos. Je vous guiderai tout au long du processus, vous fournirai des mises à jour sur les progrès et expédierai dans le monde entier afin que le portrait de votre animal de compagnie à partir de la photo arrive en toute sécurité.",
      "de": "Um ein Porträt in Auftrag zu geben, wählen Sie einfach eine Leinwandgröße und laden Sie Fotos hoch. Ich führe Sie durch den Prozess, berichte über den Fortschritt und versende weltweit, damit Ihr Haustierporträt vom Foto sicher bei Ihnen ankommt.",
      "es": "Para encargar un retrato, simplemente elige el tamaño del lienzo y sube las fotos. Lo guiaré a través del proceso, le brindaré actualizaciones sobre el progreso y realizaré envíos a todo el mundo para que el retrato de su mascota a partir de la foto llegue sano y salvo.",
      "uk": "Щоб замовити портрет, просто виберіть розмір полотна та завантажте фотографії. Я проведу вас через цей процес, надам оновлену інформацію та відправлю по всьому світу, щоб портрет вашого улюбленця був бездоганним."
    },
    "createdAt": "2025-11-29T14:20:58.930Z",
    "updatedAt": "2025-11-29T14:20:58.930Z"
  },
  {
    "id": "1jpLvzj0SIYIGEWQKs3B",
    "key": "to_get_started",
    "source": "to get started.",
    "translations": {
      "en": "to get started.",
      "fr": "pour commencer.",
      "de": "um loszulegen.",
      "es": "para empezar.",
      "uk": "щоб почати."
    },
    "createdAt": "2025-11-27T12:42:19.997Z",
    "updatedAt": "2025-11-27T12:42:19.997Z"
  },
  {
    "id": "emGoj28bACWtfkUbikNG",
    "key": "to_provide_the_services_we_collect_personal_information_from_various_sources_we_",
    "source": "To provide the Services, we collect personal information from various sources. We use it to communicate with you, provide/improve the Services, comply with legal obligations, enforce our terms, and protect the Services and our users.",
    "translations": {
      "en": "To provide the Services, we collect personal information from various sources. We use it to communicate with you, provide/improve the Services, comply with legal obligations, enforce our terms, and protect the Services and our users.",
      "fr": "Pour fournir les Services, nous collectons des informations personnelles provenant de diverses sources. Nous les utilisons pour communiquer avec vous, fournir/améliorer les Services, nous conformer aux obligations légales, appliquer nos conditions et protéger les Services et nos utilisateurs.",
      "de": "Zur Bereitstellung der Dienste erheben wir personenbezogene Daten aus verschiedenen Quellen. Wir verwenden sie, um mit Ihnen zu kommunizieren, die Dienste bereitzustellen/zu verbessern, gesetzlichen Verpflichtungen nachzukommen, unsere Bedingungen durchzusetzen und die Dienste und unsere Benutzer zu schützen.",
      "es": "Para proporcionar los Servicios, recopilamos información personal de diversas fuentes. Lo utilizamos para comunicarnos con usted, proporcionar/mejorar los Servicios, cumplir con obligaciones legales, hacer cumplir nuestros términos y proteger los Servicios y a nuestros usuarios.",
      "uk": "Щоб надавати Послуги, ми збираємо персональну інформацію з різних джерел. Ми використовуємо її для комунікації з вами, надання та покращення послуг, виконання юридичних зобов’язань, дотримання наших умов і захисту Сервісу та користувачів."
    },
    "createdAt": "2025-12-05T09:22:49.763Z",
    "updatedAt": "2025-12-05T09:22:49.763Z"
  },
  {
    "id": "q8jJX4nfY1Wc79sCFsiy",
    "key": "total",
    "source": "Total",
    "translations": {
      "en": "Total",
      "fr": "Total",
      "de": "Gesamt",
      "es": "Total",
      "uk": "Всього"
    },
    "createdAt": "2025-11-27T14:10:14.145Z",
    "updatedAt": "2025-11-27T14:10:14.145Z"
  },
  {
    "id": "ubnRFYzptet2apykmvhX",
    "key": "tracking_information",
    "source": "Tracking Information",
    "translations": {
      "en": "Tracking Information",
      "fr": "Informations de suivi",
      "de": "Tracking-Informationen",
      "es": "Información de seguimiento",
      "uk": "Відстеження відправлення"
    },
    "createdAt": "2025-11-27T14:43:22.798Z",
    "updatedAt": "2025-11-27T14:43:22.798Z"
  },
  {
    "id": "5ZYGQlgeigebLiAOAg6y",
    "key": "trending",
    "source": "Trending",
    "translations": {
      "en": "Trending",
      "fr": "Tendance",
      "de": "Im Trend",
      "es": "Tendencia",
      "uk": "В тренді"
    },
    "createdAt": "2025-11-27T11:25:08.065Z",
    "updatedAt": "2025-11-27T11:25:08.065Z"
  },
  {
    "id": "wOrlpOXcnQeEXoapPNgi",
    "key": "truly_excited_with_the_portrait_you_made_for_biba_only_positive_feedback_and_hig",
    "createdAt": "2025-12-05T10:44:56.896Z",
    "translations": {
      "en": "Truly excited with the portrait you made for Biba :) Only positive feedback and high recommend.",
      "fr": "Vraiment enthousiasmé par le portrait que vous avez réalisé pour Biba :) Que des commentaires positifs et une haute recommandation.",
      "de": "Ich bin wirklich begeistert von dem Porträt, das Sie für Biba gemacht haben :) Nur positives Feedback und sehr zu empfehlen.",
      "es": "Realmente emocionado con el retrato que hiciste para Biba :) Solo comentarios positivos y alta recomendación.",
      "uk": "Я справді в захваті від портрета, який ви зробили для Біби :) Тільки позитивні відгуки, дуже рекомендую."
    },
    "source": "Truly excited with the portrait you made for Biba :) Only positive feedback and high recommend.",
    "updatedAt": "2025-12-05T15:03:40.875Z"
  },
  {
    "id": "Tq9TKwppMjuL02h9igEK",
    "key": "ukraine_sumy",
    "source": "Ukraine, Sumy",
    "translations": {
      "en": "Ukraine, Sumy",
      "fr": "Ukraine, Soumy",
      "de": "Ukraine, Sumy",
      "es": "Ucrania, Sumy",
      "uk": "Україна, Суми"
    },
    "createdAt": "2025-12-05T15:06:41.547Z",
    "updatedAt": "2025-12-05T15:06:41.547Z"
  },
  {
    "id": "2MEpxZvSUJE0N1DaMzDd",
    "key": "unbreakable_bird",
    "source": "Unbreakable Bird",
    "translations": {
      "en": "Unbreakable Bird",
      "fr": "Oiseau incassable",
      "de": "Unzerbrechlicher Vogel",
      "es": "Pájaro irrompible",
      "uk": "Незламна птаха"
    },
    "createdAt": "2025-12-05T16:57:48.749Z",
    "updatedAt": "2025-12-05T16:57:48.749Z"
  },
  {
    "id": "39BhGdJTlBmnJx2Gdd0E",
    "key": "upload_your_reference_photos",
    "source": "Upload your reference photos",
    "translations": {
      "en": "Upload your reference photos",
      "fr": "Téléchargez vos photos de référence",
      "de": "Laden Sie Ihre Referenzfotos hoch",
      "es": "Sube tus fotos de referencia",
      "uk": "Завантажте фотографії вашого улюбленця"
    },
    "createdAt": "2025-11-27T14:12:50.252Z",
    "updatedAt": "2025-11-27T14:12:50.252Z"
  },
  {
    "id": "yj13nDjmAZ3JvEyADjcg",
    "key": "urgent_shipping_questions_are_prioritized_the_same_day",
    "source": "Urgent shipping questions are prioritized the same day.",
    "translations": {
      "en": "Urgent shipping questions are prioritized the same day.",
      "fr": "Les questions urgentes d’expédition sont prioritaires le jour même.",
      "de": "Dringende Versandfragen werden noch am selben Tag priorisiert.",
      "es": "Las consultas urgentes sobre envíos se priorizan el mismo día.",
      "uk": "Термінові питання щодо доставки розглядаються того ж дня."
    },
    "createdAt": "2025-11-29T13:58:14.031Z",
    "updatedAt": "2025-11-29T13:58:14.031Z"
  },
  {
    "id": "E6U1swCa9U3pZIhRmtfI",
    "key": "usa_canada",
    "source": "USA & Canada:",
    "createdAt": "2025-11-27T14:45:34.018Z",
    "translations": {
      "en": "USA & Canada",
      "fr": "États-Unis et Canada",
      "de": "USA und Kanada",
      "es": "Estados Unidos y Canadá",
      "uk": "США та Канада"
    },
    "updatedAt": "2025-11-27T14:56:10.115Z"
  },
  {
    "id": "wqWFgHRPemwiREHxOZQX",
    "key": "usa_canada_7_14_business_days",
    "source": "USA & Canada: 7-14 business days",
    "translations": {
      "en": "USA & Canada: 7-14 business days",
      "fr": "États-Unis et Canada : 7 à 14 jours ouvrables",
      "de": "USA und Kanada: 7–14 Werktage",
      "es": "EE.UU. y Canadá: 7-14 días hábiles",
      "uk": "США та Канада: 7-14 робочих днів"
    },
    "createdAt": "2025-11-27T14:41:44.313Z",
    "updatedAt": "2025-11-27T14:41:44.313Z"
  },
  {
    "id": "Ut7187l4am5hqIfzJ6ow",
    "key": "user_comments_and_submissions",
    "source": "User Comments and Submissions",
    "translations": {
      "en": "User Comments and Submissions",
      "fr": "Commentaires et soumissions des utilisateurs",
      "de": "Benutzerkommentare und Einsendungen",
      "es": "Comentarios y envíos de usuarios",
      "uk": "Коментарі та матеріали користувачів"
    },
    "createdAt": "2025-12-04T14:52:41.511Z",
    "updatedAt": "2025-12-04T14:52:41.511Z"
  },
  {
    "id": "irhdFbkrvZ4KGMDjRe9d",
    "key": "view_all",
    "source": "View all",
    "translations": {
      "en": "View all",
      "fr": "Voir tout",
      "de": "Alle anzeigen",
      "es": "Ver todo",
      "uk": "Переглянути всі"
    },
    "createdAt": "2025-11-27T11:14:35.532Z",
    "updatedAt": "2025-11-27T11:14:35.532Z"
  },
  {
    "id": "x9wzaAMIY1ap81ODSVYu",
    "key": "view_full_details",
    "source": "View full details",
    "translations": {
      "en": "View full details",
      "fr": "Afficher tous les détails",
      "de": "Vollständige Details anzeigen",
      "es": "Ver todos los detalles",
      "uk": "Переглянути повну інформацію"
    },
    "createdAt": "2025-11-27T15:17:24.677Z",
    "updatedAt": "2025-11-27T15:17:24.677Z"
  },
  {
    "id": "5Oaifuy0ww6eBX9Ka6a7",
    "key": "view_my_artworks",
    "source": "View my artworks",
    "translations": {
      "en": "View my artworks",
      "fr": "Voir mes oeuvres",
      "de": "Sehen Sie sich meine Kunstwerke an",
      "es": "Ver mis obras de arte",
      "uk": "Перегляньте мої твори"
    },
    "createdAt": "2025-11-27T11:12:11.785Z",
    "updatedAt": "2025-11-27T11:12:11.785Z"
  },
  {
    "id": "YpljaOmCxhmtZsyNpff7",
    "key": "visit_the_artworks_page",
    "source": "Visit the Artworks page",
    "translations": {
      "en": "Visit the Artworks page",
      "fr": "Visitez la page des oeuvres",
      "de": "Besuchen Sie die Seite „Kunstwerke“.",
      "es": "Visita la página de Obras de Arte",
      "uk": "Відвідайте сторінку з моїми роботами"
    },
    "createdAt": "2025-11-27T12:41:58.410Z",
    "updatedAt": "2025-11-27T12:41:58.410Z"
  },
  {
    "id": "QmFC8MiEaAUewF7hasHv",
    "key": "visit_the_commission_page",
    "source": "Visit the Commission page",
    "translations": {
      "en": "Visit the Commission page",
      "fr": "Visitez la page de la Commission",
      "de": "Besuchen Sie die Seite der Kommission",
      "es": "Visita la página de la Comisión",
      "uk": "Відвідайте сторінку замовлення"
    },
    "createdAt": "2025-11-27T12:49:37.689Z",
    "updatedAt": "2025-11-27T12:49:37.689Z"
  },
  {
    "id": "mgBkIHhTl6dQq8zaTTw4",
    "key": "we_have_a_30_day_return_policy_which_means_you_have_30_days_after_receiving_your",
    "source": "We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.\n\nTo be eligible, your item must be in the same condition that you received it—unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase.\n\nTo start a return, contact us at chizh.artist@gmail.com. Returns will need to be sent to the following address: [INSERT RETURN ADDRESS].",
    "translations": {
      "en": "We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.\n\nTo be eligible, your item must be in the same condition that you received it—unworn or unused, with tags, and in its original packaging. You’ll also need the receipt or proof of purchase.\n\nTo start a return, contact us at chizh.artist@gmail.com. Returns will need to be sent to the following address: [INSERT RETURN ADDRESS].",
      "fr": "Nous avons une politique de retour de 30 jours, ce qui signifie que vous disposez de 30 jours après réception de votre article pour demander un retour.\n\nPour être éligible, votre article doit être dans le même état dans lequel vous l'avez reçu : non porté ou inutilisé, avec des étiquettes et dans son emballage d'origine. Vous aurez également besoin du reçu ou de la preuve d’achat.\n\nPour commencer un retour, contactez-nous à chizh.artist@gmail.com. Les retours devront être envoyés à l'adresse suivante : [INSÉRER L'ADRESSE DE RETOUR].",
      "de": "Wir haben ein 30-tägiges Rückgaberecht, was bedeutet, dass Sie nach Erhalt Ihres Artikels 30 Tage Zeit haben, um eine Rückgabe zu beantragen.\n\nUm teilnahmeberechtigt zu sein, muss sich Ihr Artikel in demselben Zustand befinden, in dem Sie ihn erhalten haben – ungetragen oder unbenutzt, mit Etiketten und in der Originalverpackung. Sie benötigen außerdem die Quittung oder den Kaufbeleg.\n\nUm eine Rücksendung zu veranlassen, kontaktieren Sie uns unter chizh.artist@gmail.com. Rücksendungen müssen an die folgende Adresse gesendet werden: [RÜCKGABEADRESSE EINFÜGEN].",
      "es": "Tenemos una política de devolución de 30 días, lo que significa que tiene 30 días después de recibir su artículo para solicitar una devolución.\n\nPara ser elegible, su artículo debe estar en las mismas condiciones en que lo recibió: sin usar o sin usar, con etiquetas y en su embalaje original. También necesitará el recibo o comprobante de compra.\n\nPara iniciar una devolución, contáctenos en chizh.artist@gmail.com. Las devoluciones deberán enviarse a la siguiente dirección: [INSERTAR DIRECCIÓN DE DEVOLUCIÓN].",
      "uk": "1. Індивідуальні замовлення\n\nУсі персоналізовані роботи (портрети на замовлення, картини за фото тощо) не підлягають поверненню та відшкодуванню, оскільки створюються спеціально для конкретного клієнта.\nПовернення можливе лише у разі пошкодження під час доставки."
    },
    "createdAt": "2025-12-04T12:31:30.103Z",
    "updatedAt": "2025-12-04T12:31:30.103Z"
  },
  {
    "id": "JUiS6JHWZfJVLJ4eH23G",
    "key": "we_may_automatically_collect_usage_data_device_browser_ip_network_connection_pag",
    "source": "We may automatically collect usage data (device, browser, IP, network connection, pages viewed, and interactions) using cookies, pixels, and similar technologies.",
    "translations": {
      "en": "We may automatically collect usage data (device, browser, IP, network connection, pages viewed, and interactions) using cookies, pixels, and similar technologies.",
      "fr": "Nous pouvons collecter automatiquement des données d'utilisation (appareil, navigateur, IP, connexion réseau, pages consultées et interactions) à l'aide de cookies, de pixels et de technologies similaires.",
      "de": "Wir können mithilfe von Cookies, Pixeln und ähnlichen Technologien automatisch Nutzungsdaten (Gerät, Browser, IP, Netzwerkverbindung, angezeigte Seiten und Interaktionen) erfassen.",
      "es": "Podemos recopilar automáticamente datos de uso (dispositivo, navegador, IP, conexión de red, páginas vistas e interacciones) utilizando cookies, píxeles y tecnologías similares.",
      "uk": "Ми можемо автоматично збирати дані про використання (пристрій, браузер, IP-адреса, підключення до мережі, переглянуті сторінки та взаємодії) за допомогою файлів cookie, пікселів і подібних технологій."
    },
    "createdAt": "2025-12-05T09:31:26.831Z",
    "updatedAt": "2025-12-05T09:31:26.831Z"
  },
  {
    "id": "H6MokXrc3LShI9ZoXVNj",
    "key": "we_may_disclose_personal_information_to_service_providers_payment_shipping_it_an",
    "source": "We may disclose personal information to service providers (payment, shipping, IT, analytics), business and marketing partners, affiliates, at your direction/consent, in business transactions, to comply with law, or to protect our rights/users. We do not use or disclose sensitive personal information without consent or to infer characteristics.",
    "translations": {
      "en": "We may disclose personal information to service providers (payment, shipping, IT, analytics), business and marketing partners, affiliates, at your direction/consent, in business transactions, to comply with law, or to protect our rights/users. We do not use or disclose sensitive personal information without consent or to infer characteristics.",
      "fr": "Nous pouvons divulguer des informations personnelles à des prestataires de services (paiement, expédition, informatique, analyses), à des partenaires commerciaux et marketing, à des sociétés affiliées, selon vos instructions/consentement, dans le cadre de transactions commerciales, pour nous conformer à la loi ou pour protéger nos droits/utilisateurs. Nous n'utilisons ni ne divulguons d'informations personnelles sensibles sans consentement ou pour en déduire des caractéristiques.",
      "de": "Wir können personenbezogene Daten an Dienstleister (Zahlung, Versand, IT, Analyse), Geschäfts- und Marketingpartner, verbundene Unternehmen weitergeben, auf Ihre Anweisung/Einwilligung hin, im Rahmen von Geschäftstransaktionen, zur Einhaltung von Gesetzen oder zum Schutz unserer Rechte/Benutzer. Wir nutzen oder geben sensible personenbezogene Daten nicht ohne Einwilligung oder zum Rückschluss auf Merkmale weiter.",
      "es": "Podemos divulgar información personal a proveedores de servicios (pagos, envíos, TI, análisis), socios comerciales y de marketing, afiliados, bajo su dirección/consentimiento, en transacciones comerciales, para cumplir con la ley o para proteger nuestros derechos/usuarios. No utilizamos ni divulgamos información personal confidencial sin consentimiento o para inferir características.",
      "uk": "Ми можемо розкривати особисту інформацію постачальникам послуг (оплата, доставка, ІТ, аналітика), діловим і маркетинговим партнерам, афілійованим особам за вашою вказівкою/згодою, у межах корпоративних транзакцій, щоб виконати закон або захистити наші права та користувачів. Ми не використовуємо та не розголошуємо конфіденційну особисту інформацію без вашої згоди та не використовуємо її для створення характеристик користувача."
    },
    "createdAt": "2025-12-05T09:41:10.994Z",
    "updatedAt": "2025-12-05T09:41:10.994Z"
  },
  {
    "id": "7Q0F4T7KuH461s0Psf8d",
    "key": "we_may_obtain_information_from_vendors_and_service_providers_e_g_commerce_platfo",
    "source": "We may obtain information from vendors and service providers (e.g., commerce platform, payment processors, hosting/analytics partners). Any data obtained from third parties is handled under this Privacy Policy.",
    "translations": {
      "en": "We may obtain information from vendors and service providers (e.g., commerce platform, payment processors, hosting/analytics partners). Any data obtained from third parties is handled under this Privacy Policy.",
      "fr": "Nous pouvons obtenir des informations auprès de fournisseurs et de prestataires de services (par exemple, plateforme commerciale, processeurs de paiement, partenaires d'hébergement/d'analyse). Toutes les données obtenues auprès de tiers sont traitées dans le cadre de la présente politique de confidentialité.",
      "de": "Wir erhalten möglicherweise Informationen von Anbietern und Dienstleistern (z. B. Handelsplattform, Zahlungsabwicklern, Hosting-/Analysepartnern). Alle von Dritten erhaltenen Daten werden gemäß dieser Datenschutzrichtlinie behandelt.",
      "es": "Podemos obtener información de vendedores y proveedores de servicios (por ejemplo, plataformas comerciales, procesadores de pagos, socios de alojamiento/análisis). Cualquier dato obtenido de terceros se maneja bajo esta Política de Privacidad.",
      "uk": "Ми можемо отримувати інформацію від постачальників і сервісів (платіжні системи, хостинг, аналітичні та маркетингові партнери). Будь-які дані, отримані від третіх сторін, обробляються відповідно до цієї Політики конфіденційності."
    },
    "createdAt": "2025-12-05T09:32:57.418Z",
    "updatedAt": "2025-12-05T09:32:57.418Z"
  },
  {
    "id": "Jq4iREV3Hp8SoQ7ScFq9",
    "key": "we_may_provide_access_to_third_party_tools_or_links_that_we_do_not_control_we_ar",
    "source": "We may provide access to third-party tools or links that we do not control. We are not liable for any third-party materials, websites, or services. Please review third-party policies before engaging in any transaction.",
    "translations": {
      "en": "We may provide access to third-party tools or links that we do not control. We are not liable for any third-party materials, websites, or services. Please review third-party policies before engaging in any transaction.",
      "fr": "Nous pouvons donner accès à des outils ou à des liens tiers que nous ne contrôlons pas. Nous ne sommes pas responsables des documents, sites Web ou services tiers. Veuillez consulter les politiques des tiers avant de vous engager dans toute transaction.",
      "de": "Wir gewähren möglicherweise Zugriff auf Tools oder Links von Drittanbietern, die wir nicht kontrollieren. Wir haften nicht für Materialien, Websites oder Dienste Dritter. Bitte prüfen Sie die Richtlinien Dritter, bevor Sie eine Transaktion durchführen.",
      "es": "Podemos proporcionar acceso a herramientas o enlaces de terceros que no controlamos. No somos responsables de ningún material, sitio web o servicio de terceros. Revise las políticas de terceros antes de realizar cualquier transacción.",
      "uk": "Ми можемо надавати доступ до сторонніх інструментів або посилань, які ми не контролюємо. Ми не несемо відповідальності за будь-які матеріали, вебсайти чи послуги третіх сторін. Будь ласка, ознайомтеся з політиками третіх сторін перед тим, як здійснювати будь-які транзакції."
    },
    "createdAt": "2025-12-04T14:52:18.462Z",
    "updatedAt": "2025-12-04T14:52:18.462Z"
  },
  {
    "id": "7faIvjpCKgGSWUoDHllV",
    "key": "we_may_update_this_privacy_policy_from_time_to_time_we_will_post_the_revised_ver",
    "source": "We may update this Privacy Policy from time to time. We will post the revised version, update the “Last updated” date, and take any steps required by applicable law.",
    "translations": {
      "en": "We may update this Privacy Policy from time to time. We will post the revised version, update the “Last updated” date, and take any steps required by applicable law.",
      "fr": "Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. Nous publierons la version révisée, mettrons à jour la date de « Dernière mise à jour » et prendrons toutes les mesures requises par la loi applicable.",
      "de": "Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wir werden die überarbeitete Version veröffentlichen, das Datum der „letzten Aktualisierung“ aktualisieren und alle nach geltendem Recht erforderlichen Schritte unternehmen.",
      "es": "Podemos actualizar esta Política de Privacidad de vez en cuando. Publicaremos la versión revisada, actualizaremos la fecha de \"Última actualización\" y tomaremos las medidas requeridas por la ley aplicable.",
      "uk": "Час від часу ми можемо оновлювати цю Політику конфіденційності. Ми опублікуємо виправлену версію, оновимо дату «Останнього оновлення» та вживемо всіх заходів, передбачених чинним законодавством."
    },
    "createdAt": "2025-12-05T09:21:15.870Z",
    "updatedAt": "2025-12-05T09:21:15.870Z"
  },
  {
    "id": "MsVStbnsewSfYwnJDLr4",
    "key": "we_may_verify_your_identity_and_accept_authorized_agent_requests_where_allowed_w",
    "source": "We may verify your identity and accept authorized agent requests where allowed. We do not discriminate for exercising these rights.",
    "translations": {
      "en": "We may verify your identity and accept authorized agent requests where allowed. We do not discriminate for exercising these rights.",
      "fr": "Nous pouvons vérifier votre identité et accepter les demandes d'agents autorisés lorsque cela est autorisé. Nous ne faisons aucune discrimination dans l’exercice de ces droits.",
      "de": "Wir können Ihre Identität überprüfen und Anfragen autorisierter Agenten entgegennehmen, sofern dies zulässig ist. Bei der Ausübung dieser Rechte diskriminieren wir nicht.",
      "es": "Podemos verificar su identidad y aceptar solicitudes de agentes autorizados cuando esté permitido. No discriminamos por ejercer estos derechos.",
      "uk": "Ми можемо вимагати підтвердження особи. Ми не дискримінуємо користувачів за реалізацію їхніх прав."
    },
    "createdAt": "2025-12-05T09:49:40.899Z",
    "updatedAt": "2025-12-05T09:49:40.899Z"
  },
  {
    "id": "DlPPKz3wTAtu4x5nhKzc",
    "key": "we_reserve_the_right_to_refuse_any_order_we_may_limit_or_cancel_quantities_purch",
    "source": "We reserve the right to refuse any order. We may limit or cancel quantities purchased per person, household, or order. You agree to provide current, complete, and accurate purchase and account information so we can complete your transactions and contact you as needed.",
    "translations": {
      "en": "We reserve the right to refuse any order. We may limit or cancel quantities purchased per person, household, or order. You agree to provide current, complete, and accurate purchase and account information so we can complete your transactions and contact you as needed.",
      "fr": "Nous nous réservons le droit de refuser toute commande. Nous pouvons limiter ou annuler les quantités achetées par personne, foyer ou commande. Vous acceptez de fournir des informations d'achat et de compte à jour, complètes et exactes afin que nous puissions compléter vos transactions et vous contacter si nécessaire.",
      "de": "Wir behalten uns das Recht vor, jede Bestellung abzulehnen. Wir können die gekauften Mengen pro Person, Haushalt oder Bestellung begrenzen oder stornieren. Sie erklären sich damit einverstanden, aktuelle, vollständige und genaue Kauf- und Kontoinformationen anzugeben, damit wir Ihre Transaktionen abschließen und Sie bei Bedarf kontaktieren können.",
      "es": "Nos reservamos el derecho de rechazar cualquier pedido. Podemos limitar o cancelar las cantidades compradas por persona, hogar o pedido. Usted acepta proporcionar información de cuenta y de compra actual, completa y precisa para que podamos completar sus transacciones y comunicarnos con usted según sea necesario.",
      "uk": "Ми залишаємо за собою право відмовити у будь-якому замовленні.\nМи можемо обмежувати або скасовувати кількість товарів, придбаних однією особою, домогосподарством або замовленням. Ви погоджуєтесь надавати актуальну, повну та точну інформацію для здійснення покупок і створення облікового запису, щоб ми могли завершити вашу транзакцію та за потреби зв’язатися з вами."
    },
    "createdAt": "2025-12-04T14:50:46.581Z",
    "updatedAt": "2025-12-04T14:50:46.581Z"
  },
  {
    "id": "mG5XHldTrQLi2XMVuUp6",
    "key": "we_reserve_the_right_to_refuse_service_to_anyone_for_any_reason_at_any_time_cont",
    "source": "We reserve the right to refuse service to anyone for any reason at any time. Content (excluding payment data) may be transferred unencrypted over various networks. You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service without our written permission.",
    "translations": {
      "en": "We reserve the right to refuse service to anyone for any reason at any time. Content (excluding payment data) may be transferred unencrypted over various networks. You agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service without our written permission.",
      "fr": "Nous nous réservons le droit de refuser le service à quiconque, pour quelque raison que ce soit, à tout moment. Le contenu (à l'exclusion des données de paiement) peut être transféré en clair sur différents réseaux. Vous acceptez de ne pas reproduire, dupliquer, copier, vendre, revendre ou exploiter toute partie du Service sans notre autorisation écrite.",
      "de": "Wir behalten uns das Recht vor, jederzeit und aus beliebigen Gründen den Service zu verweigern. Inhalte (ausgenommen Zahlungsdaten) können unverschlüsselt über verschiedene Netzwerke übertragen werden. Sie erklären sich damit einverstanden, ohne unsere schriftliche Genehmigung keinen Teil des Dienstes zu reproduzieren, zu duplizieren, zu kopieren, zu verkaufen, weiterzuverkaufen oder zu verwerten.",
      "es": "Nos reservamos el derecho de negar el servicio a cualquier persona por cualquier motivo y en cualquier momento. El contenido (excluidos los datos de pago) puede transferirse sin cifrar a través de varias redes. Acepta no reproducir, duplicar, copiar, vender, revender ni explotar ninguna parte del Servicio sin nuestro permiso por escrito.",
      "uk": "Ми залишаємо за собою право відмовити в обслуговуванні будь-кому з будь-якої причини в будь-який час. Вміст (за винятком платіжних даних) може передаватися в незашифрованому вигляді через різні мережі. Ви погоджуєтеся не відтворювати, дублювати, копіювати, продавати, перепродувати або використовувати будь-яку частину Сервісу без нашого письмового дозволу."
    },
    "createdAt": "2025-12-04T14:45:42.894Z",
    "updatedAt": "2025-12-04T14:45:42.894Z"
  },
  {
    "id": "nRJgJL57D9L7zaEguAAA",
    "key": "we_use_cookies_to_power_and_improve_the_site_remember_preferences_and_run_analyt",
    "source": "We use Cookies to power and improve the Site, remember preferences, and run analytics. Third parties may use Cookies to tailor services, products, and advertising. Most browsers accept Cookies by default; you can block or remove them, but this may affect functionality. We recognize the Global Privacy Control (GPC) signal to honor opt-out preferences for sharing/targeted advertising where applicable.",
    "translations": {
      "en": "We use Cookies to power and improve the Site, remember preferences, and run analytics. Third parties may use Cookies to tailor services, products, and advertising. Most browsers accept Cookies by default; you can block or remove them, but this may affect functionality. We recognize the Global Privacy Control (GPC) signal to honor opt-out preferences for sharing/targeted advertising where applicable.",
      "fr": "Nous utilisons des cookies pour alimenter et améliorer le site, mémoriser les préférences et exécuter des analyses. Des tiers peuvent utiliser des cookies pour personnaliser les services, les produits et la publicité. La plupart des navigateurs acceptent les cookies par défaut ; vous pouvez les bloquer ou les supprimer, mais cela peut affecter la fonctionnalité. Nous reconnaissons le signal Global Privacy Control (GPC) pour honorer les préférences de désinscription pour le partage/la publicité ciblée, le cas échéant.",
      "de": "Wir verwenden Cookies, um die Website zu betreiben und zu verbessern, Präferenzen zu speichern und Analysen durchzuführen. Dritte können Cookies verwenden, um Dienstleistungen, Produkte und Werbung anzupassen. Die meisten Browser akzeptieren Cookies standardmäßig; Sie können sie blockieren oder entfernen, dies kann jedoch die Funktionalität beeinträchtigen. Wir erkennen das Global Privacy Control (GPC)-Signal an, um gegebenenfalls Opt-out-Einstellungen für das Teilen/gezielte Werbung zu berücksichtigen.",
      "es": "Utilizamos cookies para potenciar y mejorar el sitio, recordar preferencias y ejecutar análisis. Los terceros pueden utilizar cookies para personalizar servicios, productos y publicidad. La mayoría de los navegadores aceptan Cookies por defecto; puedes bloquearlos o eliminarlos, pero esto puede afectar la funcionalidad. Reconocemos la señal del Control de Privacidad Global (GPC) para respetar las preferencias de exclusión voluntaria para compartir/publicidad dirigida cuando corresponda.",
      "uk": "Ми використовуємо файли cookie для роботи та вдосконалення Сайту, запам’ятовування налаштувань і проведення аналітики. Треті сторони можуть використовувати файли cookie для адаптації послуг, продуктів і реклами. Більшість браузерів приймають файли cookie за замовчуванням; ви можете заблокувати або видалити їх, але це може вплинути на функціональність. Ми підтримуємо сигнал Global Privacy Control (GPC) для відмови від цільової реклами там, де це вимагається законом."
    },
    "createdAt": "2025-12-05T09:37:30.278Z",
    "updatedAt": "2025-12-05T09:37:30.278Z"
  },
  {
    "id": "WWTLWgIEoHd3vWjrGLX9",
    "key": "we_use_reasonable_safeguards_but_cannot_guarantee_perfect_security_we_retain_dat",
    "source": "We use reasonable safeguards but cannot guarantee perfect security. We retain data as long as needed to provide the Services, meet legal obligations, resolve disputes, or enforce agreements.",
    "translations": {
      "en": "We use reasonable safeguards but cannot guarantee perfect security. We retain data as long as needed to provide the Services, meet legal obligations, resolve disputes, or enforce agreements.",
      "fr": "Nous utilisons des mesures de protection raisonnables mais ne pouvons garantir une sécurité parfaite. Nous conservons les données aussi longtemps que nécessaire pour fournir les Services, respecter les obligations légales, résoudre les litiges ou faire respecter les accords.",
      "de": "Wir nutzen angemessene Sicherheitsvorkehrungen, können jedoch keine vollkommene Sicherheit garantieren. Wir bewahren Daten so lange auf, wie es für die Bereitstellung der Dienste, die Erfüllung gesetzlicher Verpflichtungen, die Beilegung von Streitigkeiten oder die Durchsetzung von Vereinbarungen erforderlich ist.",
      "es": "Utilizamos medidas de seguridad razonables, pero no podemos garantizar una seguridad perfecta. Conservamos datos durante el tiempo necesario para proporcionar los Servicios, cumplir obligaciones legales, resolver disputas o hacer cumplir acuerdos.",
      "uk": "Ми використовуємо розумні заходи безпеки, але не можемо гарантувати ідеальну безпеку. Ми зберігаємо дані стільки, скільки потрібно для надання Послуг, виконання юридичних зобов’язань, вирішення суперечок або забезпечення виконання угод."
    },
    "createdAt": "2025-12-05T09:45:45.132Z",
    "updatedAt": "2025-12-05T09:45:45.132Z"
  },
  {
    "id": "Y3MHjHdd2QJ0dx5ybiZ8",
    "key": "we_will_offer_either",
    "source": "We will offer either:",
    "translations": {
      "en": "We will offer either:",
      "fr": "Nous vous proposerons soit :",
      "de": "Wir bieten entweder:",
      "es": "Le ofreceremos:",
      "uk": "Ми запропонуємо:"
    },
    "createdAt": "2025-12-04T13:04:25.243Z",
    "updatedAt": "2025-12-04T13:04:25.243Z"
  },
  {
    "id": "l8HCQZbofD2AXerqPPoz",
    "key": "weekday_availability_10_00_18_00_utc_2",
    "source": "— weekday availability 10:00–18:00 (UTC+2).",
    "translations": {
      "en": "— weekday availability 10:00–18:00 (UTC+2).",
      "fr": "— disponibilité en semaine de 10h00 à 18h00 (UTC+2).",
      "de": "— Verfügbarkeit an Wochentagen 10:00–18:00 (UTC+2).",
      "es": "— disponibilidad entre semana de 10:00 a 18:00 (UTC+2).",
      "uk": "— доступність у будні дні 10:00–18:00 (UTC+2)."
    },
    "createdAt": "2025-11-29T14:00:38.305Z",
    "updatedAt": "2025-11-29T14:00:38.305Z"
  },
  {
    "id": "9qekdHQicAvj06TF9Yaf",
    "key": "what_personal_information_we_collect",
    "source": "What personal information we collect",
    "translations": {
      "en": "What personal information we collect",
      "fr": "Quelles informations personnelles nous collectons",
      "de": "Welche persönlichen Daten wir sammeln",
      "es": "Qué información personal recopilamos",
      "uk": "Яку персональну інформацію ми збираємо"
    },
    "createdAt": "2025-12-05T09:23:15.638Z",
    "updatedAt": "2025-12-05T09:23:15.638Z"
  },
  {
    "id": "rRekmfzr8xBDMywfcCIt",
    "key": "what_pet_owners_say_about_their_portraits",
    "source": "What Pet Owners Say About Their Portraits",
    "createdAt": "2025-12-05T10:25:01.624Z",
    "translations": {
      "en": "What Pet Owners Say",
      "fr": "Ce que disent les propriétaires d'animaux",
      "de": "Was Haustierbesitzer sagen",
      "es": "Lo que dicen los dueños de mascotas",
      "uk": "Що кажуть клієнти"
    },
    "updatedAt": "2025-12-05T15:21:52.422Z"
  },
  {
    "id": "jVZkZx54eopEwx4v2nZB",
    "key": "what_to_include_in_your_message",
    "source": "What to include in your message",
    "translations": {
      "en": "What to include in your message",
      "fr": "Que faut-il inclure dans votre message",
      "de": "Was Sie in Ihre Nachricht aufnehmen sollten",
      "es": "Qué incluir en tu mensaje",
      "uk": "Що включити у своє повідомлення"
    },
    "createdAt": "2025-11-29T14:12:42.614Z",
    "updatedAt": "2025-11-29T14:12:42.614Z"
  },
  {
    "id": "msOQHWzP68Pvdae1Mx1u",
    "key": "when_the_midday_sun_pours_through_a_sheer_curtain_time_in_the_room_seems_to_slow",
    "source": "When the midday sun pours through a sheer curtain, time in the room seems to slow. A ginger cat—the self-appointed lord of the windowsill—sprawls in unrestrained bliss, savoring every drop of warmth. Here, the contrast between temptation and nonchalance speaks without words: happiness is dozing beside a dream and feeling no rush to claim it. The scene hums with an inner purr of comfort, the scent of summer drifting through the window, and the quiet assurance that true pleasure lives in the simplest things—those that warm the soul, not just the stomach.",
    "translations": {
      "en": "When the midday sun pours through a sheer curtain, time in the room seems to slow. A ginger cat—the self-appointed lord of the windowsill—sprawls in unrestrained bliss, savoring every drop of warmth. Here, the contrast between temptation and nonchalance speaks without words: happiness is dozing beside a dream and feeling no rush to claim it. The scene hums with an inner purr of comfort, the scent of summer drifting through the window, and the quiet assurance that true pleasure lives in the simplest things—those that warm the soul, not just the stomach.",
      "fr": "Lorsque le soleil de midi traverse un voilage, le temps dans la pièce semble ralentir. Un chat roux, le seigneur autoproclamé du rebord de la fenêtre, s'étale dans un bonheur effréné, savourant chaque goutte de chaleur. Ici, le contraste entre tentation et nonchalance s'exprime sans mots : le bonheur c'est dormir à côté d'un rêve et ne pas se sentir pressé de le revendiquer. La scène bourdonne d’un ronronnement intérieur de réconfort, du parfum de l’été qui s’échappe par la fenêtre et de l’assurance tranquille que le vrai plaisir réside dans les choses les plus simples, celles qui réchauffent l’âme, pas seulement l’estomac.",
      "de": "Wenn die Mittagssonne durch einen durchsichtigen Vorhang scheint, scheint die Zeit im Raum zu verlangsamen. Eine rotbraune Katze – der selbsternannte Herr der Fensterbank – räkelt sich in hemmungsloser Glückseligkeit und genießt jeden Tropfen Wärme. Hier spricht der Kontrast zwischen Versuchung und Lässigkeit ohne Worte: Glück bedeutet, neben einem Traum zu dösen und keine Eile zu verspüren, ihn in Anspruch zu nehmen. Die Szene summt mit einem inneren Schnurren der Behaglichkeit, dem Duft des Sommers, der durch das Fenster weht, und der stillen Gewissheit, dass wahres Vergnügen in den einfachsten Dingen steckt – denen, die die Seele wärmen, nicht nur den Magen.",
      "es": "Cuando el sol del mediodía se cuela a través de una cortina transparente, el tiempo en la habitación parece ralentizarse. Un gato pelirrojo, el autoproclamado señor del alféizar de la ventana, se tumba en una felicidad desenfrenada, saboreando cada gota de calidez. Aquí, el contraste entre tentación y despreocupación habla sin palabras: la felicidad es dormitar junto a un sueño y no sentir prisa por reclamarlo. La escena vibra con un ronroneo interior de comodidad, el aroma del verano flotando a través de la ventana y la tranquila seguridad de que el verdadero placer vive en las cosas más simples, aquellas que calientan el alma, no solo el estómago.",
      "uk": "Коли полуденне сонце пробивається крізь прозору завісу, здається, що час у кімнаті сповільнюється. Рудий кіт — самозваний володар підвіконня — розвалюється в нестримному блаженстві, смакуючи кожну краплю тепла. Тут контраст між спокусою та безтурботністю говорить без слів: щастя дрімає біля мрії і не поспішає її вимагати. Сцена гуде від внутрішнього муркочання затишку, аромату літа, що проникає крізь вікно, і тихої впевненості, що справжнє задоволення живе в найпростіших речах — тих, які зігрівають душу, а не лише шлунок."
    },
    "createdAt": "2026-01-23T17:02:10.746Z",
    "updatedAt": "2026-01-23T17:02:10.746Z"
  },
  {
    "id": "ZwbHm2ACrdpWjEv2gEVV",
    "key": "where_the_heart_rests",
    "source": "WHERE THE HEART RESTS",
    "translations": {
      "en": "WHERE THE HEART RESTS",
      "fr": "OÙ REPOSE LE CŒUR",
      "de": "WO DAS HERZ RUHT",
      "es": "DONDE DESCANSA EL CORAZÓN",
      "uk": "ДЕ СЕРЦЕ ВІДПОЧИВАЄ"
    },
    "createdAt": "2025-11-27T11:17:20.417Z",
    "updatedAt": "2025-11-27T11:17:20.417Z"
  },
  {
    "id": "VkFZLmVnb5lX8LLtxRA5",
    "key": "where_the_silence_begins",
    "source": "Where the Silence Begins",
    "translations": {
      "en": "Where the Silence Begins",
      "fr": "Là où commence le silence",
      "de": "Wo die Stille beginnt",
      "es": "Donde comienza el silencio",
      "uk": "Де починається тиша"
    },
    "createdAt": "2025-11-27T11:15:33.766Z",
    "updatedAt": "2025-11-27T11:15:33.766Z"
  },
  {
    "id": "13I2NPNUJpQ6AL1iDtcz",
    "key": "whether_you_re_commissioning_your_first_portrait_or_tracking_a_gift_on_the_way_a",
    "source": "Whether you’re commissioning your first portrait or tracking a gift on the way across the world, you will always talk to me directly—no bots, just genuine care from a working artist. I’m grateful for your trust and excited to create something memorable together.",
    "translations": {
      "en": "Whether you’re commissioning your first portrait or tracking a gift on the way across the world, you will always talk to me directly—no bots, just genuine care from a working artist. I’m grateful for your trust and excited to create something memorable together.",
      "fr": "Que vous commandiez votre premier portrait ou que vous suiviez un cadeau lors de votre voyage à travers le monde, vous me parlerez toujours directement : pas de robots, juste un véritable soin d'un artiste en activité. Je suis reconnaissant pour votre confiance et ravi de créer quelque chose de mémorable ensemble.",
      "de": "Egal, ob Sie Ihr erstes Porträt in Auftrag geben oder ein Geschenk auf dem Weg um die Welt verfolgen, Sie werden immer direkt mit mir sprechen – keine Bots, nur die echte Betreuung durch einen arbeitenden Künstler. Ich bin dankbar für Ihr Vertrauen und freue mich darauf, gemeinsam etwas Unvergessliches zu schaffen.",
      "es": "Ya sea que estés encargando tu primer retrato o siguiendo un regalo en su camino por el mundo, siempre hablarás conmigo directamente, sin robots, solo atención genuina de un artista en activo. Estoy agradecido por su confianza y emocionado de crear algo memorable juntos.",
      "uk": "Незалежно від того, чи замовляєте ви свій перший портрет, чи відстежуєте подарунок у дорозі по всьому світу, ви можете завжди зв’язатись зі мною напряму — без ботів, лише щира турбота. Я вдячна за вашу довіру та рада створити щось незабутнє разом."
    },
    "createdAt": "2025-11-29T14:16:42.739Z",
    "updatedAt": "2025-11-29T14:16:42.739Z"
  },
  {
    "id": "Jb2Z6y3FkFwKA4LxWGwc",
    "key": "whispers_of_the_meadow",
    "source": "Whispers of the Meadow",
    "translations": {
      "en": "Whispers of the Meadow",
      "fr": "Murmures du pré",
      "de": "Flüstern der Wiese",
      "es": "Susurros de la pradera",
      "uk": "Шепіт лугу"
    },
    "createdAt": "2025-11-27T11:26:04.498Z",
    "updatedAt": "2025-11-27T11:26:04.498Z"
  },
  {
    "id": "0gTdjA1DcAHQzgsThMgW",
    "key": "why_pet_owners_choose_chizhart",
    "source": "Why pet owners choose ChizhArt",
    "createdAt": "2026-05-20T11:20:59.201Z",
    "translations": {
      "en": "Why pet owners choose ChizhArt",
      "fr": "Pourquoi les familles qui aiment leurs animaux choisissent ChizhArt",
      "de": "Warum Tierliebhaber ChizhArt wählen",
      "es": "Por qué los amantes de las mascotas eligen ChizhArt",
      "uk": "Чому власники домашніх улюбленців обирають ChizhArt"
    },
    "updatedAt": "2026-05-20T11:49:47.099Z"
  },
  {
    "id": "gITYuvrkyyow5ebqIKLx",
    "key": "with_your_consent_we_may_sell_or_share_personal_information_as_defined_by_applic",
    "source": "With your consent we may “sell” or “share” personal information (as defined by applicable law) for advertising/marketing purposes (e.g., identifiers, commercial info, usage data) with business/marketing partners.",
    "translations": {
      "en": "With your consent we may “sell” or “share” personal information (as defined by applicable law) for advertising/marketing purposes (e.g., identifiers, commercial info, usage data) with business/marketing partners.",
      "fr": "Avec votre consentement, nous pouvons « vendre » ou « partager » des informations personnelles (telles que définies par la loi applicable) à des fins de publicité/marketing (par exemple, identifiants, informations commerciales, données d'utilisation) avec des partenaires commerciaux/marketing.",
      "de": "Mit Ihrer Einwilligung können wir personenbezogene Daten (wie im geltenden Recht definiert) für Werbe-/Marketingzwecke (z. B. Kennungen, kommerzielle Informationen, Nutzungsdaten) an Geschäfts-/Marketingpartner „verkaufen“ oder „weitergeben“.",
      "es": "Con su consentimiento, podemos \"vender\" o \"compartir\" información personal (según lo define la ley aplicable) con fines publicitarios/de marketing (por ejemplo, identificadores, información comercial, datos de uso) con socios comerciales/de marketing.",
      "uk": "За вашою згодою ми можемо «продавати» або «ділитися» певними даними (як визначено чинним законодавством) для рекламних/маркетингових цілей (наприклад, ідентифікатори, комерційна інформація, дані про використання) діловим/маркетинговим партнерам."
    },
    "createdAt": "2025-12-05T09:42:08.041Z",
    "updatedAt": "2025-12-05T09:42:08.041Z"
  },
  {
    "id": "WytG9ebXKc5vAR7MSfiF",
    "key": "woow_amazing_we_love_it_even_prettier_in_real_life_youre_so_talanted",
    "createdAt": "2025-12-05T10:27:21.248Z",
    "translations": {
      "en": "Woow!! Amazing! We love it, even prettier in real life 😍 You're so talanted!",
      "fr": "Woow !! Incroyable ! On adore, encore plus joli en vrai 😍 Tu es tellement talentueuse !",
      "de": "Woow!! Unglaublich! Wir lieben es, im echten Leben sogar noch hübscher 😍 Du bist so talentiert!",
      "es": "¡¡Guau!! ¡Increíble! Nos encanta, incluso más bonito en la vida real 😍 ¡Tienes tanto talento!",
      "uk": "Вау! Чудово! Нам дуже подобається, навіть гарніше ніж в реальному житті 😍 Ти така талановита!"
    },
    "source": "Woow!! Amazing! We love it, even prettier in real life 😍 You're so talanted!",
    "updatedAt": "2025-12-05T15:03:04.648Z"
  },
  {
    "id": "GyE8KFbJB3fmBBISMqbc",
    "key": "worldwide_shipping",
    "source": "Worldwide shipping",
    "translations": {
      "en": "Worldwide shipping",
      "fr": "Expédition mondiale",
      "de": "Weltweiter Versand",
      "es": "Envío mundial",
      "uk": "Доставка по всьому світу"
    },
    "createdAt": "2025-12-05T10:48:14.240Z",
    "updatedAt": "2025-12-05T10:48:14.240Z"
  },
  {
    "id": "d4wVLNkfoz5pnGdJDBgr",
    "key": "year",
    "source": "Year",
    "translations": {
      "en": "Year",
      "fr": "Année",
      "de": "Jahr",
      "es": "Año",
      "uk": "рік"
    },
    "createdAt": "2025-11-27T15:18:46.764Z",
    "updatedAt": "2025-11-27T15:18:46.764Z"
  },
  {
    "id": "yYCR2rnZjYItelMclK1i",
    "key": "you_can_expect_a_reply_within",
    "source": "You can expect a reply within",
    "translations": {
      "en": "You can expect a reply within",
      "fr": "Vous pouvez vous attendre à une réponse dans",
      "de": "Sie können mit einer Antwort innerhalb von 24 Stunden rechnen",
      "es": "Puede esperar una respuesta dentro de",
      "uk": "Ви можете очікувати відповідь протягом"
    },
    "createdAt": "2025-11-29T13:43:38.311Z",
    "updatedAt": "2025-11-29T13:56:03.809Z"
  },
  {
    "id": "4jfUxzOzXcsEZLqIRWEI",
    "key": "you_may_also_like",
    "source": "You May Also Like",
    "translations": {
      "en": "You May Also Like",
      "fr": "Vous aimerez peut-être aussi",
      "de": "Vielleicht gefällt Ihnen auch",
      "es": "También te puede gustar",
      "uk": "Вам також може сподобатися"
    },
    "createdAt": "2025-11-27T15:17:32.952Z",
    "updatedAt": "2025-11-27T15:17:32.952Z"
  },
  {
    "id": "21FEBu1xb735K7sSSCq3",
    "key": "you_may_not_use_the_site_for_unlawful_purposes_to_violate_intellectual_property_",
    "source": "You may not use the site for unlawful purposes, to violate intellectual property rights, to harass, abuse, or discriminate, to submit false information, to upload malicious code, to spam or scrape, or to interfere with site security.",
    "translations": {
      "en": "You may not use the site for unlawful purposes, to violate intellectual property rights, to harass, abuse, or discriminate, to submit false information, to upload malicious code, to spam or scrape, or to interfere with site security.",
      "fr": "Vous ne pouvez pas utiliser le site à des fins illégales, pour violer les droits de propriété intellectuelle, pour harceler, abuser ou discriminer, pour soumettre de fausses informations, pour télécharger du code malveillant, pour spammer ou gratter, ou pour interférer avec la sécurité du site.",
      "de": "Sie dürfen die Website nicht für rechtswidrige Zwecke, zur Verletzung geistiger Eigentumsrechte, zur Belästigung, zum Missbrauch oder zur Diskriminierung, zur Übermittlung falscher Informationen, zum Hochladen von bösartigem Code, zum Spam oder Scraping oder zur Beeinträchtigung der Website-Sicherheit nutzen.",
      "es": "No puede utilizar el sitio con fines ilegales, para violar derechos de propiedad intelectual, para acosar, abusar o discriminar, para enviar información falsa, para cargar códigos maliciosos, para enviar spam o scrape, o para interferir con la seguridad del sitio.",
      "uk": "Ви не маєте права використовувати сайт у незаконних цілях, для порушення прав інтелектуальної власності, для переслідування, зловживань або дискримінації, для подання неправдивої інформації, для завантаження зловмисного коду, для розсилання спаму чи збору даних або для втручання в безпеку сайту."
    },
    "createdAt": "2025-12-04T14:55:21.339Z",
    "updatedAt": "2025-12-04T14:55:21.339Z"
  },
  {
    "id": "q9vAWEcYS4TYYpgGdEYe",
    "key": "you_send_your_favorite_photo_i_paint_your_pet_not_a_stock_pose_not_a_preset_styl",
    "source": "You send your favorite photo, I paint your pet — not a stock pose, not a preset style. Whether it’s a golden retriever mid-run or a tabby curled on a windowsill, your pet portrait is composed around the personality that makes your animal yours.",
    "createdAt": "2026-05-20T11:23:47.294Z",
    "translations": {
      "en": "You send your favorite photo, I paint your pet — not a stock pose, not a preset style. Whether it’s a golden retriever mid-run or a tabby curled on a windowsill, your pet portrait is composed around the personality that makes your animal yours.",
      "fr": "Vous m'envoyez votre photo préférée, je peins votre animal — sans pose convenue, sans style imposé. Qu'il s'agisse d'un golden retriever lancé dans sa course ou d'un chat tigré lové sur un rebord de fenêtre, le portrait est composé autour de la personnalité qui rend votre compagnon unique.",
      "de": "Sie schicken Ihr Lieblingsfoto, ich male Ihr Haustier – keine Standardpose, kein vorgefertigter Stil. Ob ein Golden Retriever im vollen Lauf oder eine getigerte Katze, die sich auf der Fensterbank zusammenrollt: Ihr Haustierporträt wird um genau die Persönlichkeit herum komponiert, die Ihr Tier so unverwechselbar macht.",
      "es": "Tú envías tu foto favorita y yo pinto a tu mascota — sin poses de catálogo ni estilos preestablecidos. Ya sea un golden retriever en plena carrera o un gato atigrado acurrucado en el alféizar, el retrato se construye alrededor de la personalidad que hace especial a tu animal.",
      "uk": "Ви надсилаєте улюблене фото, я малюю вашого вихованця — без стандартних поз, без готових стилів. Золотистий ретривер у стрибку чи смугастий кіт, що дрімає на підвіконні — портрет будується навколо тієї самої особистості, яка робить вашу тварину особливою."
    },
    "updatedAt": "2026-05-20T11:49:48.492Z"
  },
  {
    "id": "lSqtS0nuslmlUmTRWUxY",
    "key": "youll_see_it_before_it_ships",
    "source": "You'll See It Before It Ships",
    "createdAt": "2026-05-20T11:26:10.511Z",
    "translations": {
      "en": "You'll See It Before It Ships",
      "fr": "Vous le découvrirez avant qu'il ne parte",
      "de": "Ihr Blick zuerst – bevor das Gemälde das Atelier verlässt",
      "es": "Lo verás antes de que salga del estudio",
      "uk": "Ви побачите портрет до відправки"
    },
    "updatedAt": "2026-05-20T11:49:50.621Z"
  },
  {
    "id": "oRJMtRgV7xE09ksVLRd0",
    "key": "your_cart",
    "source": "YOUR CART",
    "translations": {
      "en": "YOUR CART",
      "fr": "VOTRE PANIER",
      "de": "IHR WARENKORB",
      "es": "TU CARRITO",
      "uk": "ВАШ КОШИК"
    },
    "createdAt": "2025-11-27T14:08:07.461Z",
    "updatedAt": "2025-11-27T14:08:07.461Z"
  },
  {
    "id": "KSNuo05yCt4woseisSXf",
    "key": "your_ideal_resolution_or_deadline",
    "source": "Your ideal resolution or deadline.",
    "translations": {
      "en": "Your ideal resolution or deadline.",
      "fr": "Votre résolution ou date limite idéale.",
      "de": "Ihr idealer Vorsatz oder Termin.",
      "es": "Tu resolución o fecha límite ideal.",
      "uk": "Ваші ідеї або крайній термін."
    },
    "createdAt": "2025-11-29T14:15:00.107Z",
    "updatedAt": "2025-11-29T14:15:00.107Z"
  },
  {
    "id": "okQ7xcvTvF2Xxte8ePzk",
    "key": "your_information_may_be_transferred_stored_and_processed_outside_your_country_wh",
    "source": "Your information may be transferred, stored, and processed outside your country. When transferring out of Europe/UK, we rely on lawful mechanisms such as Standard Contractual Clauses, unless the destination has been deemed adequate.",
    "translations": {
      "en": "Your information may be transferred, stored, and processed outside your country. When transferring out of Europe/UK, we rely on lawful mechanisms such as Standard Contractual Clauses, unless the destination has been deemed adequate.",
      "fr": "Vos informations peuvent être transférées, stockées et traitées en dehors de votre pays. Lors d'un transfert hors d'Europe/Royaume-Uni, nous nous appuyons sur des mécanismes légaux tels que les clauses contractuelles types, à moins que la destination n'ait été jugée adéquate.",
      "de": "Ihre Daten können außerhalb Ihres Landes übertragen, gespeichert und verarbeitet werden. Bei Überweisungen aus Europa/Großbritannien verlassen wir uns auf rechtmäßige Mechanismen wie Standardvertragsklauseln, es sei denn, der Bestimmungsort wurde als angemessen erachtet.",
      "es": "Su información puede transferirse, almacenarse y procesarse fuera de su país. Al realizar transferencias fuera de Europa/Reino Unido, nos basamos en mecanismos legales, como las cláusulas contractuales estándar, a menos que el destino se haya considerado adecuado.",
      "uk": "Ваша інформація може передаватися та оброблятися за межами вашої країни проживання. Під час передачі даних з Європи/Великої Британії ми використовуємо правові механізми, такі як Standard Contractual Clauses, якщо країна не визнана такою, що забезпечує належний рівень захисту."
    },
    "createdAt": "2025-12-05T09:50:52.564Z",
    "updatedAt": "2025-12-05T09:50:52.564Z"
  },
  {
    "id": "0IwypvM5uWmOqM6SHlVV",
    "key": "your_rights",
    "source": "Your rights",
    "translations": {
      "en": "Your rights",
      "fr": "Vos droits",
      "de": "Ihre Rechte",
      "es": "Tus derechos",
      "uk": "Ваші права"
    },
    "createdAt": "2025-12-05T09:45:59.062Z",
    "updatedAt": "2025-12-05T09:45:59.062Z"
  },
  {
    "id": "kRMBCDOlj4XNqaydnwvo",
    "key": "your_submission_of_personal_information_is_governed_by_our_privacy_policy",
    "source": "Your submission of personal information is governed by our Privacy Policy.",
    "translations": {
      "en": "Your submission of personal information is governed by our Privacy Policy.",
      "fr": "La soumission de vos informations personnelles est régie par notre politique de confidentialité.",
      "de": "Die Übermittlung Ihrer persönlichen Daten unterliegt unserer Datenschutzrichtlinie.",
      "es": "Su envío de información personal se rige por nuestra Política de Privacidad.",
      "uk": "Надана вами особиста інформація регулюється нашою Політикою конфіденційності."
    },
    "createdAt": "2025-12-04T14:54:13.062Z",
    "updatedAt": "2025-12-04T14:54:13.062Z"
  }
]
